import React from 'react';
import { useState, useEffect } from 'react';

import { 
  ActivityIndicator, 
  Image, 
  ImageBackground,
  Text, 
  TextInput, 
  TouchableOpacity, 
  View, 
  ScrollView,
} from 'react-native'; // react-native-web の場合は iOS で error が発生

import Icon from 'react-native-vector-icons/FontAwesome';

import Checkbox from 'expo-checkbox';

import {
  DataTable
} from 'react-native-paper';

import {loadStripe} from '@stripe/stripe-js';
import {
  CardElement,
  injectStripe, 
  CardNumberElement, 
  CardExpiryElement, 
  CardCvcElement,
  Elements,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';

import e from './e';
import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';

import myWB from './myWB_20211212';

//import { NativeModules } from 'react-native';

export default class ce { // common element 

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////
  static c(po_type, pd_pmrs={}, pa_clds=null) {
    return React.createElement(po_type, pd_pmrs, pa_clds);
  };

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////

    static Avt (pd) { // avator
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <View
                        style={ [{
                            width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                            marginTop: ic.gn_mgnNrm,
                            marginBottom: ic.gn_mgnNrm,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }, pd.stlCta] }
                    >
                        { (pd.pfx) ?
                            <Text 
                                style={ [{
                                    fontSize: ic.gn_fontSizeSml,
                                    color: ic.g_fontCcdSml,
                                    paddingTop: ic.gn_mgnNrm,
                                    paddingBottom: ic.gn_mgnNrm,
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                    fontWeight: 'bold',
                                }, pd.stlPfx] }
                            >
                                { pd.pfx }
                            </Text>
                        : null }
                        <TouchableOpacity
                            onPress={pd.o_onPrs}
                        >
                            <View
                                style={{
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <ce.Img
                                    uri={pd.uri}
                                    msg={pd.name.replace(/ /g, '').replace(/　/g, '').substring(0,2)}
                                    stlCta={{
                                        width: ic.gn_iconSizeLrg * 2.5,
                                        height: ic.gn_iconSizeLrg * 2.5,
                                        margin: ic.gn_mgnNrm,
                                    }}
                                    stlImg={{
                                        width: ic.gn_iconSizeLrg * 2.5,
                                        height: ic.gn_iconSizeLrg * 2.5,
                                    }}
                                />
                                <Text
                                    style={{
                                        fontSize: ic.gn_fontSizeSml,
                                        color: ic.g_fontCcdSml,
                                    }}
                                >
                                    {pd.name}
                                </Text>
                            </View>
                        </TouchableOpacity>
                    </View>
                : null }
            </View>
        );
    }

static Bdy = (pd) => {
  return (
    ce.c(View, {
      key: -1,
      style: [{ // rootdtl において上書きされている場合があることに注意
        position: 'absolute',
        zIndex: ic.gn_zIdxBdy,
        top: (global.t?.state.sgcn_bdyY) ? global.t?.state.sgcn_bdyY : ic.gn_bdyY,
//        left: ic.gn_bdyX,
//        left: (global.t?.state.sgcd_dmns.n_w - global.t?.state.sgcd_dmns.n_bdyW) / 2,
          lett: 0,
//        width: global.t?.state.sgcd_dmns.n_bdyW,
//        width: global.t?.state.sgcd_dmns.n_bdyW,
//        width: global.t?.state.sgcd_dmns.n_w,
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        borderWidth: 0,
        margin: 0,
        padding: 0,
        backgroundColor: ic.g_ccdWN,
      }, pd.stlCta],
    }, [
      pd.children
    ])
  );
};

static Bgg = (pd={}) => {
  return (
    ce.c(ImageBackground, {
      key: 'Bgg.root',
      resizeMode: 'cover',
      imageStyle: {
        height: '100%',
        width: '100%',
        ...pd.d_stlInrs,
      },
      source: { uri: pd.uri},
    }, pd.children)
  );
};

  static Btm (pd) {
    if (pd.b_vsb == false) return null; 
    return (
      <View
        style={{
          position: 'absolute',
          zIndex: ic.gn_zIdxBdy,
//          top: ((global.t?.state.sgcn_bdyY) ? global.t?.state.sgcn_bdyY : ic.gn_bdyY) + ic.gn_h - (ic.gn_hdrH + ((pd.n_h) ? pd.n_h : 0) + ic.gn_ftrH),
          top: ((global.t?.state.sgcn_bdyY) ? global.t?.state.sgcn_bdyY : ic.gn_bdyY) + global.t?.state.sgcd_dmns.n_h - (ic.gn_hdrH + ((pd.n_h) ? pd.n_h : 0) + ic.gn_ftrH),
          left: (global.t?.state.sgcd_dmns.n_w - ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW)) / 2,
          height: (pd.n_h) ? pd.n_h : 0,
          width: (pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW,
          justifyContent: 'center',
        }}
      >                
        { /* (pd.ld_defss) ? ce._elms(pd.ld_defss) : null */ }
        { pd.l_clds }
      </View>
    );
  };

static Tch (pd) {
  return (
    ce.c(TouchableOpacity, {
      key: 'Tch',
      style: [
        pd.d_stlCtas, // 廃止予定
        pd.d_ctrStls,
      ],
      onPress: 
        (pd.o_onPrs) ?
          () => {
//            global.t?.d_crls.o_updLastOrnDtm(); // 最終操作日時の更新
            global.d_crls.o_updLastOrnDtm(); // 最終操作日時の更新
            pd.o_onPrs();
          }
        : null,

    }, pd.children)
  )
};

static Btn = (pd) => {
  let _o = null;
  if (pd.b_vsb != false) {
    _o = (
      ce.c(ce.Tch, {
        key: -10,
        o_onPrs: pd.o_onPrs,
        d_ctrStls: pd.d_ctrStls,
/*
        d_stlCtas: {
          marginStart: 'auto',
          marginEnd: 'auto',
          marginTop: 0,
          marginBottom: 0,
          paddingStart: 0,
          paddingEnd: 0,
          paddingTop: 0,
          paddingBottom: 0,
          ...pd.d_stlCtas, // 廃止予定 
          ...pd.d_stlCtrs, // 廃止予定 
          backgroundColor: 'red'
        }
*/
      }, [
        ce.c(View, {
          key: -10,
          style: [
            { 
//              height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2, 
//              lineHeight: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2, 
//              height: ic.s(2), 
//              lineHeight: ic.s(2), 
              width: ic.gn_btnWNrm, 
              backgroundColor: (pd.b_rvs) ? ic.g_ccdWN : ic.o_getCcd('d'),
              borderWidth: ic.gn_bdrWNrw,
              borderColor: ic.o_getCcd('d'),
              borderRadius: ic.gn_bdrRdsNrm,
              marginStart: 0,
              marginEnd: 0,
              marginTop: 0,
              marginBottom: 0,
              paddingStart: 0,
              paddingEnd: 0,
              paddingTop: 0,
              paddingBottom: 0,
              flex: 1,
              flexDirection: 'column',
              justifyContent: 'center', 
              alignItems: 'center',
            },
            pd.stlBtn,
            pd.d_stlBtns,
          ],
        }, [
          ce.c(Text, {
            key: -10,
            style: [
              { 
                fontSize: ic.gn_fontSizeNrm,
                color: (pd.b_rvs) ? ic.o_getCcd('d') : ic.g_ccdWN,
              },
              pd.stlPfx,
              pd.d_stlPfxs,
            ],
            numberOfLines: 1
          }, pd.pfx)
        ])
      ])
    );
  };
/*
      <TouchableOpacity
        onPress={()=>{
          if (pd.o_onPrs) {
            pd.o_onPrs();
            global.t?.d_crls.o_updLastOrnDtm(); // 最終操作日時の更新
          };
        }}
        style={{
          marginStart: 'auto',
          marginEnd: 'auto',
          marginTop: 0,
          marginBottom: 0,
          paddingStart: 0,
          paddingEnd: 0,
          paddingTop: 0,
          paddingBottom: 0,
        }}
      >

 */
  return (
    ce.c(View, {
      key: 'Btn.Root',
      style: [
        {
//          height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2,
          height: ic.s(2),
          width: (pd.n_col) ? (pd.n_col * ic.gn_fontSizeNrm) : null,
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          marginStart: 'auto',
          marginEnd: 'auto',
          marginTop: 0,
          marginBottom: 0,
          paddingStart: 0,
          paddingEnd: 0,
          paddingTop: 0,
          paddingBottom: 0,
        },
        pd.stlCta, // 廃止予定
        pd.d_stlCtas,
      ]
    }, _o)
  );
}

  static BtnIcon (pd) {
    if (pd.b_vsb == false) return null;
    let _btnIconSize = (pd.n_btnIconSize) ? pd.n_btnIconSize : ic.gn_btnIconSize;
    return (
      ce.c(View, {
        key: -1,
        style: [{
          height: _btnIconSize,
          width: _btnIconSize,
          marginTop: 0,
          marginBottom: 0,
          marginLeft: 0,
          marginRight: 0,
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
        }, pd.stlCta],
      }, [
        ce.c(TouchableOpacity, {
          key: -1,
          onPress: pd.o_onPrs,
        }, [
          ce.c(View, {
            key: -1,
            style: [{
              height: _btnIconSize,
              width: _btnIconSize,
              marginTop: 0,
              marginBottom: 0,
              marginLeft: 0,
              marginRight: 0,
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 0,
              paddingRight: 0,
              backgroundColor: '#dddddd',
              borderColor: '#dddddd',
              borderRadius: _btnIconSize/2,
            }, pd.stlBtn],
          }, [
            ce.c(Icon, {
              key: -1,
              name: pd.iconName,
              type: "FontAwesome",
              underlayColor: "transparent",
              size: _btnIconSize - ic.gn_mgnNrm * 2,
              style: [{
                color: '#555555',
                marginTop: 'auto',
                marginBottom: 'auto',
                marginLeft: 'auto',
                marginRight: 'auto',
              }, pd.stlIcon],
            })
          ])
        ])
      ])
    );
  }

static BtnIconPfx(pd){
  if (pd.b_vsb == false) return null;
  return (
    <TouchableOpacity
      onPress={pd.o_onPrs}
      style={{
        marginLeft: (pd.b_row) ? ic.gn_fontSizeNrm : null,
        ...pd.stlCta, // 廃止予定
        ...pd.d_stlCtas,
      }}
    >
      <View
        style={[{
          height: 
            (pd.pfx) ?
              ((pd.b_row) ? (ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2 + ic.gn_bdrWNrm * 2) : (ic.gn_iconSizeSml*1.2 + ic.gn_fontSizeSml * 0.7))
            : ic.gn_btnIconSize
          ,
          minWidth: 
            (pd.b_row) ? 
              null 
            : (pd.n_col) ? 
              (pd.n_col * ic.gn_fontSizeNrm)
            : (ic.gn_btnIconSize + ic.gn_mgnLrg * 2),
          marginTop: (pd.b_row) ? 'auto' : 0,
          marginBottom: (pd.b_row) ? 'auto' : 0,
          marginLeft: (pd.b_row) ? ic.m(1) : 0,
          marginRight: (pd.pfx) ? ic.gn_mgnNrm : 0,
          flexDirection: (pd.b_row || false) ? 'row' : 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }, pd.stlCta]}
      >
{
        ce.c(Icon, {
          name: pd.iconName,
          size: (pd.b_row) ? ic.gn_iconSizeSml : ic.gn_iconSizeSml*1.2,
          color: pd.ccd ?? ic.o_getCcd('b'),
        })
}
        <Text
          style={{
            fontSize: (pd.b_row) ? ic.gn_fontSizeSml : ic.gn_fontSizeSml*0.7,
            color: pd.ccd ?? ic.o_getCcd('b'),
            fontWeight: 'bold',
            margin: 'auto',
            marginLeft: (pd.b_row) ? ic.gn_mgnNrm : null,
          }}
        >
          {pd.pfx}
        </Text>
        { (bf.f(pd.n_cnt) && pd.n_cnt > 0) ?
          <View
            style={{
              position: 'absolute',
              top: -4,
              right: -4,
              height: 12,
              width: 36,
              backgroundColor: '#ff0000',
              borderRadius: 6,
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Text
              style={{
                fontSize: 10,
                fontWeight: 'bold',
                color: '#ffffff',
                textAlign: 'center',
              }}
            >
              {pd.n_cnt}
            </Text>
          </View>
        : null }
      </View>
    </TouchableOpacity>
  );
}

static Btns (pd) {

  if ( pd.b_vsb == false ) return null;

  let _ld_defss = (pd.old_defss) ? pd.old_defss() : pd.ld_defss;

  if ( bf.f(_ld_defss) == false ) return null;

  let _r = [];

  const [ _sn_crrIdx, _setCrrIdx] = useState(0);

  for (let [_idx, _d_defs] of bf.e(_ld_defss)) {

    if (_d_defs.b_vsb == false) continue;

    _r.push(
      <TouchableOpacity
        key={_idx}
        onPress={() => {
          _setCrrIdx(_idx);
          if (_d_defs.o_onPrs) _d_defs.o_onPrs(_d_defs);
        }}
      >
        <View
          key={1}
          style={ [{ 
            height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2, 
            lineHeight: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2, 
            backgroundColor: 
                (_d_defs.b_rvs || (pd.b_srl == true && _sn_crrIdx != _idx)) ? 
                  ic.g_ccdWN 
                : 
                  (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? 
                    ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].bdyCcd 
                  : 
                    ic.gdd_ccdDefss.cmn.bdyCcd
            ,
            borderWidth: ic.gn_bdrWNrw,
            borderBottomWidth: (pd.b_srl == true && _sn_crrIdx != _idx) ? 0 : ic.gn_bdrWNrw,
            borderColor: 
              (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? 
                ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].bdyCcd 
              : 
                ic.gdd_ccdDefss.cmn.bdyCcd
            ,
            borderTopLeftRadius: ic.gn_bdrRdsNrm,
            borderTopRightRadius: ic.gn_bdrRdsNrm,
            borderBottomLeftRadius: (pd.b_srl == true) ? 0 : ic.gn_bdrRdsNrm,
            borderBottomRightRadius: (pd.b_srl == true) ? 0 : ic.gn_bdrRdsNrm,
            marginStart: (pd.b_srl == true) ? ic.gn_mgnNrm : 0,
            marginEnd: 0,
            marginTop: 0,
            marginBottom: 0,
            paddingLeft: ic.gn_mgnNrm,
            paddingRight: ic.gn_mgnNrm,
            paddingTop: 0,
            paddingBottom: 0,
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'center', 
            alignItems: 'center',
          }, _d_defs.stlBtn]}
        >
          <Text
            key={1}
            style={[{ 
              fontSize: ic.gn_fontSizeNrm,
              color: 
                (_d_defs.b_rvs || (pd.b_srl == true && _sn_crrIdx != _idx)) ? 
                  (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? 
                    ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].bdyCcd 
                  : 
                    ic.gdd_ccdDefss.cmn.bdyCcd 
                : 
                  ic.g_ccdWN
              ,
            }, _d_defs.stlPfx]}
            numberOfLines={1}
          >
            { _d_defs.pfx }
          </Text>
        </View>
      </TouchableOpacity>
    );
  };

  return (
    <>
      { ( pd.b_srl == true ) ?
        <ScrollView
          contentContainerStyle={[{
            height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2,
            flexDirection: 'row',
            justifyContent: 'space-around',
            alignItems: 'center',
            marginTop: ic.gn_mgnNrm,
            marginBottom: 0,
            padding: 0,
          }]}
          style={{
            width: ((pd.n_bdyW) ? pd.n_bdyW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            marginLeft: 'auto',
            marginRight: 'auto',
            borderWidth: 0,
            borderBottomWidth: ic.gn_bdrWNrw,
            borderBottomColor:
              (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? 
                ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].bdyCcd 
              : 
                ic.gdd_ccdDefss.cmn.bdyCcd 
            ,
          }}
          horizontal={true}
        >
          {_r}
        </ScrollView>
      :
        <View 
          style={[{
            height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2,
            width: ((pd.n_bdyW) ? pd.n_bdyW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: 0,
            marginBottom: 0,
            paddingStart: 0,
            paddingEnd: 0,
            paddingTop: 0,
            paddingBottom: 0,
            flexDirection: 'row',
            justifyContent: 'space-around',
            alignItems: 'center',
          }, pd.stlCta]}
        >
          {_r}
        </View>
      }
    </>
  );
}

static Box (pd={
  d_boxStls: null,
}) {
  if (pd.b_vsb == false) return null;
  return (
    ce.c(View, {
      key: -1,
      style: {
        width: pd.n_w,
        marginLeft: 0,
        marginRight: 0,
        marginTop: pd.n_mgnTop ?? 0,
        marginBottom: 0,
        borderWidth: 0,
        flexDirection: pd.b_row ? 'row' : 'column',
        justifyContent: pd.b_row ? 'center' : 'flex-start',
        alignItems: pd.b_row ? 'center' : 'flex-start',
        ...pd.stlCta, // 廃止予定
        ...pd.d_stlCtas,
        ...pd.d_boxStls,
      },
    }, pd.children)
  );
}

static Files (pd) {

  if (pd.b_vsb == false) return null;

  let _r = [];

  for (let [_idx, _d_files] of bf.e(global.t?.state[pd.state])) {
    if (pd.o_vsb && pd.o_vsb(_d_files.d_ct10s) == false) {
      continue;
    };

    if (bf.f(_d_files) && _d_files.b_dlt != true) {
      _r.push(
        <View
          key={_idx}
          style={[{
            height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2,
            width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            marginTop: ic.gn_mgnNrm,
            marginBottom: ic.gn_mgnNrm,
            marginLeft: 'auto',
            marginRight: 'auto',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
            paddingTop: ic.gn_mgnNrm,
            paddingBottom: ic.gn_mgnNrm,
            paddingLeft: ic.gn_mgnNrm,
            paddingRight: ic.gn_mgnNrm,
          }, (pd.stlCta) ? pd.stlCta : ((pd.o_stlCta) ? pd.o_stlCta(_d_files.d_ct10s) : null)]}
        >
            { (_d_files.lct == 'ext' && bf.f(_d_files.file)) ?
              <ce.Link
                key={-1}
                file={_d_files.file}
                stlLink={{
                  color: '#ffaa00',
                }}
              >
                {_d_files.name}
              </ce.Link>
            : null }
            { (_d_files.lct == 'ext' && bf.f(_d_files.url)) ?
              <ce.Link
                key={-1}
                url={_d_files.url}
                file={_d_files.file}
                stlLink={{
                  color: '#ffaa00',
                }}
              >
                {_d_files.name}
              </ce.Link>
            : null }
            { (_d_files.lct == 'int') ?
              <Text>
                {_d_files.name}
              </Text>
            : null }
            { (pd.o_sfx) ?
              <Text
                style={[{
                  position: 'absolute',
                  bottom: 0,
                  right: 0,
                  color: ic.g_ccdHN,
                  fontSize: ic.gn_fontSizeSml,
                  textAlign: 'right',
                }, pd.stlSfx]}
              >{_pd.o_sfx(_d_files)}</Text>
            : null }
          <ce.BtnIcon
            key={-2}
            b_vsb={(pd.ob_dltBtnVsb) ? pd.ob_dltBtnVsb(_d_files.d_ct10s) : pd.b_dltBtnVsb}
            iconName="trash"
            o_onPrs={()=>{
              if (_d_files.lct == 'int'){ // 内部ファイルの場合
                // list から ファイルを削除
                let _ld_files = global.t?.state[pd.state];
                // 削除対象が内部ファイルの場合
                _ld_files = bf.myCM_rmv(_ld_files, _d_files);
                global.t?.setState({
                  [pd.state]: _ld_files,
                });
              }; 
              if (_d_files.lct == 'ext'){ // 外部ファイルの場合
                let _ld_files = global.t?.state[pd.state];
                _ld_files = bf.myCM_rmv(_ld_files, _d_files);
                _d_files.b_dlt = true;
                _ld_files.push(_d_files);
                global.t?.setState({
                  [pd.state]: _ld_files,
                });
              }; 
            }}
            stlCta={{
                position: 'absolute',
                top: ic.gn_mgnNrm + ic.gn_bdrWNrw * 1.5 / 2, // boderWidth 分を追加
                right: ic.gn_mgnNrm,
                backgroundColor: ic.gn_backCcd,
            }}
          />
        </View>
      );
    };
  };

  return (
    <>
      <ce.Lbl
        key={-1}
        pfx={pd.pfx}
        iconName={'plus'}
        b_btnVsb={pd.b_lblBtnVsb}
        onBtnPrs={()=>{
          cf.myFS_pck_file()
          .then(async (_d_files) => {
            if ( global.t && pd.state && global.t?.state[pd.state]) {
              global.t?.setState({
                [pd.state]: bf.p(global.t?.state[pd.state], _next => {
                  _d_files.d_ct10s = {
                    ct10t110: pd.ct10t110 || global.t?.state.sgcd_pagePntKeys.cm10c410,
                    ct10cy20: global.t?.state.sgcd_pagePntKeys.cm10_key,
                  };
                  _next.push(_d_files);
                }),
              });
            };
          });
        }}
      />
      {_r}
    </>
  );
}

    static Hdr (pd) {
        return (
            <View style={{ 
              position: 'absolute',
              zIndex: ic.gn_zIdxHdr,
              top: 0,
              left: 0,
              height: ic.gn_hdrH,
              width: '100%',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              alignItems: 'center',
              backgroundColor: ic.o_getCcd('d'),
/*
              borderWidth: 0,
              borderTopWidth: ic.gn_bdrWFat,
              borderTopColor: ic.o_getCcd('d'),
              borderBottomWidth: ic.gn_bdrWNrw,
              borderBottomColor: ic.o_getCcd('d'),
*/
              ...pd.d_stlCtrs,
            }}>
                <View style={{
                  position: 'absolute',
                  zIndex: ic.gn_zIdxHdr + 1,
                  top: ic.gn_hdrBarH,
                  left: 0,
                  height: ic.gn_hdrH - ic.gn_hdrBarH,
                  width:ic.gn_btnWSml * 3,
                  marginLeft: ic.gn_mgnNrm,
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}>
                    { (ic.gob_menu() == true && ic.g_dvcMode == 's') ?
                      ce.c(ce.BtnIconPfx, {
                        b_vsb: (global.t?.state.sgc_pageMode == 'show') ? true : false,
                        pfx: 'メニュー',
                        iconName: 'navicon',
                        o_onPrs: () => {
                          let _ld_iss =  Object.keys(cf.myRN_getMenuDefss())
                          .filter( _view => {
                            let _d = cf.myRN_getMenuDefss()[_view];
                            return (_d.b_vsb != false) ? true : false;
                          })
                          .map( _view => {
                            let _d = cf.myRN_getMenuDefss()[_view];
                            if (_d.fnc == 'logout') { // 20211126
                              return {
                                pfx: _d.pfx,
                                type: 'logout',
                              };
                            }
                            else {
                              return {
                                pfx: _d.pfx,
                                type: 'moveFwd',
                                d_pageInfs: {
                                  sgc_pageName: _d.sgc_pageName,
                                  sgc_pageRole: _d.sgc_pageRole,
                                  sgc_pageMode: 'show',
                                },
                              };
                            };
                          });
                          global.t?.setState({
                            sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next =>{
                              _next.menu.ld_iss = _ld_iss;
                              _next.menu.b_showMdl = true;
                            }),
                          }, () => {
                          });
                        },
                      })
                    : null}
                    { (pd.d_lefts?.b_vsb != false && ff.f(ic.gob_home()) == true) ?
                      ce.c(ce.BtnIconPfx, {
                        b_vsb: (global.t?.state.sgc_pageMode == 'show') ? true : false,
                        pfx: 'ホーム',
                        iconName: 'home',
                        o_onPrs: () => {
                          let _d_pageInfs = { // pagePntKey の切り替えは Ftr では行わない
                            sgc_pageRole: global.t?.state.sgc_pageRole,
                            sgc_pageName: ic.gob_home(),
                            sgc_pageMode: 'show', // これがないと view の初期表示が定まらない
                          };
                          cf.myRN_move_fwd(_d_pageInfs);
                        },
                        d_stlCtas: {
                          marginLeft: (ic.g_dvcMode == 's') ? 0 : ic.s(2),
                        },
                      })
                    : null}
                    { (pd.b_logo) ?
                        <Image
                            style={[{
                                height: ic.gn_iconSizeLrg,
                                width: ic.gn_iconSizeLrg / ic.gn_logoH * ic.gn_logoW,
                            }]}
                            source={'./logo.png'} // you need logo.png at ./srn ※ 文字列に変換しておかないと error が発生
                        />
                    : null }
                    { (pd.logo) ?
                      <Text
                        style={[{
                          fontSize: ic.gn_fontSizeNrm,
                          color: ic.g_backCcd,
                          textAlign: 'center',
                        }]}
                      >
                        {pd.logo}
                      </Text>
                    : null }
                    { (bf.f(pd.leftIconName) && !bf.f(pd.leftPfx) && pd.b_leftVsb != false) ?
                        ce.Icon({
                            name: pd.leftIconName,
                            n_size: 30,
                            ccd: (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                            o_onPrs: pd.o_onLeftPrs,
                        })
                    : null }
                    { (bf.f(pd.leftPfx) && !bf.f(pd.leftIconName) && pd.b_leftVsb != false) ? // logo がある場合、leftPfx が改行される場合がある
                        ce.Btn({
                            pfx:pd.leftPfx, 
                            b_vsb:true,
                            stlCta:bf.myCM_upd({
                                width: ic.gn_btnWNrm,
                            }, pd.stlLeftCta),
                            stlBtn:bf.myCM_upd({
                                borderColor: (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                                backgroundColor: (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'flex-start',
                            }, pd.stlLeftBtn),
                            stlPfx:bf.myCM_upd({
                                color: ic.g_backCcd,
                            }, pd.stlLeftPfx),
                            o_onPrs:pd.o_onLeftPrs,
                        })
                    : null }
                    { (bf.f(pd.leftIconName) && bf.f(pd.leftPfx) && pd.b_leftVsb != false) ?
                        <ce.BtnIconPfx
                            iconName={pd.leftIconName}
                            pfx={pd.leftPfx}
                            o_onPrs={pd.o_onLeftPrs}
                        />
                    : null}
                    { (pd.b_sch) ?
                        <ce.BtnIconPfx
                            iconName='search'
                            pfx='検索'
                            o_onPrs={pd.o_onSchPrs}
                        />
                    : null}
                </View>
                <View
                  style={{
                    height: ic.gn_hdrH - ic.gn_hdrBarH,
                    width: global.t?.state.sgcd_dmns.n_w,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                    {
                      ce.c(View, {
                        key: -1,
                        style: {
                          flexDirection: 'row',
                          justifyContent: 'space-around',
                          alignItems: 'center',
                        },
                      }, [
                        (ff.f(ic.gob_home()) == true) ? // ホームを使用する場合
                          ce.c(Text, {
                            key: -1,
                            style: [{
                              fontSize: ic.gn_fontSizeNrm,
//                              color: ic.o_getCcd('p'),
                              color: ic.o_getCcd('b'),
                              fontWeight: 'bold',
                              textAlign: 'center',
                            }]
                          }, [ 
                            pd.pfx ?? global.t?.d_viewDefs.name,
                          ])
//                        : (ic.gob_menu() != true && ic.g_dvcMode == 's' && pd.pfx) ? // メニューを使用しない場合
                        : (ic.gob_menu() != true && pd.pfx) ? // メニューを使用しない場合
                          ce.c(Text, {
                            key: -1,
                            style: [{
                              fontSize: ic.gn_fontSizeNrm,
//                              color: ic.o_getCcd('p'),
                              color: ic.o_getCcd('b'),
                              fontWeight: 'bold',
                              textAlign: 'center',
                              ...pd.d_stlPfxs,
                            }]
                          }, [ 
                            pd.pfx
                          ])
                        : (ic.gob_menu() == true && global.t?.state.sgc_pageRole) ? // メニューを使用する場合
                          Object.keys(cf.myRN_getMenuDefss())
                          .filter( _page => (cf.myRN_getMenuDefss()[_page].b_vsb != false) ? true : false)
                          .map( (_page, _idx) => {
                            let _d_pageDefs = cf.myRN_getMenuDefss()[_page];
                            return ce.c(TouchableOpacity, {
                              key: _idx,
                              onPress: () => {

                                if (_d_pageDefs.fnc == 'logout') {
                                  cf.myRN_logout();
                                }
                                else {
                                  let _d_pageInfs = { // pagePntKey の切り替えは Ftr では行わない
                                    sgc_pageRole: _d_pageDefs.sgc_pageRole,
                                    sgc_pageName: _d_pageDefs.sgc_pageName,
                                    sgc_pageMode: 'show', // これがないと view の初期表示が定まらない
                                  };
                                  cf.myRN_move_fwd(_d_pageInfs);
                                };
                              },
                              style: {
                                marginLeft: ic.gn_mgnNrm * 4,
                                marginRight: 0,
                                borderColor: ic.g_backCcd,
                                borderWidth: 0,
                                borderBottomWidth: bf.i(global.t?.state.sgc_pageName, bf.c([_page], _d_pageDefs.l_subPages ?? [])) ? ic.gn_bdrWNrm : 0,
                              }
                            }, [
                              ce.c(Text, {
                                key: -1,
                                style: {
                                  fontSize: bf.i(global.t?.state.sgc_pageName, bf.c([_page], _d_pageDefs.l_subPages ?? [])) ? ic.gn_fontSizeLrg : ic.gn_fontSizeNrm,
                                  color: ic.g_backCcd,
                                },
                              }, [_d_pageDefs.pfx])
                            ])
                          })
                        : null
                      ])
                    } 
                </View>
                <View
                    style={{
                        position: 'absolute',
                        zIndex: ic.gn_zIdxHdr + 1,
                        top: ic.gn_hdrBarH,
                        right: 0,
                        height: ic.gn_hdrH - ic.gn_hdrBarH,
                        width:ic.gn_btnWSml * 3,
                        marginTop: 0,
                        marginBottom: 0,
                        marginRight: ic.gn_mgnNrm,
                        marginLeft: 0,
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }}
                >
                    {
                    ce.c(ce.Msg, {
                      key: -10,
//                      b_vsb: ff.f(global.t?.state.sgcd_cmnStgs?.c10r_pfx),
                      b_vsb: ff.f(global.t?.state.sgcd_cmnStgs?.c10r_pfx) && pd.b_c10r_pfx != false,
//                      pfx: global.t?.state.sgcd_cmnStgs?.c10r_pfx,
                      pfx: `利用者：${global.t?.state.sgcd_cmnStgs?.c10r_pfx}`,
                      n_mgnRht: ic.s(2),
                      d_stlCtas: {
                        width: null,
                      },
                      d_stlPfxs: {
                        color: ic.g_ccdWN,
                      },
                    })
                    }
                    { ( pd.d_chks?.l_clds) ? 
                        pd.d_chks.l_clds
                    : ( pd.d_chks?.b_vsb == true) ?
                      ce.c(ce.BtnIconPfx, {
                        key: -20,
                        iconName: 'check-square-o',
                        pfx: '選択',
                        o_onPrs: () => {
                          cf.myRN_savePageStgs({
                            sgc_pnlMode: 'chk',
                          })
                        }
                      })
                    : null }
                    { ( pd.d_news?.l_clds) ? 
                        pd.d_news.l_clds
                    : ( pd.d_news?.b_vsb == true) ?
                      ce.c(ce.BtnIconPfx, {
                        key: -30,
                        iconName: 'plus',
                        pfx: '新規',
                        o_onPrs: () => {
                          cf.myRN_chgPageMode({
                            ...pd.d_news,
                            mode: 'sttNew',
                          });
                        }
                      })
                    : null }
                    { (pd.d_edits) ? 
                      ( pd.d_edits?.l_clds) ? 
                          pd.d_edits.l_clds
                      : ( pd.d_edits?.b_vsb != false && global.t?.state.sgc_pageMode == 'show') ?
                        ce.c(ce.BtnIconPfx, {
                          key: -40,
                          iconName: 'pencil',
                          pfx: '変更',
                          o_onPrs: () => {
                            cf.myRN_chgPageMode({
                              mode: 'sttEdit',
                            });
                          }
                        })
                      : ( pd.d_edits?.b_vsb != false && global.t?.state.sgc_pageMode == 'edit') ?
                        ce.c(ce.BtnIconPfx, {
                          key: -50,
                          iconName: 'check',
                          pfx: '保存',
                          o_onPrs: () => {
                            cf.myRN_chgPageMode({
                              mode: 'endEdit',
                            });
                          }
                        })
                      : ( pd.d_edits?.b_vsb != false && global.t?.state.sgc_pageMode == 'new') ?
                        ce.c(ce.BtnIconPfx, {
                          key: -60,
                          iconName: 'check',
                          pfx: '登録',
                          o_onPrs: () => {
                            cf.myRN_chgPageMode({
                              mode: 'endNew',
                            });
                          }
                        })
                      : null
                    : null }
                    { ( pd.d_stgs?.l_clds) ? 
                        pd.d_stgs.l_clds
                    : ( pd.d_stgs?.b_vsb == true) ?
                      ce.c(ce.BtnIconPfx, {
                        key: -70,
                        iconName: pd.d_stgs?.iconName ?? 'sliders',
                        pfx: pd.d_stgs?.pfx ?? '設定',
                        o_onPrs: () => {
                          cf.myRN_savePageStgs({
                            sgc_pnlPhs: 'stg',
                          })
                        }
                      })
                    : null }
                    { (pd.d_subs && pd.d_subs.b_vsb != false) ?
                      ce.c(ce.BtnIconPfx, {
                        iconName: pd.d_subs.iconName,
                        pfx: pd.d_subs.pfx,
                        o_onPrs: 
                          (pd.d_subs.o_onPrs) ?
                            pd.d_subs.o_onPrs
                          : (pd.d_subs.ld_iss) ?
                            () => {
                              if (bf.f(pd.d_subs.ld_iss)) {
                                global.t?.setState({
                                  sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next =>{
                                    _next.menu.ld_iss = pd.d_subs.ld_iss;
                                    _next.menu.b_showMdl = true;
                                  }),
                                }, () => {
                                });
                              };
                            }
                          : null,
                        d_stlCtas: {
                          marginRight: (ic.g_dvcMode == 's') ? 0 : ic.s(2),
                        },
                      })
                    : null}
                    { (ff.f(ic.gob_home()) == true) ?
                      ce.c(ce.BtnIconPfx, {
                        b_vsb: (global.t?.state.sgc_pageMode == 'show') ? true : false,
                        pfx: 'ログアウト',
                        iconName: 'sign-out',
                        o_onPrs: () => {
                          cf.myRN_logout();
                        },
                        d_stlCtas: {
                          marginRight: (ic.g_dvcMode == 's') ? 0 : ic.s(2),
                        },
                      })
                    : null}
                </View>
            </View>
        );
    }
/*
                    { (ff.f(ic.gob_home()) == true && global.t?.state.sgc_pageName == ic.gob_home()) ?

                    { (pd.b_subVsb == true && global.t?.state.sgc_pageMode == 'show') ?
                      <ce.BtnIconPfx
                        iconName={pd.subIconName}
                        pfx={pd.subPfx}
                        o_onPrs={pd.o_onSubPrs}
                      />
                    : null}
*/

    static HdrTrs (pd) {
        return (
            <>
                { (pd.b_vsb) ?
                    <View style={{ 
                        position: 'absolute',
                        zIndex: ic.gn_zIdxHdr + 1,
                        top: ((global.t?.state.sgcn_bdyY) ? global.t?.state.sgcn_bdyY : ic.gn_bdyY) - ic.gn_hdrH,
                        left: 0,
                        height: ic.gn_hdrH,
                        width: global.t?.state.sgcd_dmns.n_w,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                        borderBottomColor: (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                        borderBottomWidth: ic.gn_bdrWNrm,
                        padding: ic.gn_mgnNrm,
                    }}>
                        <ce.BtnIconPfx
                            iconName='trash'
                            pfx='選択項目を削除'
                            o_onPrs={pd.o_onPrs}
                        />
                        <ce.BtnIconPfx
                            iconName='close'
                            pfx='キャンセル'
                            o_onPrs={pd.o_onCls}
                        />
                    </View>
                : null }
            </>
        );
    }

    static HdrSch (pd) {
        //
        if (pd.b_vsb == false) {
            return null;
        };
        // 
        return (
            <View style={{ 
                position: 'absolute',
                zIndex: ic.gn_zIdxHdr + 1,
                top: (((global.t?.state.sgcn_bdyY) ? global.t?.state.sgcn_bdyY : ic.gn_bdyY) - ic.gn_hdrH) + ic.gn_hdrBarH,
                left: 0,
                height: ic.gn_hdrH - ic.gn_hdrBarH,
                width: global.t?.state.sgcd_dmns.n_w,

                paddingTop: ic.gn_mgnNrm,
                paddingBottom: ic.gn_mgnNrm,
                paddingLeft: ic.gn_mgnNrm,
                paddingRight: ic.gn_mgnNrm,

                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',

                backgroundColor: (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                borderBottomColor: (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                borderBottomWidth: ic.gn_bdrWNrm,
            }}>
                <View 
                    style={ [{
                        height: ic.gn_hdrH - ic.gn_mgnNrm * 2,
                        width: global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm - ic.gn_mgnNrm - ic.gn_btnWNrm - ic.gn_mgnNrm,

                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                    }] }
                >
                    <Icon
                        name='search'
                        color={ic.g_backCcd}
                        size={ic.gn_iconSizeSml}
                    />
                    <TextInput 
                        editable={true}
                        multiline={false}
                        placeholder={(pd.phd) ? pd.phd : '検索文字を入力後に確定ください'}
                        placeholderTextColor={ic.g_backCcd}
                        style={{
                            width: global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm - ic.gn_iconSizeSml - ic.gn_mgnNrm - ic.gn_mgnNrm - ic.gn_btnWNrm - ic.gn_mgnNrm,
                            color: ic.g_backCcd,
                            fontSize: ic.gn_fontSizeNrm,
                            borderWidth: ic.gn_bdrWNrw * 1.5,
                            borderColor: (pd.b_edit == true) ? ic.g_bdrCcd : ic.g_ccdWN,
                            borderRadius: ic.gn_bdrRdsNrm,
                            marginTop: ic.gn_mgnNrm,
                            marginBottom: ic.gn_mgnNrm,
                            marginLeft: ic.gn_mgnNrm,
                            marginRight: 0,
                            paddingTop: ic.gn_mgnNrm,
                            paddingBottom: ic.gn_mgnNrm,
                            paddingLeft: ic.gn_mgnNrm,
                            paddingRight: ic.gn_mgnNrm,
                            borderRadius: (pd.b_mln || pd.b_bdr != false) ? ic.gn_bdrRdsNrm : 0,
                            minHeight: (pd.b_mln) ? ic.gn_fontSizeNrm * 8 : ic.gn_fontSizeNrm * 3,
                        }}
                        onChangeText={(_schKey)=>{
                          global.t?.setState({
                            sgcd_schs: bf.p(global.t?.state.sgcd_schs, _next => {
                              _next.word= _schKey;
                            }),
                          }, () => {
                          });
                        }}
                        onSubmitEditing={()=>{
                          if (pd.o_onEnt) {
                            pd.o_onEnt();
                          };
                        }}
                    />
                </View>
                <ce.BtnIconPfx
                    iconName='close'
                    pfx='閉じる'
                    o_onPrs={pd.o_onCls}
                />
            </View>
        );
    }

  static Icon (pd) {
    return (
      <TouchableOpacity onPress={()=>{if ( pd.o_onPrs != null ) { pd.o_onPrs(); };}}>
        <View
          style={[{
            justifyContent:'center',
            alignItems:'center',
            margin: 'auto',
          }, pd.stlCta]}
        >
          <Icon
            name={pd.name}
            color={pd.ccd}
            size={(pd.n_size) ? pd.n_size : ic.gn_iconSizeNrm}
          />
        </View>
      </TouchableOpacity>
    );
  }

    static Img = (pd={
    }) => {
      let _r = [];
      _r.push(
        <View
          key={1}
          style={{
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <View
            style={[{
              height: ic.gn_iconSizeLrg,
              width: ic.gn_iconSizeLrg,
              marginLeft: ic.gn_mgnNrm,
              marginRight: ic.gn_mgnNrm,
              ...(pd.d_stlCtas) ? pd.d_stlCtas : null,
            }, pd.stlCta]}
          >
              { ((global.t != null && pd.state != null && bf.f(global.t?.state[pd.state])) || (bf.f(pd.uri))) ?
                <Image
                  style={[{
                    height: ic.gn_iconSizeLrg,
                    width: ic.gn_iconSizeLrg,
                    borderRadius: ic.gn_bdrRdsNrm,
                  ...(pd.d_stlImgs) ? pd.d_stlImgs : null,
                  }, pd.stlImg]}
                  source={(global.t != null && pd.state != null) ? { uri: global.t?.state[pd.state]} : pd.uri}　// 文字列に変換しておかないと error が発生、pd.uri は require された文字列でないと image が表示されない
                />
              :
                <View
                  style={{
                    height: '100%',
                    width: '100%',
                    backgroundColor: ic.g_ccdHP,
                    borderRadius: ic.gn_bdrRdsNrm,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Text
                    style={{
                      fontSize: ic.gn_fontSizeNrm,
                      color: ic.g_ccdWN,
                    }}
                  >
                    {pd.msg}
                  </Text>
                </View>
              }
          </View>
        </View>
      );
      //
      return (
        <View>
          { (pd.pfx) ?
            <View
              style={{
                width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
//                marginTop: ic.gn_mgnNrm,
//                marginBottom: ic.gn_mgnNrm,
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              <Text 
                style={ [{
                  fontSize: ic.gn_fontSizeSml,
                  color: ic.g_fontCcdSml,
                  paddingTop: ic.gn_mgnNrm,
                  paddingBottom: ic.gn_mgnNrm,
                  paddingLeft: 0,
                  paddingRight: 0,
                  fontWeight: 'bold',
                }, pd.stlPfx] }
              >
                { pd.pfx }
              </Text>
            </View>
          : null }
          {(pd.b_edit == true) ?
            <TouchableOpacity onPress={()=>{
              if (pd.b_edit == true) {
                cf.myIP_pick_img((_d_ress) => {
                  if ( global.t != null && pd.state != null ) {
                    global.t?.setState({[pd.state]:String(_d_ress.uri)})
                  };
                  if (pd.o_onPrs) {
                    pd.o_onPrs(_d_ress.uri);
                  };
                }, 'image');
              };
            }}>
              {_r}
            </TouchableOpacity>
          :
            _r
          }
        </View>
      );
    }

    static Imgs (pd) {
        //
        let _r = [];
        //
        bf.myCM_for_each(pd.ld_defss, (_d_defs, _idx) => {
            _r.push(
                <ce.Img
                    key={_idx}
                    
                    state={_d_defs.state}
                    b_edit={pd.b_edit}
                    msg={_d_defs.msg}
                    uri={_d_defs.uri}
                    stlCta={pd.stlCta}
                    stlImg={pd.stlImg}
                />
            );
        });
        //
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <View
                        style={ [{
                            width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                            marginTop: ic.gn_mgnNrm,
                            marginBottom: ic.gn_mgnNrm,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }, pd.stlBox] }
                    >
                        <View>
                            { (pd.pfx) ?
                                <Text 
                                    style={ [{
                                        fontSize: ic.gn_fontSizeSml,
                                        color: ic.g_fontCcdSml,
                                        paddingTop: ic.gn_mgnNrm,
                                        paddingBottom: ic.gn_mgnNrm,
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        fontWeight: 'bold',
                                    }, pd.stlPfx] }
                                >
                                    { pd.pfx }
                                </Text>
                            : null }
                        </View>
                        <View
                            style={[{
                                marginTop: ic.gn_mgnLrg,
                                marginBottom: ic.gn_mgnLrg,
                                marginLeft: ic.gn_mgnNrm,
                                marginRight: ic.gn_mgnNrm,
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexWrap:'wrap'                    
                            }, pd.stlBox]}
                        >
                            {_r}
                        </View>
                    </View>
                : null }
            </View>
        );
    }

static Inp = React.memo((pd) => {

    const [_so_textInput, _setTextInput] = useState(null);
    const [_s_val, _setVal] = useState(pd.ini ?? ''); // common for inp & pck
    const [_s_id, _setId] = useState(''); // only for pck

    useEffect(()=>{ // pd.state の場合、o_onCld が前提
      if (
        pd.state &&
        (global.t?.state[pd.state] || global.t?.state[pd.state] == '' || global.t?.state[pd.state] == 0)
      ) {
        if (pd.mode != 'pck') { // inp の場合
          if (global.t?.state[pd.state] || global.t?.state[pd.state] == ''){ // 空白の場合に更新が反映されないことを考慮
            _setVal(global.t?.state[pd.state]);
            if (pd.o_onChg) {
              pd.o_onChg(global.t?.state[pd.state]);
            }
            //global.d_crls.o_updLastOrnDtm(); // 最終操作日時の更新
          };
        }
        else { // pck の場合
          if (
            pd.state && 
            (global.t?.state[pd.state] || global.t?.state[pd.state] == '' || global.t?.state[pd.state] == 0) && 
            bf.f(pd.ld_iss)
          ) {
            if (
              bf.f(bf.myCM_getDny({ld_iss:pd.ld_iss, fld:'key', val:global.t?.state[pd.state]}))
            ) { // pd.ld_iss に対応する値が存在する場合
              let _d = bf.myCM_getDny({ld_iss:pd.ld_iss, fld:'key', val:global.t?.state[pd.state]});
              _setVal(_d.pfx);
            }
            else { // pd.ld_items に対応する値が存在しない場合
              _setVal('');
            };
            //global.d_crls.o_updLastOrnDtm(); // 最終操作日時の更新
          };
        }
      }
    }, [
      global.t?.state[pd.state],
      pd.ld_iss
    ]);

    useEffect(()=>{ // pd.state でない場合、o_onChgAsCld が前提、common for inp & pck
      if (pd.mode != 'pck') { // 通常の場合
        if (pd.ctlVal == 0 || pd.ctlVal){ // 空白の場合に更新が反映されないことを考慮
          if (pd.state) { // clds でない state が指定されている場合
            global.t?.setState({
              [pd.state]: pd.ctlVal
            });
          }
          else { // clds であり state が指定されていない場合
            _setVal(pd.ctlVal);
            if (pd.o_onChgAsCld) {
              pd.o_onChgAsCld(pd.ctlVal, pd.d_ids);
            }
          }
          //global.d_crls.o_updLastOrnDtm(); // 最終操作日時の更新
        };
      }
    }, [
      pd.ctlVal,
    ]);

    useEffect(()=>{ // pd.state でない場合、o_onChgAsCld が前提、common for inp & pck
      if (pd.mode == 'pck') { // pck の場合
        if (pd.ctlVal == 0 || pd.ctlVal){ // 空白の場合に更新が反映されないことを考慮
          if (bf.myCM_getDny({ld_iss:pd.ld_iss, fld:'key', val:pd.ctlVal})) {
            _setVal(bf.myCM_getDny({ld_iss:pd.ld_iss, fld:'key', val:pd.ctlVal}).pfx);
          };
          if (pd.ctlVal == -1) {
            _setVal('');
          };
          //global.d_crls.o_updLastOrnDtm(); // 最終操作日時の更新
        };
      }
    }, [
      pd.ctlVal,
      pd.ld_iss
    ]);

    useEffect(()=>{ // only for pck _s_id ではなく do_fnc を用いることで処理を効率化できないか
      let _d_slcItems = global.t?.state.sgcd_mdls[pd.mdlType]?.d_slcItems;
      if (ff.f(_d_slcItems)) {
        if (_d_slcItems.key == 0 || _d_slcItems.key) { // _d_slcItems.key == 0 を考慮, SlcListsss の key が正しくない場合、値が設定されない
          if (
            ff.f(global.t?.state.sgcd_mdls[pd.mdlType].id) && 
            ff.f(_s_id) && 
            global.t?.state.sgcd_mdls[pd.mdlType].id == _s_id
          ) { // 同一 id の場合（ id はボタン押下時に発行 ） ※重複する key がある場合、全てに値が反映されるため
            if (pd.b_newLine == true) { // b_newLine である新規登録行は反映しない
              _setVal('');
            } 
            else {
              if (pd.state) { // clds でない場合
                global.t?.setState({
                  [pd.state]: _d_slcItems.key,
                }, () => {
                });
              }
              else { // clds の場合
                _setVal(_d_slcItems.pfx);
              };
            };
            //
            if(pd.o_onChg) { // clds の場合、値を反映
              global.t?.setState({ // 同一要素を繰り返し選択可能とするためには d_slcItems の初期化が必要
                sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next => {
                  _next[pd.mdlType].d_slcItems = {};
                }),
              }, () => {
                pd.o_onChg(_d_slcItems);
              });
            };
          };
        };
      };
    }, [
      global.t?.state.sgcd_mdls[pd.mdlType]?.d_slcItems
    ]) // 同一id かつ b_newLine 以外で d_slcItems が設定された場合に値が変更される

    if (pd.b_vsb == false) {
        return null;
    }

/*
    const _o_onBlur = () => {
      if (pd.state) { // clds ではない場合
        if (pd.o_onBlur) {
          pd.o_onBlur(_s_val);
        };
      }
      else { // clds の場合＋（sch等の）通常の入力欄の場合
        if (pd.o_onBlurAsCld) {
          pd.o_onBlurAsCld(_s_val, pd.d_ids);
        };
      };
    };
*/
    const _o_onBlur = () => {
      let _s = _s_val;
      if (pd.b_trim) {
        _s =  ff.myCM_cnv('trim', _s);
        _setVal(_s);
      };
      if (pd.state) { // clds ではない場合
        if (pd.o_onBlur) {
//          pd.o_onBlur(_s_val);
          pd.o_onBlur(_s);
        };
      }
      else { // clds の場合＋（sch等の）通常の入力欄の場合
        if (pd.o_onBlurAsCld) {
//          pd.o_onBlurAsCld(_s_val, pd.d_ids);
          pd.o_onBlurAsCld(_s, pd.d_ids);
        };
      };
    };

    const _o_onChangeText = (_s) => {
      if (_s != _s_val) { // 値に変更のあった場合
        if (pd.n_maxCnt > 0 && bf.myCM_cnv('bytes', _s) > pd.n_maxCnt) {
          _s = _s.substr(0,pd.n_maxCnt);
          alert('{}文字まで入力できます'.f(pd.n_maxCnt))
        }
        _setVal(_s);
        if (pd.state) { // clds ではない場合
          global.t?.setState({ // 外部からの更新を考慮し、onChg は useEffect で実行
            [pd.state]: _s
          }, ()=>{
          });
        }
        else { // clds の場合＋（sch等の）通常の入力欄の場合
          if (pd.o_onChgAsCld) {
            pd.o_onChgAsCld(_s, pd.d_ids);
          }
        };
        if (_so_textInput) {
          _so_textInput.measure((originX, originY, width, height, pageX, pageY) => { // 選択した inp の位置を保存
            global.t?.setState({
              sgcd_inpMsrs: {x:pageX, y:pageY, w:width, h:height, ox:originX, oy:originY},
            });
          })
        };
      };
    };

    const _o_onContentSizeChange = (_e) => { // PCでは不要な処理のため、keyboard が表示されたときの配置調整は、textinput ではなく、画面ごとに行う
      if (_so_textInput) {
        _so_textInput.measure((originX, originY, width, height, pageX, pageY) => { // 選択した inp の位置を保存
          global.t?.setState({
            sgcd_inpMsrs: {x:pageX, y:pageY, w:width, h:height, ox:originX, oy:originY},
          });
        })
      };
    };

    const _o_onFocus = (_e) => { // PCでは不要な処理のため、keyboard が表示されたときの配置調整は、textinput ではなく、画面ごとに行う
      if (_so_textInput) {
        _so_textInput.measure((originX, originY, width, height, pageX, pageY) => { // 選択した inp の位置を保存
          global.t?.setState({
            sgcd_inpMsrs: {x:pageX, y:pageY, w:width, h:height, ox:originX, oy:originY},
          });
        })
      };
      if (pd.state) { // clds ではない場合
        if (pd.o_onFcs) pd.o_onFcs();
      }
      else { // clds の場合＋（sch等の）通常の入力欄の場合
        if (pd.o_onFcsAsCld) pd.o_onFcsAsCld(_s_val, pd.d_ids);
      };
    };

    const _o_onLayout = () => {
      if (bf.f(_so_textInput) && pd.b_fcs == true) {
        _so_textInput.focus();
      };
      if (pd.o_onLay) {
        pd.o_onLay();
      };
    };

    const _stlTextInput = {
      minHeight: 
        (pd.n_row) ? 
          ic.s(pd.n_row)
        : (pd.b_mln) ? 
          (ic.gn_fontSizeNrm * 3 + ic.gn_mgnSml * 4 + ic.gn_bdrWNrw * 1.5 * 2) 
        : ic.s(2),
      width: (pd.n_col) ? ic.s(pd.n_col) : null,
      maxWidth: global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2 - ic.gn_scbW,
      color: (pd.b_rvs == true) ? ic.g_backCcd :ic.g_fontCcdNrm,
      fontSize: ic.gn_fontSizeNrm,
      borderWidth: ic.gn_bdrWNrw * 1.5,
      borderColor: 
        (pd.b_rvs == true) ? 
          ic.g_backCcd 
        : (pd.b_edit == true) ? 
          ic.g_bdrCcd 
        : 
          'transparent'
      ,
      borderRadius: ic.gn_bdrRdsNrm,
      marginLeft: 
        (pd.n_mgnLeft) ?
          pd.n_mgnLeft
        : (pd.b_row) ? 
          ic.gn_mgnNrm
        : ((pd.n_lyr || 1) > 1) ? 
          'auto'
        : 0,
      marginRight: 0,
      paddingTop: ic.gn_mgnSml,
      paddingBottom: ic.gn_mgSml,
      paddingLeft: ic.gn_mgnSml * 2,
      paddingRight: ic.gn_mgnSml * 2,
      borderRadius: (pd.b_mln || pd.b_bdr != false) ? ic.gn_bdrRdsNrm : 0,
      textAlign: pd.aln ?? 'left',
      textAlignVertical: (cf.myRN_chk_os('a') && pd.b_mln) ? 'top' : null,
      ...pd.d_stlInps,
    };

/*
          <ce.Lbl
            key={-1}
            pfx={pd.pfx}
            stlPfx={{
              ...pd.stlLbl, // 廃止予定 InpTree の lbl はここではない
              ...pd.d_stlLblPfxs, // 廃止予定
              ...pd.d_lbls?.d_stlPfxs,
            }}
            d_stlCtas={{
              ...pd.d_stlLblCtas, // 廃止予定
              ...pd.d_lbls?.d_stlCtas,
            }}
            b_row={pd.b_row}
            b_rvs={pd.b_rvs}
          />
 */

//ff.l('1696: {}, {}'.f(pd.pfx, _stlTextInput.marginLeft))
//ff.l('1699: {}, {}'.f(_s_val, pd.b_tail))
    return (
      ce.c(View, {
        key: -1,
        style: {
          width: pd.n_w,
          marginTop:  0,
          marginBottom: 0,
          marginLeft: 0,
          marginRight: 0,
          flexDirection: (pd.b_row) ? 'row' : 'column',
          justifyContents: (pd.b_row) ? 'flex-start' : 'flex-start',
          alignItems: (pd.b_row) ? 'flex-start' : 'flex-start',
          ...pd.stlCta, // 廃止予定
          ...pd.d_stlCtas,
        }
      }, [
        (pd.pfx) ?
          ce.c(ce.Lbl, {
            key: -1, 
            pfx: pd.pfx,
            d_stlPfxs: {
              ...pd.stlLbl, // 廃止予定 InpTree の lbl はここではない
              ...pd.d_stlLblPfxs, // 廃止予定
              ...pd.d_lbls?.d_stlPfxs,
            },
            d_stlCtas: {
              ...pd.d_stlLblCtas, // 廃止予定
              ...pd.d_lbls?.d_stlCtas,
            },
            b_row: pd.b_row,
            b_rvs: pd.b_rvs,
            ...pd.d_lbls,
          })
        : null,
        ce.c(View, {
          key: -2,
          style: {
            flexDirection: 'row',
            justifyContents: 'flex-start',
            alignItems: 'center',
          },
        }, [
          (
          (pd.b_edit == true && pd.mode != 'pck') ? 
            <TextInput
              key={-2}
              editable={pd.b_edit}
              placeholder={pd.phd}
              multiline={pd.b_mln}
              selectTextOnFocus={true}
              style={[_stlTextInput, {
              }, pd.stlInp]}
              ref={(_o) => {
                _setTextInput(_o);
              }}
              value={_s_val}
              onBlur={_o_onBlur}
              onChangeText={_o_onChangeText}
              onContentSizeChange={_o_onContentSizeChange}
              onFocus={_o_onFocus}
              onLayout={_o_onLayout}
              keyboardType={pd.kbdType}
              placeholderTextColor={(pd.b_row) ? ic.g_backCcd : ic.g_fontCcdNrm}
              secureTextEntry={(pd.b_pwd) ? true : false}
            />
          : (pd.b_edit == true && pd.mode == 'pck') ?
            <View
              key={-1}
            >
              <TouchableOpacity
                key={-2}
                onPress={async ()=>{
                  if (pd.o_rlcFldPrs){
                    pd.o_rlcFldPrs();
                  }
                  else {
                    if (pd.o_onFldPrs){
                      await pd.o_onFldPrs(); // await しないと選択項目が表示されない
                    };
                    global.t?.setState({
                      sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next =>{
                        let _id = bf.myCM_gnr(10);
                        _setId(_id);
                        _next[pd.mdlType] = {
                          id: _id,
                          ld_iss: pd.ld_iss,
                          b_showMdl: true,
                          d_tmps: {},
                          ...pd.d_mdls,
                        };
                      }),
                    });
                  };
                }}
              >
                <Text
                  numberOfLines={
                    (pd.b_tail) ? 
                      1 
                    : null
                  }
                  ellipsizeMode={
                    (pd.b_tail) ? 
                      'tail' 
                    : null
                  }
                  style={[_stlTextInput, {
                    }, pd.stlInp]} >{(pd.o_stlVal) ? pd.o_stlVal(_s_val) : _s_val }</Text>
              </TouchableOpacity>
              { (pd.d_btns?.o_onClrPrs || pd.d_btns?.o_onClrPrsAsCld) ?
                <ce.BtnIcon
                  key={-3}
                  b_vsb={true}
                  iconName={'remove'}
                  o_onPrs={
/*
                    (pd.state) ?
                      ()=>{
ff.l('ce 1838: here');
                        if (pd.d_btns?.o_onClrPrs) {
//                          pd.d_btns?.o_onClrPrs(pd.d_ids);
                          pd.d_btns?.o_onClrPrs();
                        };
                      }
                    : (pd.d_btns?.o_onClrPrsAsCld) ?
                      ()=>{
ff.l('ce 1846: here');
                        if (pd.d_btns?.o_onClrPrsAsCld) {
                          pd.d_btns?.o_onClrPrsAsCld();
                        };
                      }
                    : null
*/
                    (pd.state) ?
                      ()=>{
//ff.l('ce 1838: here');
                        if (pd.d_btns?.o_onClrPrs) {
//                          pd.d_btns?.o_onClrPrs(pd.d_ids);
                          pd.d_btns?.o_onClrPrs();
                        };
                      }
                    :
                      ()=>{
//ff.l('ce 1846: here');
                        if (pd.d_btns?.o_onClrPrsAsCld) {
                          pd.d_btns?.o_onClrPrsAsCld();
                        };
                      }
                  }
                  stlCta={[{
                    position: 'absolute',
                    top: ic.gn_mgnNrm, // boderWidth 分を追加
                    right: ic.gn_mgnNrm,
                  }, pd.d_btns?.clrStlCta]}
                  stlBtn={[{
                    backgroundColor: 'transparent',
//                    backgroundColor: 'black',
                  }, pd.d_btns?.clrStlBtn]}
                  stlIcon={[{
                    color: (pd.b_rvs == true) ? ic.g_backCcd : ic.g_fontCcdNrm,
                  }, pd.d_btns?.clrStlIcon]}
                  n_btnIconSize={ic.gn_fontSizeLrg}
                />
              : null }
            </View>
          : (pd.o_onPrs) ? 
            <TouchableOpacity
              key={-2}
              onPress={() => {
                if (pd.state) {
                  pd.o_onPrs();
                }
                else {
                  pd.o_onPrs(pd.d_ids);
                };
              }}            
            >
            {
              ce.c(Text, {
                key: -1,
                numberOfLines: (pd.b_tail) ? 1 : null,
                ellipsizeMode: (pd.b_tail) ? 'tail' : null,
                style: [_stlTextInput, {
                  color: ic.o_getCcd('t'), 
                  fontWeight: 'bold',
                  textDecorationLine: 'underline',
                }, pd.stlInp],
              }, (pd.o_stlVal) ? pd.o_stlVal(_s_val) : _s_val
              )
            }
            </TouchableOpacity>
          :
/*
            ce.c(View, {
              key: -3,
              style: {
                flexDirection: 'column',
                justifyContents: 'center',
                alignItems: 'center',
              },
            }, [
              ce.c(Text, {
                  key: -1,
                  style: [_stlTextInput, {
                  }, pd.stlInp], 
              }, [ 
                ce.c(Text, {
                  key: -1,
                  numberOfLines: (pd.b_tail) ? 1 : null,
                  ellipsizeMode: (pd.b_tail) ? 'tail' : null,
                }, (pd.o_stlVal) ? pd.o_stlVal(_s_val) : _s_val )
              ])
            ])
*/
            ce.c(View, {
              key: -3,
              style: {
                flexDirection: 'column',
                justifyContents: 'center',
                alignItems: 'center',
              },
            }, [
              ce.c(Text, { // Text が階層化されていると ellipsizeMode が機能しない？
                key: -1,
                numberOfLines: (pd.b_tail) ? 1 : null,
                ellipsizeMode: (pd.b_tail) ? 'tail' : null,
                style: [_stlTextInput, {
//                  backgroundColor: (pd.b_tail) ?  'red' : 'blue',
                }, pd.stlInp], 
              }, (pd.o_stlVal) ? pd.o_stlVal(_s_val) : _s_val )
            ])
          ),
          (pd.bsd) ? // backside
            ce.c(Text, {
              key: -5,
              style: [{
                color: ic.g_fontCcdSml,
                fontSize: ic.gn_fontSizeSml,
                marginLeft: ic.m(1),
              }, pd.stlBsd],
            }, pd.bsd)
          : null
        ]),
        (pd.d_btns?.o_onBtnPrs) ?
          <ce.BtnIcon
            key={-3}
            b_vsb={true}
            iconName={pd.d_btns?.btnIconName}
            o_onPrs={()=>{
              if (pd.d_btns?.o_onBtnPrs) {
                pd.d_btns?.o_onBtnPrs(pd.d_ids);
              };
            }}
            stlCta={[{
              position: 'absolute',
              top: ic.gn_mgnNrm + ic.gn_bdrWNrw * 1.5 / 2, // boderWidth 分を追加
              right: (pd.d_btns?.o_onDltPrs) ? (ic.gn_mgnNrm + ic.gn_btnIconSize + ic.gn_mgnNrm) : ic.gn_mgnNrm,
              backgroundColor: ic.gn_backCcd,
            }, pd.d_btns?.btnStlCta]}
            stlBtn={[{
            }, pd.d_btns?.btnStlBtn]}
            stlIcon={[{
            }, pd.d_btns?.btnStlIcon]}
          />
        : null,
        (pd.d_btns?.o_onDltPrs) ?
          <ce.BtnIcon
            key={-4}
            b_vsb={true}
            iconName={'trash'}
            o_onPrs={()=>{
              if (pd.d_btns?.o_onDltPrs) {
                pd.d_btns?.o_onDltPrs(pd.d_ids);
              };
            }}
            stlCta={{
                position: 'absolute',
                top: (pd.b_mln) ? null : (ic.gn_mgnSml + ic.gn_bdrWNrw), // boderWidth 分を追加
                bottom: (pd.b_mln) ? ic.gn_mgnSml : (ic.gn_mgnSml + ic.gn_bdrWNrw), // b_mln の場合は下端に表示
                right: ic.gn_mgnSml,
                backgroundColor: ic.gn_backCcd,
            }}
          />
        : null,
        (pd.sfx) ? // suffix
          <Text
            key={-6}
            style={[{
              position: 'absolute',
              bottom: 0,
              right: 0,
              color: ic.g_ccdHN,
              fontSize: ic.gn_fontSizeSml,
              textAlign: 'right',
            }, pd.stlSfx]}
          >{pd.sfx}</Text>
        : null,
        (pd.d_btns?.o_onHdrPrs) ?
          <ce.BtnIcon
            key={-7}
            b_vsb={true}
            iconName={pd.d_btns?.hdrIconName}
            o_onPrs={()=>{
              if (pd.d_btns?.o_onHdrPrs) {
                pd.d_btns?.o_onHdrPrs(pd.d_ids);
              };
            }}
            stlIcon={{
              color: 'orange',
            }}
            stlBtn={{
              backgroundColor: ic.gn_backCcd,
            }}
            stlCta={{
              position: 'absolute',
              zIndex: ic.gn_zIdxBdy + 1,
              top: ic.gn_mgnNrm, // boderWidth 分を追加
              right: 0,
              backgroundColor: ic.gn_backCcd,
            }}
          />
        : null,
      ])
    );
});

  static Lbl (pd) {
    if (pd.b_vsb == false) return null;
//ff.l('ce 1966: {}, {}'.f(pd.pfx, pd.b_rqr))
//ff.l('ce 1989: {}, {}, {}'.f(pd.d_stlLbls, pd.d_stlPfxs, pd.d_lbls))
    return (
      <View
        key={(pd.idx) ? pd.idx : -1}
        style={{
          height: (pd.b_row) ? (ic.gn_fontSizeNrm + ic.gn_mgnNrm / 2 * 2 + ic.gn_bdrWNrw * 1.5 * 2) : (ic.gn_fontSizeSml + ic.gn_mgnNrm / 2 * 2),
          width: 
            (pd.n_w) ?
              pd.n_w
            : (pd.n_col) ? 
              ic.s(pd.n_col) 
            : null,
          marginTop: 
            (pd.n_mgnTop) ?
              pd.n_mgnTop
            : (pd.b_row) ? 
              'auto' 
            : ic.gn_mgnSml,
          marginBottom: (pd.b_row) ? 'auto' : 0,
          marginLeft: ic.gn_mgnSml,
          marginRight: 0,
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          ...pd.stlCta, // 廃止予定
          ...pd.d_stlCtas,
        }}
      >
        {
        (pd.o_onBtnPrs) ?
          ce.c(TouchableOpacity, {
            key: -10,
            onPress: pd.o_onBtnPrs,
            accessible: false,
            style: {
              ...pd.d_stlLbls
            }
          }, 
            ce.c(Text, {
              key: -1,
              style: {
                fontSize: ic.gn_fontSizeSml,
/*
                color: 
                  (pd.b_rqr) ?
                    ic.o_getCcd('e') 
                  : (pd.b_rvs) ? 
                    ic.o_getCcd('b') 
                  : ic.o_getCcd('d'),
*/
                color: 
                  (pd.b_rvs) ? 
                    ic.o_getCcd('b') 
                  : ic.o_getCcd('d'),
                paddingTop: 'auto',
                paddingBottom: 'auto',
                paddingLeft: 0,
                paddingRight: 0,
                fontWeight: 'bold',
                ...pd.stlPfx,
                ...pd.d_stlPfxs,
              },
            }, pd.pfx )
          )
        :
          ce.c(View, {
            key: -10,
            style: {
              ...pd.d_stlLbls
            }
          }, 
            ce.c(Text, { // here
              key: -1,
              style: {
                fontSize: ic.gn_fontSizeSml,
                color: 
                  (pd.b_rvs) ? 
                    ic.o_getCcd('b') 
                  : ic.o_getCcd('d'),
                paddingTop: 'auto',
                paddingBottom: 'auto',
                paddingLeft: 0,
                paddingRight: 0,
                fontWeight: 'bold',
                ...pd.stlPfx,
                ...pd.d_stlPfxs,
              },
            }, pd.pfx )
          ) 
        }
        {
        (pd.b_rqr == true) ?
          ce.c(Text, {
            key: -20,
            style: {
              position: 'absolute',
              zIndex: ic.gn_zIdxBdy + 1,
              top: ic.m(-2),
              right: ic.m(1.5),
              color: ic.o_getCcd('e'),
            },
          }, '＊')
        : null
        }
        { (pd.d_btns) ? 
          <ce.BtnIconPfx
            key={-2}
            pfx={pd.d_btns.iconPfx}
            b_vsb={(pd.d_btns.b_vsb != false && pd.d_btns.o_onPrs) ? true : false}
            b_row={true}
            iconName={(pd.d_btns.iconName) ? pd.d_btns.iconName : 'ellipsis-v'}
            o_onPrs={pd.d_btns.o_onPrs}
            ccd={ic.o_getCcd('t')}
          />
        :
          <ce.BtnIcon
            key={-3}
            b_vsb={(pd.b_btnVsb != false && pd.o_onBtnPrs) ? true : false}
            iconName={(pd.iconName) ? pd.iconName : 'ellipsis-v'}
            o_onPrs={pd.o_onBtnPrs}
            stlCta={{
              marginTop: ic.gn_mgnNrm + ic.gn_bdrWNrm,
              marginLeft: ic.gn_mgnNrm,
            }}
            stlBtn={{
              height: ic.gn_btnIconSize * 0.6,
              width: ic.gn_btnIconSize * 0.6,
              backgroundColor: ic.g_bdyCcd,
            }}
            stlIcon={[{
              color: ic.o_getCcd('t'),
            }, pd.stlIcon]}
          />
        }
      </View>
    );
  }

/*
        { (pd.iconPfx) ? 
          <ce.BtnIconPfx
            key={-2}
            pfx={pd.iconPfx}
            b_vsb={(pd.b_btnVsb != false && pd.o_onBtnPrs) ? true : false}
            b_row={true}
            iconName={(pd.iconName) ? pd.iconName : 'ellipsis-v'}
            o_onPrs={pd.o_onBtnPrs}
            ccd={ic.o_getCcd('t')}
          />
 */

static Left (pd) {

  if (pd.b_vsb == false) return null;

  let _r = [];

  const _fnc1 = (pd_defs) => {
    if (pd_defs.sgc_pageName) { // 内部画面の場合
      let _d_pageInfs = { // pagePntKey の切り替えは Ftr では行わない
        sgc_pageRole: pd_defs.sgc_pageRole,
        sgc_pageName: pd_defs.sgc_pageName,
        sgc_pageMode: 'show',
      };
      cf.myRN_move_fwd(_d_pageInfs);
    };
    if (pd_defs.url) { // 外部URLの場合
      cf.myRN_open_url(pd_defs.url);
    };
  };

  if (global.t?.state.sgc_pageRole) {
    Object.keys(pd.dd_defss[global.t?.state.sgc_pageRole])
    .filter( _key => (pd.dd_defss[global.t?.state.sgc_pageRole][_key].b_vsb == false) ? false : true) // 表示対象外も定義可能とするために必要
    .map( _als => {
      let _d_defs = pd.dd_defss[global.t?.state.sgc_pageRole][_als];
      if (_d_defs.type == 'iconPfx'){
        _r.push(
          <ce.BtnIconPfx
            key={_als}
            iconName={_d_defs.iconName}
            pfx={_d_defs.pfx}
            o_onPrs={() => {
              if (_d_defs.fnc == 'logout') {
                cf.myRN_logout();
              }
              else {
                _fnc1(_d_defs);
              };
            }}
            n_cnt={(_d_defs.state) ? global.t?.state[_d_defs.state] : null}
            stlCta={{
              marginBottom: ic.gn_mgnNrm * 4,
            }}
          />
        );
      };
    });
  };

  if (bf.myCM_getLen(pd.dd_defss[global.t?.state.sgc_pageRole]) == 1) _r = []; // 要素が 1つの場合は表示しない, error が発生する場合は sgc_pageRole が誤っていないか確認

  return (
    <View style={[{ 
      position: 'absolute',
      zIndex: 20,
      top: ic.gn_bdyY,
      left: 0,
//      height: ic.gn_bdyH,
      height: global.t?.state.sgcd_dmns.n_bdyH,
      width: ic.gn_btnWSml,
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      backgroundColor: (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].ftrCcd : ic.gdd_ccdDefss.cmn.ftrCcd,
      padding: ic.gn_mgnNrm,
      borderTopWidth: ic.gn_bdrWNrm,
      borderTopColor: (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].ftrCcd : ic.gdd_ccdDefss.cmn.ftrCcd,
    }, pd.stlCta]}>
      {_r}
    </View>
  );
}

static CfmMdl(pd) { // confirm modal

  let _r = [];
  global.t?.state.sgcd_mdls.cfm.ld_btnss.map( (_d_btns, _idx) => {
    _r.push(
      ce.c(ce.Btn, {
        key: _idx,
        pfx: _d_btns.pfx,
        o_onPrs: () => {
          global.t?.setState({
            sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next =>{
              _next.cfm.b_showMdl = false;
            }),
          }, () => {
            if (_d_btns.o_onPrs) _d_btns.o_onPrs();
          });
        },
        stlCta: {
          width: ic.gn_btnWLrg,
        },
      })
    );
  });

//  let _w = global.t?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2;
//  _w = (_w > ic.gn_minBdyW * 2) ? ic.gn_minBdyW * 2 : _w;

  _r = ce.c(View, {
    key: -2,
    style: {
      width: global.t?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2 - ic.gn_scbW,
      maxWidth: ic.gn_minBdyW * 2,
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      marginTop: ic.s(1),
      marginBottom: ic.s(1),
    },
  }, _r);

  return (
    ce.c(ce.Mdl, {
      key: 'CfmMdl',
      mdlType: 'cfm',
    }, [
      ce.c(ce.Msg, {
        key: -1,
        pfx: global.t?.state.sgcd_mdls.cfm.msg,
        stlCta: bf.c({
//          width: _w - ic.gn_mgnNrm * 2 - ic.gn_scbW - ic.gn_mgnNrm * 2,
          width: global.t?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2 - ic.gn_scbW,
          maxWidth: ic.gn_minBdyW * 2,
          marginLeft: ic.gn_mgnNrm,
          marginRight: ic.gn_mgnNrm,
          flexDirection: 'column',
          justifyContnt: 'center',
          alignItems: 'center',
        }),
      }),
      _r
    ])
  );
};

static Chk = pd => { // checkbox

  const [_sb_val, _setVal] = useState(pd.b_val ?? false);

  useEffect(() => {
    _setVal((pd.n_val == 1) ? true : false)
  }, [pd.n_val])

/*
  useEffect(() => {
    if (pd.state) {
      let _state = (_sb_val == true) ? 1 : 0;
      if (_state != global.t?.state[pd.state]) {
        global.t?.setState({
          [pd.state]: _state,
        })
      }
    };
  }, [_sb_val])
*/

  useEffect(() => {
    let _b = (global.t?.state[pd.state] == 1) ? true : false;
    if ( _b != _sb_val) _setVal(_b);
  }, [global.t?.state[pd.state]])

  return (
    (pd.frm != 'sqr') ? 
      ce.c(TouchableOpacity, {
        key: 'Chk',
        onPress: () => {
          if (pd.b_edit != false) {
            let _b_val = !_sb_val; // 並行処理に必要
            _setVal(_b_val);
            if (pd.o_onChg) pd.o_onChg(_b_val ? 1 : 0);
          };
        },
        style: [{
          width: ic.s(2),
          marginTop: 'auto',
          marginBottom: 'auto',
          flexDirection: 'column',
          jusityContent: 'center',
          alignItems: 'center',
        }, pd.stlCta]
      }, [
        ce.c(View, {
          key: '-1',
          style: {
            height: ic.s(1),
            width: ic.s(1),
            borderColor: (pd.b_edit != false) ? ic.g_fontCcdNrm: ic.g_ccdWN,
            borderWidth: ic.gn_bdrWNrm,
            backgroundColor: (_sb_val) ? ic.g_fontCcdNrm : null,
            borderRadius: ic.gn_fontSizeNrm / 2,
          },
        }, [])
      ])
    : (pd.frm == 'sqr' && ff.f(pd.bsd) == false) ? 
      ce.c(Checkbox, {
        disabled: false,
        value: _sb_val,
        onChange: () => {
          if (pd.b_edit != false) { //disabled 時の color を変更できないため
            let _b_val = !_sb_val;
            _setVal(_b_val);
            if (pd.o_onChg) {
                pd.o_onChg(_b_val ? 1 : 0);
            };
            if (pd.o_onChgAsCld) {
                pd.o_onChgAsCld(_b_val ? 1 : 0);
            };
          }
        },
        color: pd.ccd ?? ic.o_getCcd('d'),
        style: {
          height: ic.s(1.2),
          width: ic.s(1.2),
          margin: ic.gn_mgnLrg,
          ...pd.d_stlChks,
        },
      })
    : (pd.frm == 'sqr' && ff.f(pd.bsd) == true) ? 
      ce.c(View, {
        key: 'Chk.cta',
        style: {
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          ...pd.d_stlCtas, 
        },
      }, [
        ce.c(Checkbox, {
          key: -10,
          disabled: false,
          value: _sb_val,
          onChange: () => {
            if (pd.b_edit != false) { //disabled 時の color を変更できないため
              let _b_val = !_sb_val;
              _setVal(_b_val);
              if (pd.o_onChg) {
                  pd.o_onChg((_b_val == true) ? 1 : 0);
              };
              if (pd.o_onChgAsCld) {
                  pd.o_onChgAsCld((_b_val == true) ? 1 : 0);
              };
            }
          },
          color: pd.ccd ?? ic.o_getCcd('d'),
          style: {
            height: ic.s(1.2),
            width: ic.s(1.2),
            margin: ic.gn_mgnLrg,
            ...pd.d_stlChks,
          },
        }),
        ce.c(Text, {
          key: -20,
          style: {
            fontSize: ic.s(1),
//            color: ic.o_getCcd('d'),
//            fontWeight: 'bold',
          },
        }, pd.bsd)
      ])
    : null
  );
}

  static List = (pd={
  }) => { // 辞書型の場合、ソートできない？
    //
    if (pd.b_vsb == false) {
      return null;
    };
    //
    let _r = [];
    //
    let _ld_iss = {};
    if (pd.state) {
      _ld_iss = global.t?.state[pd.state];
    }
    else if (pd.ld_iss) {
      _ld_iss = pd.ld_iss;
    }
    else {
      return null;
    };
    //
    let _n_cnt = 0;
    let _n_sum = 0;
    let _pastDate = '';
    //
    for (let [_idx, _d_items] of bf.e(_ld_iss)) {
      //
      if (pd.sumFld && pd.dtmFld) {
        if (_pastDate != _d_items.val[pd.dtmFld].substr(0,10)) {
          if (_pastDate != '') {
            _n_cnt -= 1;
            _r.push(
              <View
                key={_n_cnt}
                style={{
                  height: 10 + ic.gn_bdrWNrw * 2,
                  width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                  marginTop: ic.gn_mgnLrg,
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  backgroundColor: '#e9e9e9',
                  borderWidth: ic.gn_bdrWNrw,
                  borderRadius: ic.gn_bdrRdsNrm,
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Text
                  key={-1}
                  style={{
                    fontSize: 10,
                    color: '#444444',
                  }}
                >
                  {'{} {}円'.f(_pastDate, _n_sum)}
                </Text>
              </View>
            );
          };
          _pastDate = _d_items.val[pd.dtmFld].substr(0,10)
          _n_sum = 0;
        };
        _n_sum += bf.n(_d_items.val[pd.sumFld]);
      };

      _r.push(
        <View
          key={_idx}
          style={{
            marginTop: ic.gn_mgnSml,
            marginBottom: ic.gn_mgnSml,
            width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <View
            key={-1}
          >
            { (pd.b_chb == true) ?
              <ce.Chb
                key={-1}
                b_vsb={true}
                onChg={(_b_val)=>{
                  if (pd.o_onChk){
                    pd.o_onChk(_d_items, _b_val);
                  }
                  if (pd.state) {
                    global.t?.setState({
                      [pd.state]: bf.p(global.t?.state[pd.state], _next => {
                        let _d_is = ff.myCM_getDny({mode: 'is', ld_iss:_next, fld: 'key', val: _d_items.key});
                        _d_is.b_chk = _b_val;
                      }),
                    }, () => {
                    });
                  };
                }}
                stlCta={{
                }}
              />
            : null }
            <TouchableOpacity
              key={-2}
              onPress={()=>{
                if (pd.o_onPrs && pd.b_prs != false) {
                  pd.o_onPrs(_d_items, _idx);
                };
              }}
            >
              <View
                key={-1}
                style={{
                  width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW - ((pd.b_chb) ? ic.g_chbW : 0),
                  paddingTop: ic.gn_mgnLrg,
                  paddingBottom: ic.gn_mgnLrg, // 0 is good for chat
                  paddingLeft: ic.gn_mgnNrm, // 0 is good for chat
                  paddingRight: ic.gn_mgnNrm,
                  borderWidth: 1,
                  borderColor: (pd.b_prs == true && pd.b_bdr != false) ? '#bbbbbb' : ic.g_ccdWN,
                  borderRadius: 0,
                  backgroundColor: (_d_items.backCcd) ? _d_items.backCcd : null,
                }}
              >
                <View
                  key={-1}
                >
                  { (pd.b_img) ? // (_d_items.uri) ?
                    <ce.Img
                      key={-1}
                      stlCta={{
                        height: ic.gn_iconSizeLrg,
                        width: ic.gn_iconSizeLrg,
                        marginTop: ic.gn_mgnNrm,
                        marginBottom: 'auto',
                        marginLeft: 0,
                        marginRight: ic.gn_mgnNrm,
                      }}
                      stlImg={{
                        width: ic.gn_iconSizeLrg,
                        height: ic.gn_iconSizeLrg,
                      }}
                      uri={_d_items.uri}
                      msg={_d_items.pfx.replace(/ /g, '').replace(/　/g, '').substring(0,2)}
                    />
                  : null}
                  <View
                    key={-2}
                    style={{
                      width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 4 - ic.gn_scbW - ((pd.b_chb) ? ic.g_chbW : 0) - ((!bf.f(_d_items.uri) == false) ? ic.gn_iconSizeLrg + ic.gn_mgnNrm : 0)
                    }}
                  >
                    <Text
                      key={-1}
                      style={{
                        fontSize: ic.gn_fontSizeNrm,
                        color: ic.g_fontCcdNrm,
                      }}
                    >
                      {_d_items.pfx}
                    </Text>
                    <Text
                      key={-2}
                      style={[{
                        fontSize: ic.gn_fontSizeSml,
                        color: ic.g_fontCcdSml,
                        marginRight: ic.gn_mgnNrm,
                        marginLeft: 'auto',
                      }]}
                    >
                      {_d_items.spf}
                    </Text>
                  </View>
                </View>
              </View>
            </TouchableOpacity>
          </View>
        </View>
      );
    };
    //
    if (pd.sumFld && pd.dtmFld) {
      _n_cnt -= 1;
      _r.push(
        <View
          key={_n_cnt}
          style={{
            height: 10 + ic.gn_bdrWNrw * 2,
            width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
            marginTop: ic.gn_mgnLrg,
            marginLeft: 'auto',
            marginRight: 'auto',
            backgroundColor: '#e9e9e9',
            borderWidth: ic.gn_bdrWNrw,
            borderRadius: ic.gn_bdrRdsNrm,
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Text
            key={1}
            style={{
              fontSize: 10,
              color: '#444444',
            }}
          >
            {'{} {}円'.f(_pastDate, _n_sum)}
          </Text>
        </View>
      );
    };
    //
    return (
      <View
          key={-1}
          style={{
          }}
      >
        <ce.Lbl
          key={-1}
          b_vsb={(bf.f(pd.pfx)) ? true : false}          
          pfx={pd.pfx}
          stlCta={{
          }}
          stlPfx={{
//              fontSize: ic.gn_fontSizeLrg,
//              color: ic.g_fontCcdLrg,
          }}
          iconName={pd.iconName}
          onBtnPrs={pd.o_onBtnPrs}
        />
        {_r}
      </View>
    );
  }

    static ListBean (pd) {
        //
        let _n_col = 4; // 列数
        let _n_w = (global.t?.state.sgcd_dmns.n_w - ic.gn_scbW - ic.gn_mgnNrm * ( _n_col + 1)) / _n_col; 
        //
        let _r = [];
        bf.myCM_for_each(global.t?.state[pd.state], (_d_items) => {
            _r.push(
                <View
                    style={{
                        height: ic.gn_fontSizeSml + ic.gn_mgnNrm * 2,
                        width:  _n_w + ic.gn_fontSizeNrm,
                        margin: ic.gn_mgnNrm / 2,
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <View
                        style={{
                            height: ic.gn_fontSizeSml + ic.gn_mgnNrm * 2,
                            width: _n_w,
                            borderWidth: ic.gn_bdrWNrw,
                            borderRightWidth: 0,
                            borderColor: ic.g_bdrCcd,
                            borderTopLeftRadius: ic.gn_bdrRdsLrg,
                            borderBottomLeftRadius: ic.gn_bdrRdsLrg,
                            marginLeft: ic.gn_mgnNrm / 2,
                            marginRight: 0,
                            paddingHorizontal: ic.gn_mgnNrm,
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Text
                            style={{
                                color: ic.g_fontCcdNrm,
                                fontSize: ic.gn_fontSizeSml,
                            }}
                            numberOfLines={1}
                            ellipsizeMode='tail'
                        >
                            {_d_items.pfx}
                        </Text>
                    </View>
                    <TouchableOpacity
                        onPress={() => {
                            (pd.o_onPrs) ? pd.o_onPrs(_d_items) : null
                        }}
                    >
                        <View
                            style = {{
                                height: ic.gn_fontSizeSml + ic.gn_mgnNrm * 2,
                                width: ic.gn_fontSizeNrm,
                                borderWidth: ic.gn_bdrWNrw,
                                borderLeftWidth: 0,
                                borderColor: ic.g_bdrCcd,
                                borderTopRightRadius: ic.gn_bdrRdsLrg,
                                borderBottomRightRadius: ic.gn_bdrRdsLrg,
                                marginLeft: 0,
                                marginRight: ic.gn_mgnNrm / 2,
                            }}
                        >
                            <Text
                                style={{
                                    color: ic.g_fontCcdNrm,
                                    fontSize: ic.gn_fontSizeSml,
                                }}
                            >
                                ×
                            </Text>
                        </View>
                    </TouchableOpacity>
                </View>
            );
        });
        //
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <ScrollView
                        contentContainerStyle={[{
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            borderWidth: 0,
                            margin: 0,
                            padding: 0,
                        }]}
                        showsVerticalScrollIndicator={true}
                    >
                        <View
                            style={{
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                            }}
                        >
                            {_r}
                        </View>
                    </ScrollView>
                : null }
            </View>
        );
    }

/*
listcard の無限スクロールへの対応について <- useContext により改善される？
・本来は、listcard ごとに scroll bottom を判定し、追加で読み込むべきであるが、tecs では、下記の３点により対応を見送る
・rootlist が複数の listcart に対応していることから、
　listcard を横方向スクロールとする必要がある
・body ではなく listcard の scrollview をもとにスクロールするよう変更する必要がある
・listcard にイベントを送るため、例えば、listcard に 表示行数等の state を保持し、
　その state を rootlist において更新する必要がある？　←　いらなくなるかも

*/

    static ListCard (pd) {
        //
        let _n_col = (!bf.f(pd.n_col) == false) ? pd.n_col : 2;
        let _n_cnt = 0;
        let _n_w = (((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * (_n_col + 1)) / _n_col;
        //
        let _r1 = [];
        let _r2 = [];
        bf.myCM_for_each(global.t?.state[pd.state], (_d_items, _idx) => {
            _r1.push(
                <View
                    key={_idx}
                    style={{
                        marginTop: 0,
                        marginBottom: 'auto',
                        marginStart: 'auto',
                        marginEnd: 'auto',
                    }}
                >
                    <TouchableOpacity
                        onPress={()=>{
                            (pd.o_onPrs) ? pd.o_onPrs(_d_items) : null;
                        }}
                    >
                        <View style={{
                            width: _n_w,
                            borderWidth: 1,
                            borderColor: (pd.o_onPrs && pd.b_bdr != false) ? '#bbbbbb' : ic.g_ccdWN,
                            borderRadius: 0,
                            paddingTop: ic.gn_mgnLrg,
                            paddingBottom: ic.gn_mgnLrg, // 0 is good for chat
                            paddingLeft: ic.gn_mgnNrm / 2, // 0 is good for chat
                            paddingRight: ic.gn_mgnNrm / 2,
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                        }}>
                            { (pd.b_img) ?
                                <ce.Img
                                    b_edit={false}
                                    stlCta={{
                                        height: _n_w - ic.gn_mgnNrm,
                                        width: _n_w - ic.gn_mgnNrm,
                                        margin: 0,
                                    }}
                                    stlImg={{
                                        height: _n_w - ic.gn_mgnNrm,
                                        width: _n_w - ic.gn_mgnNrm,
                                    }}
                                    uri={_d_items.uri}
                                    msg={_d_items.pfx.replace(/ /g, '').replace(/　/g, '').substring(0,2)}
                                />
                            : null }
                            <View
                                style={{
                                    width: _n_w - ic.gn_mgnNrm,
                                }}
                            >
                                <Text
                                    style={{
                                        fontSize: ic.gn_fontSizeNrm,
                                        color: ic.g_fontCcdNrm,
                                        marginRight: 'auto',
                                        marginLeft: 'auto',
                                    }}
                                >
                                    {_d_items.pfx}
                                </Text>
                                <Text
                                    style={[{
                                        fontSize: ic.gn_fontSizeSml,
                                        color: ic.g_fontCcdSml,
                                        marginRight: 'auto',
                                        marginLeft: 'auto',
                                    }]}
                                >
                                    {_d_items.spf}
                                </Text>
                            </View>
                        </View>
                    </TouchableOpacity>
                </View>
            );
            //
            _n_cnt += 1;
            if ( _n_cnt >= _n_col ) {
                _n_cnt = 0;
                _r2.push(
                    <ce.Row
                        key={_idx}
                        style={{
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                        }}
                    >
                        {_r1}
                    </ce.Row>
                );
                _r1 = [];
            };
        });
        // 残り分
        _r2.push(
            <ce.Row
                key={-1}
                style={{
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                }}
            >
                {_r1}
            </ce.Row>
        );
        //
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <ScrollView
                        contentContainerStyle={[{
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            borderWidth: 0,
                            padding: 0,
                            width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                            marginTop: ic.gn_mgnNrm,
                            marginBottom: ic.gn_mgnNrm,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }]}
                        showsVerticalScrollIndicator={true}
                    >
                        <View>
                            <View>
                                { (pd.pfx) ?
                                    <ce.Row
                                        stlCta={{
                                            width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                                            marginTop: ic.gn_mgnNrm * 3,
                                            marginBottom: ic.gn_mgnNrm,
                                            marginLeft: 'auto',
                                            marginRight: 'auto',
                                            borderColor: ic.g_bdrCcd,
                                            borderBottomWidth: ic.gn_bdrWNrw,
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <ce.Lbl
                                            
                                            pfx={pd.pfx}
                                            stlCta={{
                                            }}
                                            stlPfx={{
                                                fontSize: ic.gn_fontSizeSml,
                                                color: ic.g_fontCcdSml,
                                                paddingTop: ic.gn_mgnNrm,
                                                paddingBottom: ic.gn_mgnNrm,
                                                paddingLeft: 0,
                                                paddingRight: 0,
                                                fontWeight: 'bold',
                                            }}
                                        />
                                        { (pd.b_menu) ?
                                            <TouchableOpacity
                                                onPress={()=>{
                                                    global.t?.setState({ // menu の表示
                                                        sgcb_menu: true
                                                    });
                                                }}
                                            >
                                                <View
                                                    style={{
                                                        height: ic.gn_fontSizeLrg + ic.gn_mgnNrm * 2,
                                                        width: ic.gn_fontSizeLrg + ic.gn_mgnNrm * 2,
                                                        backgroundColor: '#dddddd',
                                                        borderColor: '#dddddd',
                                                        borderRadius: (ic.gn_fontSizeLrg + ic.gn_mgnNrm * 2)/2,
                                                    }}
                                                >
                                                    <Icon
                                                        name="ellipsis-v"
                                                        type="FontAwesome"
                                                        underlayColor="transparent"
                                                        size={ic.gn_fontSizeLrg}
                                                        color={'#555555'}
                                                        style={{
                                                            marginTop: 'auto',
                                                            marginBottom: 'auto',
                                                            marginLeft: 'auto',
                                                            marginRight: 'auto',
                                                        }}
                                                    />
                                                </View>
                                            </TouchableOpacity>
                                        : null }
                                        { (pd.btnPfx) ?
                                            <ce.Btn
                                                b_vsb={true}
                                                pfx={pd.btnPfx}
                                                stlCta={{
                                                    width:ic.gn_fontSizeSml * 3,
                                                }}
                                                stlBtn={{
                                                    width:ic.gn_fontSizeSml * 3,
                                                    marginLeft: ic.gn_mgnNrm,
                                                    borderWidth: ic.gn_bdrWNrw,
                                                    borderColor: (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                                                    backgroundColor: (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                                                    padding: ic.gn_mgnSml,
                                                }}
                                                stlPfx={{
                                                    fontSize: ic.gn_fontSizeSml,
                                                    color: ic.g_ccdWN,
                                                }}
                                                o_onPrs={pd.o_onBtnPrs}
                                            />
                                        : null }
                                    </ce.Row>
                                : null }
                            </View>
                            {_r2}
                        </View>
                    </ScrollView>
                : null }
            </View>
        );
    }

  static ListChat (pd) {
    //
    let _r = [];
    //
    let _pastDate = '';
    let _pastTime = '';
    //
    let _cnt = 1; // 初期値分シフト
    //
    for (let [_idx, _d_items] of bf.e(global.t?.state[pd.state])) {

      if (_d_items.b_dlt == true) continue; // 20211003

      if (_pastDate != _d_items.time.substr(0,10)) {
        _cnt += 1;
        _r.push(
          <View
            key={_cnt}
            style={{
              height: 10 + ic.gn_bdrWNrw * 2,
              width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
              marginTop: ic.gn_mgnLrg,
              backgroundColor: '#e9e9e9',
              borderWidth: ic.gn_bdrWNrw,
              borderRadius: ic.gn_bdrRdsNrm,
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Text
              key={1}
              style={{
                fontSize: 10,
                color: '#444444',
              }}
            >
              {_d_items.time.substr(0,10)}
            </Text>
          </View>
        );
        //
        _pastDate = _d_items.time.substr(0,10)
      };
      //
      _cnt += 1;
      _r.push(
        <ce.Row
            key={_cnt}
            stlCta={{
              width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
              marginTop: 0,
              marginBottom: 0,
              marginLeft: 'auto',
              marginRight: 'auto',
              paddingTop: 0,
              paddingBottom: 0, // 0 is good for chat
              paddingLeft: 0, // 0 is good for chat
              paddingRight: 0,
              borderWidth: 0,
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            }}
        >
          { (pd.b_chk) ?
            ce.c(ce.Chk, { 
              key: -1,
              b_val: _d_items.b_chk ?? false,
              b_edit: (pd.ob_chk) ? pd.ob_chk(_d_items) : false, // ob_edit に変更要
              o_onChg: _b_val => {
                global.t?.setState({
                  [pd.state]: bf.p(global.t?.state[pd.state], _next => {
                    _next[_idx].b_chk = _b_val;
                  }),
                })
              },
              stlCta: {
                width: ic.gn_btnWSml,
              },
            })
          : null }
          { (pd.b_avt) ?
            <ce.Img
              key={1}
              stlCta={{
                height: ic.gn_iconSizeLrg,
                width: ic.gn_iconSizeLrg,
                marginTop: 0,
                marginBottom: 'auto',
                marginLeft: 0,
                marginRight: ic.gn_mgnNrm,
              }}
              stlImg={{
                height: ic.gn_iconSizeLrg,
                width: ic.gn_iconSizeLrg,
                marginTop: 0,
                marginBottom: 0,
                marginLeft: 0,
                marginRight: 0,
              }}
              uri={_d_items.uri}
            />
          : null }
          <View
            key={2}
            style={{
              flex: 1,
              marginTop: 0,
              marginBottom: 0,
              marginLeft: 'auto',
              marginRight: 'auto',
              paddingTop: 0,
              paddingBottom: 0,
            }}
          >
            { (_pastTime != _d_items.time.substr(0,16)) ?
              <Text
                key={1}
                style={{
                  width: '100%',
                  marginTop: ic.gn_mgnLrg,
                  fontSize: ic.gn_fontSizeSml * 0.85,
                  color: (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                  fontWeight: 'bold',
                }}
              >
                {_d_items.name}（{_d_items.time}）
              </Text>
            : null }
            <Text
              key={2}
              style={[{
                fontSize: ic.gn_fontSizeNrm,
                color: ic.g_fontCcdNrm,
                marginTop: 0,
                marginBottom: 0,
                minHeight: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2 + ic.gn_bdrWNrw * 1.5 * 2, // 20211003
              }]}
            >
              { (_d_items.type == 'msg') ? 
                <Text
                  key={1}
                  style={{
                    marginTop: 0,
                    marginBottom: 0,
                  }}
                >
                  {_d_items.msg}
                </Text>
              : (_d_items.type == 'file') ? 
                <ce.Link
                  key={1}
                  file={_d_items.file}
                  stlLink={{
                    color: '#ffaa00',
                  }}
                >
                  {_d_items.file.name}
                </ce.Link>
              : null }
              { (pd.b_edit == true) ? // 20211003
                <ce.BtnIcon
                  iconName={'trash'}
                  onPrs={()=>{
                    global.t?.setState({
                      [pd.state]: bf.p(global.t?.state[pd.state], _next => {
                        _next[_idx].b_dlt = true;
                      }),
                    })
                  }}
                  stlCta={{
                    position: 'absolute',
                    right: ic.gn_mgnNrm,
                    bottom: ic.gn_mgnNrm,
                  }}
                />
              : null }
            </Text>
          </View>
        </ce.Row>
      );
      //
      _pastTime = _d_items.time.substr(0,16);
    };
    //
    if (pd.b_vsb == false) {
      return null;
    }
    //
    return (
      <ScrollView
        key={-1}
        contentContainerStyle={[{
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center',
          borderWidth: 0,
          margin: 0,
          padding: 0,
        }]}
        showsVerticalScrollIndicator={true}
      >
        { (pd.pfx) ?
        <ce.Lbl
          key={-1}
          pfx={pd.pfx}
          stlCta={{
            width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
            marginTop: ic.gn_mgnLrg,
            marginBottom: ic.gn_mgnLrg,
            marginLeft: 'auto',
            marginRight: 'auto',
            borderColor: ic.g_bdrCcd,
            borderBottomWidth: ic.gn_bdrWNrw,
          }}
          stlPfx={{
            fontSize: ic.gn_fontSizeLrg,
            color: ic.g_fontCcdLrg,
          }}
        />
        : null }
        {_r}
      </ScrollView>
    );
  }

    static ListEnt (pd) { // list entry
        //
        if (pd.b_vsb == false) { // b_vsb == false の場合は非表示
            return null;
        }
        //
        let _r = [];
        //
        let _pastHdr = '';
        //
        let _cnt = 0;
        for (let [_key, _d_items] of bf.e(global.t?.state[pd.state])) {
            //
            _cnt += 1;
            if(_d_items.hdr == _pastHdr) {
            }
            else {
                _r.push(
                    <View
                        key={_cnt}
                        style={{
                            width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                            marginTop: ic.gn_mgnSml,
                            marginBottom: ic.gn_mgnSml,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }}
                    >
                        <ce.Msg
                            key={-1}
                            pfx={_d_items.hdr}
                            stlPfx={(pd.stlHdr) ? pd.stlHdr : null}
                        />
                    </View>
                );
            };
            //
            _pastHdr = _d_items.hdr;
            //
            _cnt += 1;
            _r.push(
                <View
                    key={_cnt}
                    style={{
                        width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                        marginTop: ic.gn_mgnSml,
                        marginBottom: ic.gn_mgnSml,
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    }}
                >
                    <ce.Msg
                        key={-1}
                        pfx={_d_items.msg}
                    />
                    <ce.Msg
                        key={-2}
                        pfx={'{}時点'.f(_d_items.dtm)}
                        stlPfx={{
                            fontSize: ic.gn_fontSizeSml,
                        }}
                    />
                    <ce.Inp
                        key={-3}
                        b_vsb={true}
                        b_edit={pd.b_edit}                        
                        state={null}
                        pfx={null}
                        b_mln={true}
                        ini={_d_items.ini}
                        phd={null}
                        onFcs={null}
                        onBlur={(_s) => {
                            global.t?.setState({
                                [pd.state]: bf.p(global.t?.state[pd.state], _next => {
                                    _next[_key].val = _s;
                                }),
                            });                            
                        }}
                        stlCta={null}
                        stlInp={null}
                    />
                </View>
            );
        };
        //
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <ScrollView
                        contentContainerStyle={[{
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            borderWidth: 0,
                            margin: 0,
                            padding: 0,
                        }, pd.stlCta]}
                        showsVerticalScrollIndicator={true}
                    >
                        <View
                            key={-1}
                        >
                            <View
                                key={-1}
                            >
                                { (pd.pfx) ?
                                <ce.Row
                                    key={-1}
                                    stlCta={{
                                        width: ((pd.n_w) ? pd.n_w : global.t?.state.sgcd_dmns.n_w) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                                        marginTop: ic.gn_mgnNrm * 3,
                                        marginBottom: ic.gn_mgnNrm,
                                        marginLeft: ic.gn_mgnNrm,
                                        marginRight: ic.gn_mgnNrm,
                                        borderColor: ic.g_bdrCcd,
                                        borderBottomWidth: ic.gn_bdrWNrw,
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                    }}
                                >
                                    <ce.Lbl
                                        key={-1}
                                        
                                        pfx={pd.pfx}
                                        stlCta={{
                                        }}
                                        stlPfx={{
                                            fontSize: ic.gn_fontSizeLrg,
                                            color: ic.g_fontCcdLrg,
                                        }}
                                    />
                                </ce.Row>
                                : null }
                            </View>
                            {_r}
                        </View>
                    </ScrollView>
                : null }
            </View>
        );
    }

static Ldr (pd) { // loader

  const [_sn_prsRate, _setPrsRate] = useState(0); 
  useEffect(() => {
    let _n = 
      ( global.t?.state.sgcd_prss.n_ttlCnt > 0 ) ? 
        global.t?.state.sgcd_prss.n_crrCnt / global.t?.state.sgcd_prss.n_ttlCnt * global.t?.state.sgcd_prss.n_wgt 
      : 0;
    _setPrsRate(_n);
  }, [
    global.t?.state.sgcd_prss.n_crrCnt,
    global.t?.state.sgcd_prss.n_ttlCnt,
  ]);

  if (global.t?.state[pd.state] != true) return null;

  return (
    ce.c(View, {
      key: 'Ldr.root',
      style: {
        position: 'absolute',
        zIndex: ic.gn_zIdxLdr,
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }
    }, [
      ce.c(View, {
        key: -1,
        style: {
          height: 100,
          width: 100,
          borderRadius: ic.gn_bdrRdsNrm,
          backgroundColor: '#eeeeee',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          // for border
          borderWidth: ic.gn_bdrWNrw,
          borderColor: '#eeeeee',
        }
      }, [
        ce.c(ActivityIndicator, {
          key: -1,
          animating: true,
          color: ic.o_getCcd('d'),
          size: "large",
        })
      ]),
      (global.t?.state.sgcd_prss.b_vsb) ? // progress
        ce.c(View, {
          key: -2,
          style: {
            height: 40,
            width: 200,
            borderWidth: 0,
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }
        }, [
          ce.c(View, {
            key: -1,
            style: {
              height: 10,
              width: 160,
              backgroundColor: ic.gn_backCcd,
              borderWidth: ic.gn_bdrWNrw,
              borderRadius: ic.gn_bdrRdsSml,
              borderColor: (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'flex-start',
            }
          }, [
            ce.c(View, {
              key: -1,
              style: {
                height: 10,
                width: 160 * _sn_prsRate / 100,
                backgroundColor: (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                borderWidth: ic.gn_bdrWNrw,
                borderRadius: ic.gn_bdrRdsSml,
                borderColor: (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
              }
            })
          ])
        ])
      : null
    ])
  );
}

static Srp = (pd={
}) => {

  const stripe = useStripe();
  const elements = useElements();

  const _onSmt = async event => {
    cf.s();
    event.preventDefault()
    const _body = JSON.stringify({ 
        name: event.target.name.value,
        id: event.target.id.value,
        amt: ff.n(String(event.target.amt.value).replace(' 円', '').replace(/,/g, '')),
        subDmn: myWB.myWB_getDmn().subDmn,
      });
    //ff.l('cd 3598: {}, {}'.f(_body, event.target.amt.value))
    //const res = await fetch("http://118.27.15.97:3004/createPaymentIntent", {
    //ff.l('cd 3600: {}, {}'.f(ic.g_url3, _body));
    const res = await fetch(ic.g_url3, {
      method: "POST",
      body: _body,
      headers: { "Content-Type": "application/json" },
    })
    const data = await res.json()
    const secret = data.client_secret
//    const card = elements.getElement(CardElement, {
    const card = elements.getElement(CardNumberElement, {
      style: {
        base: {
          fontSize: ic.s(2),
          color: 'black',
        }
      }
    })
    const result = await stripe.confirmCardPayment(secret, {
      payment_method: {
        card: card,
        billing_details: {
          name: "user name",
        },
      },
    })

    cf.h();
    if (result.error) {
        global.t?.setState({
          sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next => {
            _next.srp.b_showMdl = false;
          }),
        }, () => {
          alert(`${result.error.message}(${(result.error.code) ? result.error.code : ''}${(result.error.decline_code) ? ', ' + result.error.decline_code : ''})`)
          // https://stripe.com/docs/error-codes
          // https://stripe.com/docs/declines#issuer-declines
        });
    } else {
      if (result.paymentIntent.status === "succeeded") {
        global.t?.setState({
          sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next => {
            _next.srp.b_showMdl = false;
          }),
        }, () => {
          if (global.t?.state.sgcd_mdls.srp.onScd) global.t?.state.sgcd_mdls.srp.onScd();
        })
      }
    }
  }

  const _name = global.t?.state.sgcd_mdls.srp.name
  const _id = global.t?.state.sgcd_mdls.srp.id
  const _amt = global.t?.state.sgcd_mdls.srp.amt


//  return injectStripe(
//      onSubmit={_onSmt}
  return (

    <form
      key={'Srp.root'}
      style={{
        textAlign: 'center'
      }}
      onSubmit={_onSmt}
    >

      <View 
        key={-5}
        style={{
          width: ic.s(20),
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        <Text
          key={-10}
          for={'name'}
          style={{ 
            fontSize: ic.s(0.9),
            color: ic.g_ccdKN,
            textAlign: 'left',
          }}
        >
          カード番号・有効期限・CVC(カード記載の確認コード)を入力した後、「支払う」ボタンを押してください。（カード情報が本システム上に保存されることはありません）。
        </Text>
      </View>

      <View 
        key={-10}
        style={{
          width: ic.s(20),
          marginTop: ic.s(1.5),
          marginLeft: 'auto',
          marginRight: 'auto',
          paddingLeft: ic.s(1),
          paddingRight: ic.s(1),
          paddingBottom: ic.s(0.5),
          backgroundColor: ic.c('h'),
          borderRadius: ic.s(1),
          borderColor: ic.c('p'),
          borderWidth: ic.b(0.5),
        }}
      >

        <View 
          key={-10}
          style={{
            height: ic.s(2),
            width: '100%',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            marginTop: ic.s(0.25),
          }}
        >
          <Text
            key={-10}
            for={'name'}
            style={{ 
              fontSize: ic.s(0.9),
              fontWeight: 'bold',
              color: ic.c('d'),
            }}
          >
            団体名
          </Text>
        </View>
        <input
          key={-15}
          name={"name"}
          defaultValue={_name}
          style={{
            fontSize: ic.s(1),
            border: 0,
            backgroundColor: 'transparent',
          }}
          size={20}
          readOnly={true}
        />

        <View 
          key={-20}
          style={{
            height: ic.s(2),
            width: '100%',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            marginTop: ic.s(0.25),
          }}
        >
          <Text
            key={-10}
            style={{ 
              fontSize: ic.s(0.9),
              fontWeight: 'bold',
              color: ic.c('d'),
            }}
          >
            予約ID
          </Text>
        </View>
        <input
          key={-25}
          name={"id"}
          defaultValue={_id}
          style={{
            fontSize: ic.s(1),
            border: 0,
            backgroundColor: 'transparent',
          }}
          size={20}
          readOnly={true}
        />

        <View 
          key={-30}
          style={{
            height: ic.s(2),
            width: '100%',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            marginTop: ic.s(0.25),
          }}
        >
          <Text
            key={-10}
            style={{ 
              fontSize: ic.s(0.9),
              fontWeight: 'bold',
              color: ic.c('d'),
            }}
          >
            金額
          </Text>
        </View>
        <input
          key={-35}
          name={"amt"}
          defaultValue={`${ff.myCM_cnv('cmm', _amt)} 円`}
          style={{
            fontSize: ic.s(1),
            border: 0,
            backgroundColor: 'transparent',
          }}
          size={20}
          readOnly={true}
        />

      </View> 

      <View 
        key= {-20}
        style= {{
          width: ic.s(20),
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >

        <View 
          key={-10}
          style={{
            height: ic.s(2),
            width: '100%',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            marginTop: ic.s(1.5),
          }}
        >
          <Text
            key={-10}
            style={{ 
              fontSize: ic.s(0.9),
              fontWeight: 'bold',
              color: ic.c('d'),
            }}
          >
            カード番号
          </Text>
        </View>
        <div
          key={-15}
          style={
            {
              border: '1px solid gray',
              'border-radius': ic.s(0.25),
              paddingTop: ic.s(0.5),
              paddingBottom: ic.s(0.5),
              paddingLeft: ic.s(1),
              paddingRight: ic.s(1),
            }
          }
        >
          <CardNumberElement
            key={-15}
            options={{
              style: {
                base: {
                  color: ic.g_ccdKN,
                  fontSize: ic.s(1),
                  '::placeholder': {
                    color: '#CCCCCC',
                  },
                },
              },
            }}
          />
        </div>

        <View 
          key={-20}
          style={{
            height: ic.s(2),
            width: '100%',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            marginTop: ic.s(0.25),
          }}
        >
          <Text
            key={-10}
            style={{ 
              fontSize: ic.s(0.9),
              fontWeight: 'bold',
              color: ic.c('d'),
            }}
          >
            有効期限
          </Text>
        </View>
        <div
          key={-25}
          style={
            {
              border: '1px solid gray',
              'border-radius': ic.s(0.25),
              paddingTop: ic.s(0.5),
              paddingBottom: ic.s(0.5),
              paddingLeft: ic.s(1),
              paddingRight: ic.s(1),
            }
          }
        >
          <CardExpiryElement
            key={-25}
            options={{
              style: {
                base: {
                  color: ic.g_ccdKN,
                  fontSize: ic.s(1),
                  '::placeholder': {
                    color: '#CCCCCC',
                  },
                },
              },
            }}
          />
        </div>

        <View 
          key={-30}
          style={{
            height: ic.s(2),
            width: '100%',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            marginTop: ic.s(0.25),
          }}
        >
          <Text
            key={-10}
            style={{ 
              fontSize: ic.s(0.9),
              fontWeight: 'bold',
              color: ic.c('d'),
            }}
          >
            CVC(カード記載の確認コード)
          </Text>
        </View>
        <div
          key={-35}
          style={
            {
              border: '1px solid gray',
              'border-radius': ic.s(0.25),
              paddingTop: ic.s(0.5),
              paddingBottom: ic.s(0.5),
              paddingLeft: ic.s(1),
              paddingRight: ic.s(1),
            }
          }
        >
          <CardCvcElement
            key={-35}
            options={{
              style: {
                base: {
                  color: ic.g_ccdKN,
                  fontSize: ic.s(1),
                  '::placeholder': {
                    color: '#CCCCCC',
                  },
                },
              },
            }}
          />
        </div>

        <button
          key={-40}
          type={"submit"}
          style={{
            border: 0,
            backgroundColor: ic.c('d'),
            height: ic.s(2),
            color: ic.g_ccdWN,
            fontSize: ic.s(1),
            borderRadius: ic.gn_bdrRdsNrm,
            marginTop: ic.s(2),
            marginBottom: ic.s(1),
          }}
        >
          支払う
        </button>

      </ View>
    
    </form>
  );

};

/*
      <View 
        key={-40}
        style={{
          height: ic.s(2),
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center',
          marginTop: ic.s(1),
        }}
      >
        <Text
          key={-10}
          style={{ 
            width: ic.s(6),
            fontSize: ic.s(0.9),
            fontWeight: 'bold',
            color: ic.c('d'),
          }}
        >
          カード情報
        </Text>
      </View>

 */
/*
static SrpMdl = (pd={ // stripe
}) => {

  return null;

  const _plcKey = global.t?.state.sgcd_mdls.srp.plcKey;
ff.l('ce 3673: {}'.f(_plcKey));
  const stripePromise = loadStripe(_plcKey);

  return (
    ce.c(ce.Mdl, {
      key: 'Srp.root',
      mdlType: 'srp',
    }, (
      ce.c(Elements, {
        key: -10,
        stripe: stripePromise,
      }, [
        ce.c(ce.Srp, {
          key: -10,
        })
      ])
    ))
  );
};
*/

static SrpMdl = (pd={ // stripe
}) => {

  const [_srp, _setSrp] = React.useState(null);
  React.useEffect(() => {
    if (global.t?.state.sgcd_mdls.srp.plcKey) {
      const _plcKey = global.t?.state.sgcd_mdls.srp.plcKey;
      _setSrp(loadStripe(_plcKey));
    };
  }, [
    global.t?.state.sgcd_mdls.srp.plcKey
  ])
  return (
    _srp ?
    ce.c(ce.Mdl, {
      key: 'Srp.root',
      mdlType: 'srp',
//      d_cldStls: {
      stlMenu: {
        width: ic.s(22),
//        backgroundColor: 'red',
      },
    }, (
      ce.c(Elements, {
        key: -10,
//        stripe: stripePromise,
        stripe: _srp,
      }, [
        ce.c(ce.Srp, {
          key: -10,
        })
      ])
    ))
    : null
  );
};

static Mdl = (pd={
// mdl は root と同階層で定義する
// 仮に mdl を bdy 内で定義した場合、bdy 内部のスクロールに合わせて、mdl の表示位置が変わってしまう
// なお、root の zIdx は bdy の zIdx よらず打ち勝つため、root で定義した overlay を bdy 内の cpt で共有することはできない
}) => {

  if (global.t?.state.sgcd_mdls[pd.mdlType]?.b_showMdl != true) return null; // sgcd_mdls に mdlType が定義されていない場合、エラーとなる

//ff.l('3179: {}'.f(global.t?.state.sgcd_dmns.n_bdyW))

  return (
    ce.c(View, { // 背景
      key: 'Mdl.{}'.f(pd.mdlType),
      style: [{
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: ic.gn_zIdxMdl,
        backgroundColor: 'rgba(0,0,0,0.2)',
        height: ic.gn_h,
        width: global.t?.state.sgcd_dmns.n_w,
      }, pd.stlCta],
    }, [
      ce.c(View, {
        key: -1,
        style: [{
          backgroundColor: ic.g_ccdWN,
          maxHeight: (global.t?.state.sgcd_dmns.n_h - ic.gn_mgnNrm * 2),
          width: (global.t?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2),
          maxWidth: ic.gn_minBdyW * 2,
          borderRadius: ic.gn_bdrRdsNrm,
          marginTop: 'auto',
          marginBottom: 'auto',
          marginLeft: 'auto',
          marginRight: 'auto',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }, pd.stlMenu]
      }, [
        ce.c(ce.BtnIcon, { // 閉じるボタン
          key: -1,
          b_vsb: true,
          iconName: "close",
          o_onPrs: ()=>{
            if (pd.o_onCls) {
              pd.o_onCls()
            }
            if (pd.mdlType) {
              global.t?.setState({
                sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next => {
                  _next[pd.mdlType].b_showMdl = false;
                }),
              });
            }
          },
          stlCta: {
//            width: (global.t?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2),
            width: '100%',
            maxWidth: ic.gn_minBdyW * 2,
          }, 
          stlBtn: {
            backgroundColor: ic.gn_backCcd,
            marginLeft: 'auto',
            marginRight: 0,
          },
        }),
        ce.c(View, { // 表示要素
          key: -2,
          style: {
            maxHeight: (global.t?.state.sgcd_dmns.n_h - ic.gn_mgnNrm * 2) - ic.gn_btnIconSize - ic.gn_mgnNrm * 2,
            width: (global.t?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2),
            maxWidth: ic.gn_minBdyW * 2,
            marginTop: ic.gn_mgnNrm,
            marginBottom: ic.gn_mgnNrm,
            marginLeft: 0,
            marginRight: 0,
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
//            ...pd.d_cldStls,
          },
        }, [
          pd.children
        ])
      ])
    ])
  );
};

static Link (pd) {
  return (
    ce.c(Text, {
      key: 'Link',
      style: [{
        fontSize: ic.gn_fontSizeNrm,
        color: ic.o_getCcd('t'),
        textDecorationLine: 'underline',
      }, pd.stlLink], 
      onPress: async ()=>{
        if (bf.f(pd.url)) {
          if (cf.myRN_chk_os('w')) { // web の場合
            cf.myRN_open_url(pd.url);
          }
          else { // スマホ の場合
            let _fdr = await cf.myFS_get_rootFdr();
            await cf.myFS_make_fdr(_fdr);                                    
            let _name = _fdr + encodeURI(pd.children); // 日本語ファイル名への対応
            cf.myFS_open_url(pd.url, _name);
          };
        };
        if (bf.f(pd.file)) {
          if (!cf.myRN_chk_os('w')) {
            let _fdr = await cf.myFS_get_rootFdr();
            await cf.myFS_make_fdr(_fdr);                                    
            let _name = _fdr + encodeURI(pd.file.name); // 日本語ファイル名への対応
            cf.myFS_open_url(pd.file.url, _name); // FileSystem は WEB に対応していない。サーバー側でファイル名の変更が必要か
          }
          else {
            cf.myRN_open_url(pd.file.url);
            //Sharing.shareAsync(pd.file.url) // https 化すれば動く模様
          }
        };                    
        if (pd.o_onPrs) {
          pd.o_onPrs();
        };
      }
    }, [
      pd.children
    ])
  )
}

static Msg = (pd={
  b_vsb: true,
  pfx: '',
  n_pntW: 0,
  stlPfx: {},
  d_pfxStls: {},
  stlCta: {},
  d_ctrStls: {},
  n_lines: null,
  o_onPrs: null,
}) => {
  if (pd.b_vsb == false) {
    return null;
  };

  const _d_pfxStls = [
    {
      fontSize: ic.gn_fontSizeNrm,
      color: ic.g_fontCcdNrm,
    },
    (pd.o_onPrs) ?
    {
      color: ic.c('t'), 
      fontWeight: 'bold',
      textDecorationLine: 'underline',
    }
    : null,
    pd.stlPfx, // 廃止予定          
    pd.d_stlPfxs, // 廃止予定          
    pd.d_pfxStls,
  ];

  return (
    ce.c(View, {
      key: 'Msg.Root',
      style: { // width を指定した場合、中央表示とならない
        width: pd.n_w ?? ic.gn_bdyW - ic.m(2, true),
        maxWidth: ic.gn_minBdyW * 2,
        marginLeft: pd.n_mgnLeft ?? 'auto',
        marginRight: pd.n_mgnRht ?? 'auto',
        marginTop: pd.n_mgnTop ?? 0,
        marginBottom: pd.n_mgnBtm ?? 0,
        paddingLeft: pd.n_pdgLeft ?? 0,
        paddingRight: pd.n_pdgRht ?? 0,
        paddingTop: pd.n_pdgTop ?? 0,
        paddingBottom: pd.n_pdgBtm ?? 0,
        flexDirection: 'column',
        justifyContent: 'flex-start',
/*
        alignItems: 
          pd.aln == 'ctr' ? 
            'center' 
          : pd.aln == 'left' ? 
            'flex-start' 
          : pd.aln == 'rht' ? 
            'flex-end' 
          : 'flex-start',
*/
        ...pd.stlCta, // 廃止予定
        ...pd.d_stlCtas,
        ...pd.d_ctrStls,
      }
    }, [
      ce.c(Text, {
        key: -1,
        style: _d_pfxStls,
        numberOfLines: pd.n_lines,
        ellipsizeMode: 'tail',
        onPress: pd.o_onPrs,
      }, pd.pfx)
    ])
  );
}

static OnChg = pd => {

  let _d_onChgs = null;

  if (global.t?.$ido_onChgs) {
    _d_onChgs = global.t?.$ido_onChgs() ?? {};
    Object.keys(_d_onChgs)
    .map( _state => {
      useEffect(_d_onChgs[_state], [global.t?.state[_state]]);
    });
  };

  if (global.t?.$pdo_onChgs) {
    _d_onChgs = global.t?.$pdo_onChgs() ?? {};
    Object.keys(_d_onChgs)
    .map( _state => {
      useEffect(_d_onChgs[_state], [global.t?.state[_state]]);
    });
  };

  return pd.children;
}

static Pck(pd) {
//    <ce._fld
  return (
    <ce.Inp
      key={-1}
      mode={'pck'}
      b_vsb={pd.b_vsb}
      b_edit={pd.b_edit}
      b_tail={pd.b_tail}
      b_row={pd.b_row}
      b_rvs={pd.b_rvs}
      b_newLine={pd.b_newLine || false}
      state={pd.state}
      pfx={pd.pfx}
      bsd={pd.bsd}
      ini={(
        pd.ld_iss && 
        pd.ini && 
        bf.myCM_getDny({ld_iss:pd.ld_iss, fld:'key', val:pd.ini}) 
      ) ? bf.myCM_getDny({ld_iss:pd.ld_iss, fld:'key', val:pd.ini}).pfx 
        : null
      }
      d_ids={pd.d_ids}
      ctlVal={pd.ctlVal}
      phd={(pd.phd) ? pd.phd : ((pd.b_edit) ? '選択ください' : '')}
      phdCcd={pd.phdCcd}
      mdlType={'pck'}
      ld_iss={pd.ld_iss}
      o_onFldPrs={() => {
        global.t?.setState({
          sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next => {
            _next.pck.ld_iss = pd.ld_iss?.filter(_d_is => (_d_is.b_hide != true) ? true : false); // b_hide == true は list 表示の対象外
          }),
        }, ()=>{
        });
      }}
      o_rlcFldPrs={(pd.o_rlcFldPrs) ? () => { // replace field press
        pd.o_rlcFldPrs(pd.d_ids);
      } : null}
      o_onDltPrs={(pd.status) ? pd.o_onDltPrs : pd.o_onDltPrsAsCld}
      o_onChg={(_d_is) => { // pck の場合、mdl で処理するため、onBlur が意味をなさないことに注意
//ff.l('3596: {}, {}'.f(pd.state, _d_is))
        if (pd.state) { // clds でない場合
          global.t?.setState({ // clds でない場合は onChg において state に反映されて、clds の場合は 
            [pd.state]: _d_is.key,
          }, ()=>{
            if(pd.o_onChg){
              pd.o_onChg(_d_is);
            };
          });
        }
        else { // clds の場合
          if(pd.o_onChgAsCld){
            pd.o_onChgAsCld(_d_is, pd.d_ids); // clds の二重登録を防ぐために itemKey が必要
          }
        };
      }}
      o_onFcsAsCld={pd.o_onFcsAsCld}
      n_w={pd.n_w}
      n_mgnLeft={pd.n_mgnLeft}
//      stlCta={pd.stlCta}
      d_stlCtas={pd.d_ctrStls ?? pd.d_stlCtas ?? pd.stlCta}
      d_stlInps={pd.d_stlInps}
      stlPfx={pd.stlPfx}
      n_col={pd.n_col}
      stlLbl={pd.stlLbl}
      d_stlLblPfxs={pd.d_stlLblPfxs}
      d_stlLblCtas={pd.d_stlLblCtas}
      d_lbls={pd.d_lbls}
      n_lyr={pd.n_lyr}
      d_btns={
/*
        (pd.state && pd.b_clr != false) ? 
          {
            o_onClrPrs: () => {
              global.t?.setState({
                [pd.state]: -1,
              }, () => {
                if (pd.o_onChg) pd.o_onChg(null);
              })
            }
          }
        : pd.d_btns
*/
/*
        (pd.state && pd.b_clr != false) ? // state の場合
          {
            o_onClrPrs: () => {
ff.l('ce 3800 : here')
              global.t?.setState({
                [pd.state]: -1,
              }, () => {
                if (pd.o_onChg) pd.o_onChg();
              })
            }
          }
        : (pd.b_clr == true) ? // cld の場合
            {
              o_onClrPrsAsCld: () => {
ff.l('ce 3811 : here')
                if(pd.o_onClrPrsAsCld) pd.o_onClrPrsAsCld();
              }
            }
        : pd.d_btns
*/
        (pd.d_btns) ?
          pd.d_btns
        : (pd.state && pd.b_clr != false) ? // state の場合
          {
            o_onClrPrs: () => {
//ff.l('ce 3877 : {}'.f(pd.state));
              global.t?.setState({
                [pd.state]: -1,
              }, () => {
                if (pd.o_onChg) {
//ff.l('ce 3881 : {}'.f(pd.state));
                  pd.o_onChg();
                };
              })
            }
          }
        : (pd.b_clr == true) ? // cld の場合
          {
            o_onClrPrsAsCld: () => {
//ff.l('ce 3811 : here')
              if(pd.o_onClrPrsAsCld) pd.o_onClrPrsAsCld();
            }
          }
        : null
      }
    />
  );
};

static PckMdl(pd) { // 選択された項目を d_slcItems に反映し、_fld で処理

  let _r = [];

  let _w = global.t?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2;
  _w = ( _w > ic.gn_minBdyW * 2) ? ic.gn_minBdyW * 2 : _w;

  for (let [_idx, _d_items] of bf.e(global.t?.state.sgcd_mdls.pck.ld_iss)) {

    if (_d_items.b_dlt == true) { // b_dlt が true である item は表示対象外
      continue;
    };

    _r.push(
      ce.c(TouchableOpacity,
        {
          key: _idx,
          onPress: () => {
            global.t?.setState({
              sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next =>{
                _next.pck.d_slcItems = _d_items;
                _next.pck.b_showMdl = false;
              }),
            }, ()=>{
            });
          },
        },
        ce.c(View,
          {
            style: [{
              width: (_w) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
              marginTop: ic.gn_mgnNrm,
              marginBottom: ic.gn_mgnNrm,
              marginLeft: 'auto',
              marginRight: 'auto',
              paddingTop: ic.gn_mgnNrm,
              paddingBottom: ic.gn_mgnNrm,
              paddingLeft: ic.gn_mgnNrm,
              paddingRight: ic.gn_mgnNrm,
              borderWidth: ic.gn_bdrWNrw * 1.5,
              borderColor: '#bbbbbb',
              borderRadius: ic.gn_bdrRdsNrm,
            }, _d_items.stlCta]
          },
          ce.c(Text,
            {
              style: {
                fontSize: ic.gn_fontSizeNrm,
                color: ic.g_fontCcdNrm,
                textAlign: 'center',
              },
            },
            _d_items.pfx
          )
        )
      )
    );
  };

  return (
    ce.c(ce.Mdl,
      {
        key: -1,
        mdlType: 'pck',
        stlCta: {
          zIndex: ic.gn_zIdxPck,
        },
      },
      ce.c(ScrollView,
        {
          key: -1,
          showsVerticalScrollIndicator: true,
        },
        _r
      )
    )
  );
};

  static PckSlc(pd) { // 指定された分類で絞り込んだ上で選択

    // pck 用の識別番号
    const _pckId = 'pckId20210625';
    //
    // 分類の更新
//ff.l('3733: {}'.f(pd.ld_itemss))
    let _ld_ctgss = bf.c(
      pd.ld_itemss.filter(_d_is => (_d_is.b_show != false) ? true : false )
      .map( _d_is => _d_is.ctg )
      .reduce( (_prev, _ctg) => {
        if (_prev.includes(_ctg) == false) {
          _prev.push(_ctg)
        };
        return _prev;
      }, [])
      .map( _ctg => ({ key:_ctg, pfx:_ctg })),
      [{key:'全分類', pfx:'全ての分類'}], 
    );
    //
    return (
      <ce._fld
        key={-1}
        b_vsb={pd.b_vsb}
        b_edit={pd.b_edit}
        state={pd.state}
        pfx={pd.pfx}
        ini={(
          pd.ld_itemss && 
          pd.ini && 
          bf.myCM_getDny({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ini}) 
        ) ? bf.myCM_getDny({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ini}).pfx 
          : null
        }
        d_ids={pd.d_ids}
        ctlVal={pd.ctlVal}
        phd={(pd.phd) ? pd.phd : ((pd.b_edit) ? '選択ください' : '')}
        phdCcd={pd.phdCcd}
        mdlType={'pckSlc'}
        ld_itemss={pd.ld_itemss}
        b_newLine={false}
        onFldPrs={() => {
          global.t?.setState({
            sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next => {
              _next['pck'].id = _pckId;
              _next['pck'].ld_itemss = _ld_ctgss; // b_hide == true は list 表示の対象外
              _next['pck'].b_showMdl = true;
              _next['pckSlc'].ld_itemss = pd.ld_itemss.filter(_d_is => (_d_is.b_hide != true) ? true : false); // b_hide == true は list 表示の対象外
            }),
          }, ()=>{
          });
        }}
        onDltPrs={pd.o_onDltPrs}
        onChg={(_d_items) => { // pck の場合、mdl で処理するため、onBlur が意味をなさないことに注意
          if (pd.state) { // clds でない場合
            global.t?.setState({ // clds でない場合は onChg において state に反映されて、clds の場合は 
              [pd.state]: _d_items.key,
            }, ()=>{
              if(pd.o_onChg){
                pd.o_onChg(_d_items);
              };
            });
          }
          else { // clds の場合
            if (pd.o_onChgAsCld) {
              pd.o_onChgAsCld(_d_items, pd.d_ids); // clds の二重登録を防ぐために itemKey が必要
            }
          };
        }}
        stlCta={pd.stlCta}
        stlPfx={pd.stlPfx}
        n_col={pd.n_col}
        stlLbl={pd.stlLbl}
      />
    );
  };

  static PckSlcMdl(pd) { // 選択された項目を d_slcItems に反映し、_fld で処理

    // pck 用の識別番号
    const _pckId = 'pckId20210625';

    let _r = [];

    const [_sld_iss, _setIss] = useState([]);
    useEffect(()=> {
      if ( global.t?.state.sgcd_mdls['pck'].id == _pckId ) {
        let _ctg = global.t?.state.sgcd_mdls['pck'].d_slcItems.key || '全分類';
        let _ld_iss = bf.c(
          global.t?.state.sgcd_mdls.pckSlc.ld_itemss
            .filter( _d_is => ( _ctg == '全分類' || _d_is.ctg == _ctg ) ? true : false),
          [{key: '戻る', pfx: '戻る'}]
        );
        _setIss(_ld_iss);
      };
    }, [
      global.t?.state.sgcd_mdls.pckSlc.ld_itemss,
      global.t?.state.sgcd_mdls['pck'].d_slcItems
    ]);

    for (let [_idx, _d_is] of bf.e(_sld_iss)) {

      if (_d_is.b_dlt == true) { // b_dlt が true である item は表示対象外
        continue;
      };

      _r.push(
        <TouchableOpacity
          key={_idx}
          onPress={()=>{
            if ( _d_is.key == '戻る' ) { // 戻る の場合
              global.t?.setState({
                sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next => {
                  _next['pck'].id = _pckId;
                  _next['pck'].b_showMdl = true;
                }),
              }, ()=>{
              });
            }
            else {
              global.t?.setState({
                sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next =>{
                  _next['pckSlc'].d_slcItems = _d_is;
                  _next['pckSlc'].b_showMdl = false;
                }),
              }, ()=>{
              });
            };
          }}
        >
          <View style={[{
            width: (global.t?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            marginTop: ic.gn_mgnNrm,
            marginBottom: ic.gn_mgnNrm,
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingTop: ic.gn_mgnNrm,
            paddingBottom: ic.gn_mgnNrm,
            paddingLeft: ic.gn_mgnNrm,
            paddingRight: ic.gn_mgnNrm,
            borderWidth: ic.gn_bdrWNrw * 1.5,
            borderColor: '#bbbbbb',
            borderRadius: ic.gn_bdrRdsNrm,
          }, _d_is.stlCta]}>
            <Text
              style={{
                fontSize: ic.gn_fontSizeNrm,
                color: ic.g_fontCcdNrm,
                textAlign: 'center',
              }}
            >
              {_d_is.pfx}
            </Text>
          </View>
        </TouchableOpacity>
      );
    };

    return (
      <ce.Mdl
        key={-1}
        mdlType={'pckSlc'}
      >
        <ScrollView
          key={-1}
          showsVerticalScrollIndicator={true}
        >
          {_r}
        </ScrollView>
      </ce.Mdl>
    );
  };

static Pnn (pd) { // pagination ※ pnl の srcState と併用できないことに留意

  let _n_lmt = pd.n_lmt ?? 10;

  const [ _sn_crrIdx, _setCrrIdx] = useState(0);
  const [ _sld_defss, _setDefss] = useState([]);

  useEffect(() => {

    let _als = pd.als ?? (
      (pd.state && global.t?.state[pd.state] && Object.keys(global.t?.state[pd.state])) ?  
        Object.keys(global.t?.state[pd.state])[0]
      : null
    );

    if (
      _als &&
      pd.state && 
      global.t?.state[pd.state] &&
      ff.myCM_getLen(global.t?.state[pd.state][_als]) > _n_lmt
    ){
      let _ld_defss = global.t?.state[pd.state][_als]
      .filter((_d_dats, _idx) => (_idx % _n_lmt == 0) ? true : false )
      .map( (_d_dats, _idx) => {
        return {
          pfx: _idx + 1,
          b_vsb: true,
          o_onPrs: () => {
            global.t?.setState({
              [pd.state]: bf.p( global.t?.state[pd.state], _next => {
                _next[_als]
                .map( (_d_dats2, _idx2) => {
                  if (_idx2 >= _idx * _n_lmt && _idx2 < _idx * _n_lmt + _n_lmt) {
                    _d_dats2.b_show = true;
                  }
                  else {
                    _d_dats2.b_show = false;
                  };
                })
              }),
              sgcl_pnnRngs: ff.myCM_getRng(_idx * _n_lmt + _n_lmt, _idx * _n_lmt),
            })
          },
        };
      });
      _setDefss(_ld_defss)
    }
    else {
      _setDefss([]);
    };
  }, [
    global.t?.state[pd.state]
  ])

  if ( pd.b_vsb == false ) return null;

  if ( bf.f(_sld_defss) == false ) return null;

  let _r = [];

  _sld_defss.map( (_d_defs, _idx) => {

    if (_d_defs.b_vsb == false) return;

    _r.push(
      ce.c(TouchableOpacity, {
        key: _idx,
        onPress: () => {
          _setCrrIdx(_idx);
          if (_d_defs.o_onPrs) _d_defs.o_onPrs(_d_defs);
        },
      }, [
        ce.c(View, {
          key: -1,
          style: { 
            height: ic.gn_fontSizeNrm + ic.gn_mgnSml * 2, 
            lineHeight: ic.gn_fontSizeNrm + ic.gn_mgnSml * 2, 
            width: ic.gn_btnWSml, 
            backgroundColor: ic.o_getCcd((_idx == _sn_crrIdx) ? 'd' : 'n'),
            borderWidth: ic.gn_bdrWNrw,
            borderColor: ic.o_getCcd((_idx == _sn_crrIdx) ? 'd' : 'n'),
            borderRadius: ic.gn_bdrRdsNrm,
            marginStart: ic.gn_mgnNrm,
            marginEnd: 0,
            marginTop: 0,
            marginBottom: 0,
            paddingLeft: ic.gn_mgnNrm,
            paddingRight: ic.gn_mgnNrm,
            paddingTop: 0,
            paddingBottom: 0,
            flexDirection: 'column',
            justifyContent: 'center', 
            alignItems: 'center',
          }
        }, [
          ce.c(Text, {
            key: -1,
            style: [{ 
              fontSize: ic.gn_fontSizeNrm,
              color: ic.g_ccdWN,
              textAlign: 'center',
            }, _d_defs.stlPfx],
          }, [
            _d_defs.pfx
          ])
        ])
      ])
    );
  });

  return (
    ce.c(ScrollView, {
      key: 'Pnn',
      style: {
        height: ic.gn_fontSizeNrm + ic.gn_mgnSml * 2 * 2 + ic.gn_bdrWNrw * 2 + ic.gn_scbW,
        width: '100%',
      },
      contentContainerStyle: [{ // '100%'
        marginTop: 'auto',
        marginBottom: 'auto',
      }],
      horizontal: true,
      showsHorizontalScrollIndicator: true,
    }, [
      _r
    ])
  );
}

static MenuMdl(pd) { // 選択された項目を d_slcItems に反映し、_fld で処理
  let _r = global.t?.state.sgcd_mdls.menu.ld_iss
  .filter( _d_is => (_d_is) ? true : false ) // null の場合は スキップ
  .map( (_d_is, _idx) => {
    return (
      ce.c(TouchableOpacity, {
        key: _idx,
        onPress: ()=>{
          global.t?.setState({
            sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next =>{
              _next.menu.b_showMdl = false;
            }),
          }, ()=>{
            if (_d_is.type == 'moveFwd') {
              cf.myRN_move_fwd(_d_is.d_pageInfs);
            };
            if (_d_is.type == 'logout') { // 20211126
              cf.myRN_logout();
            };
            if (_d_is.o_onPrs) {
              _d_is.o_onPrs();
            };
          });
        },
      }, [
        ce.c(View, {
          key: -1,
          style: {
            width: (global.t?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            marginTop: ic.gn_mgnNrm,
            marginBottom: ic.gn_mgnNrm,
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingTop: ic.gn_mgnNrm,
            paddingBottom: ic.gn_mgnNrm,
            paddingLeft: ic.gn_mgnNrm,
            paddingRight: ic.gn_mgnNrm,
            borderWidth: ic.gn_bdrWNrw * 1.5,
            borderColor: '#bbbbbb',
            borderRadius: ic.gn_bdrRdsNrm,
          }
        }, [
          ce.c(Text, {
            key: -1,
            style: {
              fontSize: ic.gn_fontSizeNrm,
              color: ic.g_fontCcdNrm,
              textAlign: 'center',
            },
          }, [
            _d_is.pfx
          ])
        ])
      ])
    );
  });
  return (
    ce.c(ce.Mdl, {
      key: 'MenuMdl',
      mdlType: 'menu',
    }, [
      ce.c(ScrollView, {
        key: -1,
        showsVerticalScrollIndicator: true,
      }, [
        _r
      ])
    ])
  );
};

static MsgMdl(pd) { // cfmMdl に統合予定
  return (
    ce.c(ce.Mdl, {
      key: -1,
      mdlType: 'msg',
    }, [
      ce.c(ce.Msg, {
        pfx: pd.d_msgs?.pfx,
        stlCta: bf.c({
          marginLeft: ic.gn_mgnNrm,
          marginRight: ic.gn_mgnNrm,
        }, pd.d_msgs?.stlCta),
        stlPfx: pd.d_msgs?.stlPfx,
      }),
      ce.c(ce.Btn, {
        pfx: '閉じる',
        o_onPrs: ()=>{
          global.t?.setState({
            sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next =>{
              _next.msg.b_showMdl = false;
            }),
          });
        },
      }),
    ])
  );
};

  static FileMdl(pd) { // File Inport 用のモーダル
    return null;
  };

    static Qr(pd) {
        if (pd.b_vsb == false || !bf.f(pd.val)) {
            return null;
        };
        
        return (
            <>
                <ce.Lbl
                    key={-1}                    
                    pfx={pd.pfx}
                />
                <View
                    key={-2}   
                    style={{
                        width: global.t?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                        marginLeft: 'auto',
                        marginRight: 'auto',                    
                    }}
                >
                    <QRCode
                        key={-1}
                        value={pd.val}
                    />
                </View>
            </>
        );
    };

  static _fld(pd) { // pd.ini か d_slcItems が設定された場合に値が変更される

    let _r = [];

    const [_s_id, _setId] = useState('');
    const [_s_val, _setVal] = useState(pd.ini || ''); // 前回の値が初期表示されないよう pd.ini が null の場合は '' で初期化

    useEffect(()=>{ // _s_id ではなく do_fnc を用いることで処理を効率化できないか
      let _d_slcItems = global.t?.state.sgcd_mdls[pd.mdlType]?.d_slcItems;
      if (bf.f(_d_slcItems)) {
        if (bf.f(_d_slcItems.key)) {
          if (
            bf.f(global.t?.state.sgcd_mdls[pd.mdlType].id) && 
            bf.f(_s_id) && 
            global.t?.state.sgcd_mdls[pd.mdlType].id == _s_id
          ) { // 同一 id の場合（ id はボタン押下時に発行 ） ※重複する key がある場合、全てに値が反映されるため
            if (pd.b_newLine == true) { // b_newLine である新規登録行は反映しない
              _setVal('');
            } else {
              if (pd.state) { // clds でない場合
                global.t?.setState({
                  [pd.state]: _d_slcItems.key,
                }, () => {
                });
              }
              else { // clds の場合
                _setVal(_d_slcItems.pfx);
              };
            };
            //
            if(pd.o_onChg) { // clds の場合、値を反映
              global.t?.setState({ // 同一要素を繰り返し選択可能とするためには d_slcItems の初期化が必要
                sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next => {
                  _next[pd.mdlType].d_slcItems = {};
                }),
              }, () => {
                pd.o_onChg(_d_slcItems);
              });
            };
          };
        };
      };
    }, [global.t?.state.sgcd_mdls[pd.mdlType]?.d_slcItems]) // 同一id かつ b_newLine 以外で d_slcItems が設定された場合に値が変更される

    useEffect(()=>{ 
      if (
        bf.f(pd.state) && 
        bf.f(global.t?.state[pd.state]) && 
        bf.f(pd.ld_iss)
      ) {
        if (
          bf.f(bf.myCM_getDny({ld_iss:pd.ld_iss, fld:'key', val:global.t?.state[pd.state]}))
        ) { // pd.ld_iss に対応する値が存在する場合
          let _d = bf.myCM_getDny({ld_iss:pd.ld_iss, fld:'key', val:global.t?.state[pd.state]});
          _setVal(_d.pfx);
        }
        else { // pd.ld_items に対応する値が存在しない場合
          _setVal('');
        };
      };
    }, [global.t?.state[pd.state], pd.ld_iss]);

    useEffect(()=>{ 
        if (pd.ctlVal){
            if (bf.myCM_getDny({ld_iss:pd.ld_iss, fld:'key', val:pd.ctlVal})) {
                _setVal(bf.myCM_getDny({ld_iss:pd.ld_iss, fld:'key', val:pd.ctlVal}).pfx);
            };
        };
    }, [
      pd.ctlVal, 
      pd.ld_iss
    ]); // pd.dd_listItems が変更された場合に初期値が反映される状況

    if (pd.b_vsb == false) {
        return null;
    };

    const _stlTextInput = {
      minHeight: ((pd.b_mln) ? ic.gn_fontSizeNrm * 3 : ic.gn_fontSizeNrm ) + ic.gn_mgnNrm * 2 + ic.gn_bdrWNrm * 2,
      width: (pd.n_col) ? (pd.n_col * ic.gn_fontSizeNrm) : null,
      color: (pd.b_row) ? ic.g_backCcd : ic.g_fontCcdNrm,
      fontSize: ic.gn_fontSizeNrm,
      opacity: 1,
      borderWidth: ic.gn_bdrWNrw * 1.5,
      borderColor: 
        (pd.b_row == true) ? 
          ic.g_backCcd 
        : (pd.b_edit == true) ? 
          ic.g_bdrCcd 
        : 
          'transparent'
      ,
      borderRadius: ic.gn_bdrRdsNrm,
      marginLeft: 
        (pd.b_row) ? 
          ic.gn_mgnNrm
        : ((pd.n_lyr || 1) > 1) ? 
          'auto'
        : 0,
      marginRight: 0,
      paddingTop: ic.gn_mgnSml,
      paddingBottom: ic.gn_mgnSml,
      paddingLeft: ic.gn_mgnSml,
      paddingRight: ic.gn_mgnSml,
      borderRadius: (pd.b_mln || pd.b_bdr != false) ? ic.gn_bdrRdsNrm : 0,
      textAlign: 'left',
      textAlignVertical: (cf.myRN_chk_os('a') && pd.b_mln) ? 'top' : null,
    };

    return (
      <View
        key={-1}
        style={[{
          marginTop: 0,
          marginBottom: 0,
          marginLeft: ic.gn_mgnNrm,
          marginRight: 0,
          flexDirection: (pd.b_row) ? 'row' : 'column',
          justifyContent: (pd.b_row) ? 'flex-start' : 'flex-start',
          alignItems: (pd.b_row) ? 'center' : 'flex-start',
        }, pd.stlCta]}
      >
        { (pd.pfx) ?
          <ce.Lbl
            key={-1}
            pfx={pd.pfx}
            stlPfx={
              (pd.b_row) ? 
                bf.c({
                  fontSize: ic.gn_fontSizeSml,
                  color: ic.g_backCcd,
                }, pd.stlLbl)
              : pd.stlLbl }
            b_row={pd.b_row}
          />
        : null }
        { (pd.b_edit) ?
          <TouchableOpacity
            key={-2}
            onPress={async ()=>{
              if (pd.o_rlcFldPrs){
                pd.o_rlcFldPrs();
              }
              else {
                if (pd.o_onFldPrs){
                  await pd.o_onFldPrs(); // await しないと選択項目が表示されない
                };
                global.t?.setState({
                  sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next =>{
                    let _id = bf.myCM_gnr(10);
                    _setId(_id);
                    _next[pd.mdlType].id = _id;
                    if (pd.dop_acts) _next[pd.mdlType].dop_acts = pd.dop_acts ?? null;
                    if (_next[pd.mdlType].b_clr == true) _next[pd.mdlType].ld_iss = [];
                    _next[pd.mdlType].b_showMdl = true;
                  }),
                });
              };
            }}
          >
            <Text
              numberOfLines={(pd.b_tail) ? 1 : null}
              ellipsizeMode={(pd.b_tail) ? 'tail' : null}
              style={[_stlTextInput, {
                }, pd.stlInp]} >{(pd.o_stlVal) ? pd.o_stlVal(_s_val) : _s_val}</Text>
          </TouchableOpacity>
        :
          <Text
            numberOfLines={(pd.b_tail) ? 1 : null}
            ellipsizeMode={(pd.b_tail) ? 'tail' : null}
            style={[_stlTextInput, {
            }, pd.stlInp]} >{(pd.o_stlVal) ? pd.o_stlVal(_s_val) : _s_val}</Text>
        }
          <ce.BtnIconPfx
            key={-4}
            b_vsb={true}
            iconName="trash"
            o_onPrs={()=>{
              pd.d_btns.o_onDltPrs(pd.d_ids);
            }}
            stlCta={{
              position: 'absolute',
              top: ic.gn_mgnNrm,
              right: ic.gn_mgnNrm,
              backgroundColor: ic.gn_backCcd,
            }}
          />
      </View>
    );
  };

static PckDate = (pd={
}) => {
  const [_sld_iss, _setIss] = useState([]);
  useEffect(() => {
    if (
      pd.state &&
      global.t?.state[pd.state]
    ) {
      let _date = global.t?.state[pd.state];
      let _ld_iss = [{ 
        key: '{}'.f(_date), 
        pfx: '{}'.f(_date)
      }];
      _setIss(_ld_iss);
    }
  }, [
    global.t?.state[pd.state],
  ]);
  useEffect(() => {
    if (
      pd.ctlVal == '' || pd.ctlVal
    ) {      
      let _date = pd.ctlVal;
      let _ld_iss = [{ 
        key: '{}'.f(_date), 
        pfx: '{}'.f(_date)
      }];
      _setIss(_ld_iss);
    }
  }, [
    pd.ctlVal
  ]);

  return ce.c(ce.Inp, {
    key: -1,
    mode: 'pck',
    b_vsb: pd.b_vsb,
    b_edit: pd.b_edit,
    pfx: pd.pfx,
    bsd: pd.bsd,
    ini: pd.ini,
    mdlType: 'pckDate',
    d_mdls: pd.d_mdls,
    b_newLine: pd.b_newLine,
    o_onChg: (_d_items) => { // pck の場合、mdl で処理するため、onBlur が意味をなさないことに注意
      if (pd.state) { // clds でない場合
        global.t?.setState({ // clds でない場合は onChg において state に反映されて、clds の場合は 
          [pd.state]: _d_items.key,
        }, ()=>{
          if(pd.o_onChg) pd.o_onChg(_d_items);
        });
      }
      else { // clds の場合
        if (pd.o_onChgAsCld) pd.o_onChgAsCld(_d_items, pd.d_ids); // clds の二重登録を防ぐために itemKey が必要
      };
    },
    o_onFcsAsCld: pd.o_onFcsAsCld,
    b_row: pd.b_row,
    n_col: pd.n_col,
    state: pd.state,
    ctlVal: pd.ctlVal,
    n_w: pd.n_w,
    stlLbl: pd.stlLbl,
    d_stlLblPfxs: pd.d_stlLblPfxs,
    d_stlLblCtas: pd.d_stlLblCtas,
    d_lbls: pd.d_lbls,
    b_rvs: pd.b_rvs,
    ld_iss: _sld_iss,
    d_btns: pd.d_btns,
    d_btns:
      (pd.state && pd.b_clr != false) ? 
        {
          o_onClrPrs: () => {
            global.t?.setState({
              [pd.state]: '', // PckSch との違い
            })
          }
        }
      : pd.d_btns,
  }, null);
};

static PckDateMdl(pd={}) {

//ff.l('ce 4543: {}'.f(global.t?.state.sgcd_mdls?.pckDate));

  const [_s_date, _setDate] = useState(global.t?.state.sgcd_mdls?.pckDate?.iniDate ?? ff.myDT_getDate('today'));
  useEffect(() => {
    if (ff.f(global.t?.state.sgcd_mdls?.pckDate?.iniDate)) {
      _setDate(global.t?.state.sgcd_mdls?.pckDate?.iniDate);
    };
  }, [
    global.t?.state.sgcd_mdls?.pckDate?.iniDate,
  ]);

  const [_sld_iss, _setIss] = useState([]);
  useEffect(() => {
    let _ld_iss = ff.myDT_cnv('cdrMthDates', _s_date).map( _date => {
      return { 
        key: '{}'.f(_date), 
        pfx: '{}'.f(_date)
      }
    });
    _setIss(_ld_iss);
  }, [
    _s_date,
  ]);

  let _w = global.t?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2;
  _w = (_w > ic.gn_minBdyW * 2) ? ic.gn_minBdyW * 2 : _w;

  let _n_w = ff.myCM_cnv('flr', ((_w) - ic.gn_mgnNrm * 8) / 7);

  let _r = [];
  ['日', '月', '火', '水', '木', '金', '土']
  .map( (_dow, _idx) => {
    _r.push(
      ce.c(View, {
        key: 'PckDateMdl.Hdr.{}'.f(_idx),
        style: [{
          height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2,
          width: _n_w,
          marginTop: ic.gn_mgnNrm,
          marginBottom: 0,
          marginLeft: 0,
          marginRight: 0,
          paddingTop: ic.gn_mgnSml,
          paddingBottom: ic.gn_mgnSml,
          paddingLeft: ic.gn_mgnNrm,
          paddingRight: ic.gn_mgnNrm,
          borderWidth: 0,
          borderBottomWidth: ic.gn_bdrWNrw * 1.5,
          borderColor: ic.g_fontCcdNrm,
          backgroundColor: ic.gn_backCcd,
        }]
      }, [
        ce.c(Text,
          {
            key: -1,
            style: {
              fontSize: ic.gn_fontSizeNrm,
              color: ic.g_fontCcdNrm,
              textAlign: 'center',
            },
          },
          _dow,
        )
      ])
    );
  });

/*
  _sld_iss.map( (_d_items, _idx) => {
    let _dow = ff.myDT_cnv('dow', _d_items.key);
    let _o = (
      ce.c(View,
        {
          key: -1,
          style: [{
            height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2,
            width: _n_w,
            marginTop: ic.gn_mgnNrm,
            marginBottom: 0,
            marginLeft: 0,
            marginRight: 0,
            paddingTop: ic.gn_mgnSml,
            paddingBottom: ic.gn_mgnSml,
            paddingLeft: ic.gn_mgnNrm,
            paddingRight: ic.gn_mgnNrm,
            borderWidth: 0,
            borderRadius: ic.gn_bdrRdsNrm,
            backgroundColor: 
              ( _dow == '土' ) ?
                ic.o_getCcd('n')
              : ( _dow == '日' ) ?
                ic.o_getCcd('d')
              : ic.gn_backCcd,
          }, _d_items.stlCta]
        },
        ce.c(Text,
          {
            key: -1,
            style: {
              fontSize: ic.gn_fontSizeNrm,
              color: (String(_d_items.key).substr(0,7) == String(_s_date).substr(0,7)) ? ic.g_fontCcdNrm : 'lightgray',
              textAlign: 'center',
            },
          },
          bf.n(String(_d_items.key).substr(8))
        )
      )
    );
    _r.push(
      ce.c(TouchableOpacity, {
        key: 'PckDateMdl.Bdy.{}'.f(_idx),
        onPress: () => {
          global.t?.setState({
            sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next =>{
              _next['pckDate'].d_slcItems = _d_items;
              _next['pckDate'].b_showMdl = false;
            }),
          }, ()=>{
          });
        },
      }, _o)
    );
  });
*/
  _sld_iss.map( (_d_items, _idx) => {
    let _dow = ff.myDT_cnv('dow', _d_items.key);

    let _b_vld = false;
//ff.l('ce 4566: {}, {}, {}'.f(global.t?.state.sgcd_mdls?.pckDate?.sttDate, global.t?.state.sgcd_mdls?.pckDate?.endDate, _d_items.key))
    if (
      (ff.f(global.t?.state.sgcd_mdls?.pckDate?.sttDate) == false || _d_items.key >= global.t?.state.sgcd_mdls?.pckDate?.sttDate) && 
      (ff.f(global.t?.state.sgcd_mdls?.pckDate?.endDate) == false || global.t?.state.sgcd_mdls?.pckDate?.endDate >= _d_items.key)
    ) {
      _b_vld = true;
    };

    let _o = (
      ce.c(View,
        {
//          key: -1,
          key: _d_items.key,
          style: [{
            height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2,
            width: _n_w,
            marginTop: ic.gn_mgnNrm,
            marginBottom: 0,
            marginLeft: 0,
            marginRight: 0,
            paddingTop: ic.gn_mgnSml,
            paddingBottom: ic.gn_mgnSml,
            paddingLeft: ic.gn_mgnNrm,
            paddingRight: ic.gn_mgnNrm,
            borderWidth: 0,
            borderRadius: ic.gn_bdrRdsNrm,
            backgroundColor: 
              (_b_vld != true) ?
                'whitesmoke'
              : ( _dow == '土' ) ?
                ic.o_getCcd('n')
              : ( _dow == '日' ) ?
                ic.o_getCcd('d')
              : ic.gn_backCcd,
          }, _d_items.stlCta]
        },
        ce.c(Text,
          {
            key: -1,
            style: {
              fontSize: ic.gn_fontSizeNrm,
              color: 
                (_b_vld != true) ?
                  'lightgray'
                : (String(_d_items.key).substr(0,7) == String(_s_date).substr(0,7) && bf.i(_dow, ['土', '日']) == true) ? 
                  ic.g_ccdWN
                : (String(_d_items.key).substr(0,7) == String(_s_date).substr(0,7) && bf.i(_dow, ['土', '日']) == false) ? 
                  ic.g_fontCcdNrm
                : 'lightgray',
              textAlign: 'center',
            },
          },
          bf.n(String(_d_items.key).substr(8))
        )
      )
    );
    if (_b_vld) {
//ff.l('ce 4608: {}, {}, {}'.f(global.t?.state.sgcd_mdls?.pckDate?.sttDate, global.t?.state.sgcd_mdls?.pckDate?.endDate, _d_items.key))
      _o = ce.c(TouchableOpacity, {
        key: _d_items.key,
        onPress: () => {
          global.t?.setState({
            sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next =>{
              _next['pckDate'].d_slcItems = _d_items;
              _next['pckDate'].b_showMdl = false;
            }),
          }, ()=>{
          });
        },
      }, _o)
    };
    _r.push(_o);
  });

//ff.l('4563: {}'.f(global.t?.state.sgcd_mdls?.pckDate?.iniDate));
//ff.l('4564: {}'.f(global.t?.state.sgcd_mdls?.pckDate?.sttDate));
//ff.l('4565: {}'.f(global.t?.state.sgcd_mdls?.pckDate?.endDate));

  return ce.c(ce.Mdl, {
    key: -1,
    mdlType: 'pckDate',
    stlCta: {
      zIndex: ic.gn_zIdxPck, // Mdl の上に表示するため
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    },
  }, [
      ce.c(View, {
        key: -1,
        style: [{
          height: (ic.gn_fontSizeNrm + ic.gn_mgnNrm * 3) * 8,
          paddingLeft: ic.gn_mgnNrm,
          paddingRight: ic.gn_mgnNrm,
        }],
      }, [
          ce.c(View, { 
            key: -1,
            style: [{
              width: (_w) - ic.gn_mgnNrm * 2,                  
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }],
          }, [
            ce.c(ce.BtnIconPfx, 
              {
                key: -1,
                b_row: true,
                iconName: 'angle-double-left',
                pfx: '前年',
                o_onPrs: () => {
                  _setDate(ff.myDT_add('mth', _s_date, -12));
                },
//                ccd: ic.o_getCcd(global.t?.state.sgc_pageRole, 'd'),
                ccd: ic.o_getCcd('d'),
              }
            ),
            ce.c(ce.BtnIconPfx, 
              {
                key: -2,
                b_row: true,
                iconName: 'angle-left',
                pfx: '前月',
                o_onPrs: () => {
                  _setDate(ff.myDT_add('mth', _s_date, -1));
                },
//                ccd: ic.o_getCcd(global.t?.state.sgc_pageRole, 'd'),
                ccd: ic.o_getCcd('d'),
              }
            ),
            ce.c(Text, 
              {
                key: -3,
                style: {
                  width: ic.gn_btnWLrg,
                  fontSize: ic.gn_fontSizeLrg,
                  fontWeight: 'bold',
                  color: ic.g_fontCcdNrm,
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  textAlign: 'center',
                  color: ic.g_fontCcdNrm,
                },
              },
              String(_s_date).substr(0,7)
            ),
            ce.c(ce.BtnIconPfx, 
              {
                key: -4,
                b_row: true,
                iconName: 'angle-right',
                pfx: '翌月',
                o_onPrs: () => {
                  _setDate(ff.myDT_add('mth', _s_date, +1));
                },
//                ccd: ic.o_getCcd(global.t?.state.sgc_pageRole, 'd'),
                ccd: ic.o_getCcd('d'),
              }
            ),
            ce.c(ce.BtnIconPfx, 
              {
                key: -5,
                b_row: true,
                iconName: 'angle-double-right',
                pfx: '翌年',
                o_onPrs: () => {
                  _setDate(ff.myDT_add('mth', _s_date, +12));
                },
//                ccd: ic.o_getCcd(global.t?.state.sgc_pageRole, 'd'),
                ccd: ic.o_getCcd('d'),
              }
            ),
          ]),
          ce.c(View, {
            key: -2,
            style: [{
              flexDirection: 'row',
                justifyContent: 'space-around',
              alignItems: 'center',
              flexWrap: 'wrap',                    
            }],
          }, [
            _r,
          ])
      ]),
  ]);
};


  static ListRdb (pd) { // radio button
      //
      let _r = [];
      //
      bf.myCM_for_each(pd.ld_iss, (_d_items) => {
          _r.push(
              <>
                  <Text
                      style={{
                          width: global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                          marginStart: 'auto',
                          marginEnd: 'auto',
                      }}
                  >
                      {_d_items.pfx}
                  </Text>
                  <ce.Rdb
                      
                      state={_d_items.state}
                      ld_iss={ic.gld_yesNo}
                  />
              </>
          );
      });
      //
      return (
          <>
              {_r}
          </>
      );
  }
  
  static Rdb (pd) { // radio button
      //
      let _r = [];
      //
      bf.myCM_for_each(pd.ld_iss, (_d_items) => {
          _r.push(
              <>
                  <RadioButton
                      value={_d_items.key}
                      status={ global.t?.state[pd.state] == _d_items.key ? 'checked' : 'unchecked' }
                      onPress={() => {
                          global.t?.setState({
                              [pd.state]: _d_items.key,
                          });
                      }}
                  />
                  <Text>{_d_items.pfx}</Text>
              </>
          );
      });
      //
      return (
          <ce.Row
              stlCta={[{
                  width: global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                  marginStart: 'auto',
                  marginEnd: 'auto',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
              }, pd.stlCta]}
          >
              {_r}
          </ce.Row>
      );
  }

    static Rfr (pd) { // referer
        //
        const [_s_crrTextInp, _setTextInp] = useState('');
        //
        useEffect(()=>{
            if (global.t?.state[pd.state]) {
                if (pd.o_onChgKey){
                    pd.o_onChgKey(global.t?.state[pd.state])
                    .then((_s)=>{
                        _setTextInp(_s);
                    });
                };
            };
        }, [global.t?.state[pd.state]]);
        //
        return (
            <View 
                style={ [{
                    width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                    margin: ic.gn_mgnNrm,
                }, pd.stlCta] }
            >
                <ce.Lbl
                    key={-1} 
                    pfx={pd.pfx}
                />
                <TextInput 
                    key={-2} 
                    editable={pd.b_edit}
                    multiline={false}
                    placeholder={pd.phd}
                    style={ [{
                        color: ic.g_fontCcdNrm,
                        fontSize: ic.gn_fontSizeNrm,
                        borderWidth: ic.gn_bdrWNrw * 1.5,
                        borderColor: (pd.b_edit == true) ? ic.g_bdrCcd : ic.g_ccdWN,
                        borderRadius: ic.gn_bdrRdsNrm,
                        paddingTop: ic.gn_mgnNrm,
                        paddingBottom: ic.gn_mgnNrm,
                        paddingLeft: ic.gn_mgnNrm,
                        paddingRight: ic.gn_mgnNrm,
                        borderRadius: (pd.b_bdr) ? ic.gn_bdrRdsNrm : 0,
                        minHeight: ic.gn_fontSizeNrm * 3,
                    }, pd.stlInp] }
                    value={_s_crrTextInp}
                    onChangeText={(_newTextInp)=>{
                        if (pd.o_onChgStr) {
                            pd.o_onChgStr(_newTextInp, _s_crrTextInp);
                        };
                        _setTextInp(_newTextInp);
                    }}
                />
            </View>
        );
    }

  static PckFilesMdl = (pd={
    state: '',
   o_onPrs: () => {},
  }) => {
    return (
      <ce.Mdl
        key={-1}
        b_vsb={global.t?.state.sgcd_mdls.pckFiles.b_showMdl}
        mdlType={'pckFiles'}
      >
        <ce.Files
          key={-1}
          b_vsb={true}
          b_lblBtnVsb={true}
          ob_dltBtnVsb={() => true}
          pfx='添付ファイル'
          state={pd.state}
          n_pntW={(global.t?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2)}
        />
        <ce.Btn
          key={-2}
          b_vsb={(bf.myCM_getLen(global.t?.state[pd.state])>0) ? true : false}
          b_rvs={false}
          pfx='送る'
          onCls={()=>{
            global.t?.setState({
              sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next => {
                _next.pckFiles.b_showMdl = false;
              }),
            });
          }}
         o_onPrs={pd.o_onPrs}
          stlCta={{
            width: (global.t?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
          }}
        />
      </ce.Mdl>
    );
  };

static PckSch = (pd) => {
  return (
    <ce.Inp
      key={-1}
      mode={'pck'}
      b_vsb={pd.b_vsb}
      b_edit={pd.b_edit}
      b_tail={pd.b_tail}
      pfx={pd.pfx}
      ini={pd.ini}
      mdlType={'pckSch'}
      b_newLine={pd.b_newLine}
      o_onChg={(_d_items) => { // pck の場合、mdl で処理するため、onBlur が意味をなさないことに注意
//ff.l('4602: {}'.f(_d_items))
        if (pd.state) { // clds でない場合
//ff.l('4604: here')
          global.t?.setState({ // clds でない場合は onChg において state に反映されて、clds の場合は 
            [pd.state]: _d_items.key,
          }, ()=>{
            if(pd.o_onChg){
              pd.o_onChg(_d_items);
            };
          });
        }
        else { // clds の場合
//ff.l('4614: here')
          if (pd.o_onChgAsCld) {
            pd.o_onChgAsCld(_d_items, pd.d_ids); // clds の二重登録を防ぐために itemKey が必要
          }
        };
      }}
      o_onFcsAsCld={pd.o_onFcsAsCld}
      b_row={pd.b_row}
      n_col={pd.n_col}
      state={pd.state}
      ld_iss={pd.ld_iss}
      ctlVal={pd.ctlVal}
      n_w={pd.n_w}
      d_stlCtas={pd.d_stlCtas}
      stlLbl={pd.stlLbl}
      d_lbls={pd.d_lbls}
      b_rvs={pd.b_rvs}
      d_btns={
        (pd.state) ? 
          {
            o_onClrPrs: () => {
              global.t?.setState({
                [pd.state]: -1,
              })
            }
          }
        : pd.d_btns
      }
    />
  );
};

static PckSchMdl(pd) {
  const [_so_textInput, _setTextInput] = useState(null);
  const [_s_word, _setWord] = useState(null);

  const _sch = () => {
    let _ld_iss = global.t?.state.sgcd_mdls.pckSch.ld_iss.filter( _d_is => {
//      let _b = (String(_d_is.sch ?? _d_is.pfx ?? '').indexOf(_s_word) >= 0) ? true : false;
      let _b = (String(_d_is.sch ?? _d_is.pfx ?? '').toUpperCase().indexOf(_s_word.toUpperCase()) >= 0) ? true : false;
      return _b;
    });
    global.t?.setState({
      sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next => {
        _next.pckSch.d_tmps.ld_iss = _ld_iss;
      })
    })
  };

  let _w = global.t?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2;
  _w = ( _w > ic.gn_minBdyW * 2) ? ic.gn_minBdyW * 2 : _w;

  return (
    <ce.Mdl
      key={-1}
      mdlType={'pckSch'}
    >
      <View 
        key={-1}
        style={ [{
          height: (global.t?.state.sgcd_dmns.n_h - ic.gn_mgnNrm * 2) * 0.6,
        }] }
      >
        <View 
          key={-1}
          style={ [{
            width: _w - ic.gn_mgnNrm * 2,                  
            marginLeft: 'auto',
            marginRight: 'auto',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }] }
        >
          <TextInput 
            key={-2}
            editable={true}
            multiline={false}
            placeholder={'検索文字を入力ください'}
            style={{
              width: _w - ic.gn_mgnNrm * 3 - ic.gn_iconSizeSml,
              color: ic.g_fontCcdNrm,
              fontSize: ic.gn_fontSizeNrm,
              borderWidth: ic.gn_bdrWNrw * 1.5,
              borderColor: ic.g_bdrCcd,
              outlineColor: ic.o_getCcd('d'), // only for web
              borderRadius: ic.gn_bdrRdsNrm,
              marginTop: ic.gn_mgnNrm,
              marginBottom: ic.gn_mgnNrm,
              marginLeft: ic.gn_mgnNrm,
              marginRight: 0,
              paddingTop: ic.gn_mgnNrm,
              paddingBottom: ic.gn_mgnNrm,
              paddingLeft: ic.gn_mgnNrm,
              paddingRight: ic.gn_mgnNrm,
              borderRadius: (pd.b_mln || pd.b_bdr != false) ? ic.gn_bdrRdsNrm : 0,
              minHeight: (pd.b_mln) ? ic.gn_fontSizeNrm * 8 : ic.gn_fontSizeNrm * 3,
            }}
            ref={(_o) => {
              _setTextInput(_o);
            }}
            onChangeText={(_word)=>{
              _setWord(_word)
            }}
            onLayout={() => {
              _so_textInput.focus();
            }}
            onSubmitEditing={() => {
              _sch();
            }}
          />
          <TouchableOpacity
            key={-1}
            onPress={()=>{
              _sch();
            }}
            style={{
              marginStart: ic.gn_mgnNrm,
            }}
          >
            <Icon
              key={-1}
              name='search'
              color={(ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd}
              size={ic.gn_iconSizeSml}
            />
          </TouchableOpacity>
        </View>
        {
          ce.c(ScrollView, {
            key: -2,
            scrollEnabled: true,
            showsVerticalScrollIndicator: true,
            persistentScrollbar: true,
          }, [
            ce.c(ce.List, {
              key: -1,
              b_vsb: true,                    
              state: null,
              ld_iss: global.t?.state.sgcd_mdls.pckSch.d_tmps.ld_iss,
              pfx: '',
              b_chb: false,
              b_prs: true,
              o_onPrs: (_d_items, _key) => {
//ff.l('4898: here')
                global.t?.setState({
                  sgcd_mdls: bf.p(global.t?.state.sgcd_mdls, _next => {
                    _next.pckSch.d_slcItems = _d_items;
                    _next.pckSch.b_showMdl = false;
                  }),
                });
              },
              n_pntW: _w,
            })
          ])
        }
      </View>
    </ce.Mdl>
  );
};

static Root (pd) { // RootDtl と統合予定

//console.log(document.documentElement.lang);

  let _r = [];
  if (pd.backImg) {
    _r.push(
      <ImageBackground
        key={-1}
        resizeMode='cover'
        imageStyle={{
          height: '100%', 
          width: '100%',
        }}
        style={{
          height: '100%', 
          width: '100%',
        }}
        source={{ uri: pd.backImg }}
      >
        { pd.children }
      </ImageBackground>
    );
  }
  else {
    _r.push(
      <View
        key={-1}
        style={{
//          height:ic.gn_h, 
//          width: global.t?.state.sgcd_dmns.n_w,
          height: global.t?.state.sgcd_dmns.n_h, 
          width: '100%',
          backgroundColor: ic.g_ccdWN,
        }}
      >
        { pd.children }
      </View>
    );
  };

  return (
    <View 
      key={-1}
      style={[{ // hdr/ bdy/ ftr を中央配置するために必要
        height: global.t?.state.sgcd_dmns.n_h, 
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-start', 
        alignItems: 'center',
        backgroundColor: ic.g_baseCcd,                
      }]}
    >
      {_r}
      <ce.PckSlcMdl
        key={-2}
      />
      <ce.PckMdl
        key={-3}
      />
      <ce.PckSchMdl
        key={-4}
      />
      <ce.PckDateMdl
        key={-5}
      />
      {
        ce.c(ce.CfmMdl, {
          key: -6,
        })
      }
      <ce.FileMdl
        key={-7}
      />
      <ce.MenuMdl
        key={-8}
      />
      <ce.SrpMdl
        key={-9}
      />
      <ce.Ldr
        key={-10}
        state="sgcb_showLdr"
      />
      { (ff.f(global.t?.state.s_msg)) ?
        <View
          key={-11}
          style={{
            position: 'absolute',
            zIndex: 99,
            top: 0,
            left: 0,
            backgroundColor: '#ff3333',
            width: '100%',
            paddingTop: ic.gn_mgnNrm,
            paddingBottom: ic.gn_mgnNrm,
            paddingLeft: ic.gn_mgnNrm,
            paddingRight: ic.gn_mgnNrm,
            minHeight: ic.gn_hdrH,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Text
            style={{
              color: '#ffffff',
              fontSize: ic.gn_fontSizeSml,
            }}
          >{global.t?.state.s_msg}</Text>
        </View>
      : null}
    </View>
  );
}
  static RootDtl (pd) {

    const [_sb_schVsb, _setSchVsb] = useState(false);

    return (
      <ce.OnChg
        do_onChgs={{
          sgcd_schs: () => {
          },
        }}
      >    
        <ce.Root
          key={-1}
          backImg={pd.backImg}
          onPckSchMdlEnt={pd.o_onPckSchMdlEnt}
        >
          <ce.Bdy
            key={-1}
            stlCta={{
              top: ((global.t?.state.sgcn_bdyY) ? global.t?.state.sgcn_bdyY : ic.gn_bdyY) + ((pd.d_tops?.n_h) ? pd.d_tops?.n_h : 0),
              height: global.t?.state.sgcd_dmns.n_h - (ic.gn_hdrH + ic.gn_ftrH) - ((pd.d_btms?.n_h) ? pd.d_btms?.n_h : 0) - ((pd.d_tops?.n_h) ? pd.d_tops?.n_h : 0),
//              backgroundColor: (pd.ccd) ? pd.ccd : ic.o_getCcd(global.t?.state.sgc_pageRole, 'b'),
              backgroundColor: (pd.ccd) ? pd.ccd : ic.o_getCcd('b'),
              ...pd.d_bdys?.stlCta, // 廃止予定
              ...pd.d_bdys?.d_stlCtas,
            }}
            b_ctr={pd.b_ctr}
            b_row={
              (pd.d_bdys?.b_row) ?
                pd.d_bdys?.b_row
              :(ic.g_dvcMode == 'p') ? 
                true
              : false 
            }
          >
            { /* ce._elms(pd.d_bdys?.ld_defss) */ }
            { pd.d_bdys?.l_clds }
            { pd.children }
          </ce.Bdy>
              
          <ce.Top
            key={-2}
            n_h={pd.d_tops?.n_h}
            n_pntW={pd.n_pntW}
            ld_defss={pd.d_tops?.ld_defss}
          />

          <ce.Btm
            key={-3}
            b_vsb={pd.d_btms?.b_vsb}
            n_h={pd.d_btms?.n_h}
            n_pntW={pd.n_pntW}
            ld_defss={pd.d_btms?.ld_defss}
            l_clds={pd.d_btms?.l_clds}
          />

          { /* Pnl と統合要 */}
          <ce.Hdr 
            key={-4}
            pfx={pd.d_hdrs?.pfx}            
            d_stlPfxs={pd.d_hdrs?.d_stlPfxs}
            b_logo={pd.d_hdrs?.b_logo}
            logo={pd.d_hdrs?.logo}
            b_sch={(pd.o_onSchEnt) ? true : false}
            onSchPrs={()=>{
              _setSchVsb(true);
            }}
            d_lefts={pd.d_hdrs?.d_lefts}
            b_leftVsb={(pd.d_hdrs?.d_lefts && pd.d_hdrs?.d_lefts?.b_vsb != false && pd.d_hdrs?.d_edits?.b_vsb != false) ? true : false}
            leftIconName={
              (pd.d_hdrs?.d_lefts?.iconName) ? 
                pd.d_hdrs?.d_lefts?.iconName 
              : (global.t?.state.sgc_pnlPhs == 'ini' && global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'show') ?
                'arrow-left'
              : (global.t?.state.sgc_pnlPhs == 'stg' && global.t?.state.sgc_pnlMode == 'list' && global.t?.state.sgc_pageMode == 'show') ?
                'arrow-left'
              : (global.t?.state.sgc_pnlPhs == 'stg' && global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'show') ?
                'arrow-left'
              : (global.t?.state.sgc_pageMode == 'new') ?
                'remove'
//              : (global.t?.state.sgc_pageMode == 'edit') ?
              : (global.t?.state.sgc_pageMode == 'edit' && pd.d_hdrs?.d_edits?.b_vsb != false) ?
                'remove'
              : null
            }
            leftPfx={
              (pd.d_hdrs?.d_lefts?.pfx) ? 
                pd.d_hdrs?.d_lefts?.pfx 
              : (global.t?.state.sgc_pnlPhs == 'ini' && global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'show') ?
                '戻る'
              : (global.t?.state.sgc_pnlPhs == 'stg' && global.t?.state.sgc_pnlMode == 'list' && global.t?.state.sgc_pageMode == 'show') ?
                '戻る'
              : (global.t?.state.sgc_pnlPhs == 'stg' && global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'show') ?
                '戻る'
              : (global.t?.state.sgc_pageMode == 'new') ?
                '取消'
//              : (global.t?.state.sgc_pageMode == 'edit') ?
              : (global.t?.state.sgc_pageMode == 'edit' && pd.d_hdrs?.d_edits?.b_vsb != false) ?
                '取消'
              : null
            }
            o_onLeftPrs={
              (pd.d_hdrs?.d_lefts?.o_onPrs) ?
                pd.d_hdrs?.d_lefts?.o_onPrs
              : (global.t?.state.sgc_pnlPhs == 'ini' && global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'show') ?
                () => {
                  cf.myRN_savePageStgs({
                    sgc_pnlMode: 'list',
                    sgc_pageKey: -1,
                  })
                  .then(() => {
                    global.t?.op_loadListAll(); // dtl から戻った際、list の表示に必要
                  })
                }
              : (global.t?.state.sgc_pnlPhs == 'stg' && global.t?.state.sgc_pnlMode == 'list' && global.t?.state.sgc_pageMode == 'show') ?
                () => {
                  cf.myRN_savePageStgs({
                    sgc_pnlPhs: 'ini',
                  })
                  .then(() => {
                    global.t?.op_loadListAll(); // dtl から戻った際、list の表示に必要
                  })
                }
              : (global.t?.state.sgc_pnlPhs == 'stg' && global.t?.state.sgc_pnlMode == 'list' && global.t?.state.sgc_pageMode == 'edit') ?
                () => {
                  cf.myRN_savePageStgs({
                    sgc_pageMode: 'show',
                  })
                  .then(() => {
                    global.t?.op_loadListAll(); // dtl から戻った際、list の表示に必要
                  })
                }
              : (global.t?.state.sgc_pnlPhs == 'stg' && global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'show') ?
                () => {
                  cf.myRN_savePageStgs({
                    sgc_pnlMode: 'list',
                    sgc_pageKey: -1,
                  })
                  .then(() => {
                    global.t?.op_loadListAll(); // dtl から戻った際、list の表示に必要
                  })
                }
              : (global.t?.state.sgc_pageMode == 'new') ?
                () => {
/*
                  cf.myRN_savePageStgs({
                    sgc_pageMode: 'show',
                    sgc_pnlMode: 'list',
                  })
                  .then(() => {
                    global.t?.op_loadListAll({b_clr: false}); // dtl から list へ戻った際、リストを表示するためになぜか必要
                  });
*/
                  cf.myRN_chgPageMode({
                    mode: 'cclNew',
                  });
                }
              : (global.t?.state.sgc_pageMode == 'edit') ?
                () => {
/*
                  global.t?.op_loadDtlAll()
                  .then(() => {
                    cf.myRN_savePageStgs({
                      sgc_pageMode: 'show',
                    })
                  });
*/
                  cf.myRN_chgPageMode({
                    mode: 'cclEdit',
                  });
                }
              : null
}
            d_news={pd.d_hdrs?.d_news}
            d_edits={pd.d_hdrs?.d_edits}
            d_subs={pd.d_hdrs?.d_subs}
            d_stgs={pd.d_hdrs?.d_stgs}
            d_stlCtrs={pd.d_hdrs?.d_stlCtrs}
            b_c10r_pfx={pd.d_hdrs?.b_c10r_pfx}
          />

        {(pd.lo_hdrs) ?
          ce.c(View, {
            key: -5,
            style: {
              position: 'absolute',
              zIndex: ic.gn_zIdxHdr + 2,
              top: (ic.gn_hdrY ?? 0) - (global.t?.state.sgcn_dy ?? 0),
              left: 0,
              height: ic.gn_hdrH,
              width: global.t?.state.sgcd_dmns.n_w,
              flexDirection: 'column',
              justifyContent: cf.myRN_chk_os('i') ? 'flex-end' : 'center',
              alignItems: 'center',
              backgroundColor: ic.g_ccdWN,
              borderColor: (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
              borderBottomWidth: ic.gn_bdrWNrm,
            },
          }, pd.lo_hdrs)
        : null }
            
          {(pd.lo_ftrs) ?
            ce.c(View, {
              key: -7,
              style: {
                position: 'absolute',
                zIndex: ic.gn_zIdxFtr + 1,
                top: ic.gn_ftrY,
                left: 0,
                height: ic.gn_ftrH,
                width: global.t?.state.sgcd_dmns.n_w,
                flexDirection: 'row',
                justifyContent: 'space-around',
                alignItems: 'flex-start',
                backgroundColor: ic.g_ccdWN,
                padding: ic.gn_mgnNrm,
                borderTopWidth: ic.gn_bdrWNrm,
                borderTopColor: (ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].ftrCcd : ic.gdd_ccdDefss.cmn.ftrCcd,
              },
            }, pd.lo_ftrs)
          : null }

          { pd.l_mdls }

        </ce.Root>
      </ce.OnChg>    
    );
  };

static Row (pd) { // row
  return (
    (pd.b_vsb != false) ? 
      ce.c(View, {
        key: 'Row',
        style: {
          minHeight: ic.s(2.2), // 20211215
          width: pd.n_w ?? ic.s(64),
          marginTop: pd.n_mgnTop,
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          ...pd.stlCta, // 廃止予定
          ...pd.d_stlCtas,
        },
      }, [
        pd.children
      ])
    : null
  );


};

    static Sch (pd) {
        return (
            <View 
                style={ [{
                    width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                    marginTop: ic.gn_mgnLrg,
                    marginBottom: ic.gn_mgnLrg,
                    marginLeft: 'auto',
                    marginRight: 'auto',

                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignSelf: 'center',
                    borderWidth: ic.gn_bdrWNrw * 1.5,
                    borderColor: ic.g_ccdHP,
                    borderRadius: ic.gn_bdrRdsNrm,
                }, pd.stlCta] }
            >
                <ce.Icon
                    stlCta={{
                        height: ic.gn_iconSizeSml,
                        width: ic.gn_iconSizeSml,
                        marginTop: 'auto',
                        marginBottom: 'auto',
                        marginLeft: ic.gn_mgnNrm,
                    }}
                    name='search'
                    n_size={ic.gn_iconSizeSml}
                    ccd={(ic.gdd_ccdDefss[global.t?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.t?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd}
                    margin={ic.gn_mgnNrm}
                />
                <ce.Inp
                    stlCta={[{
                        width: ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_iconSizeSml - ic.gn_mgnNrm * 5 - ic.gn_bdrWNrm * 2,
                        marginLeft: 'auto',
                        marginRight: 'auto',

                    }, pd.stlInpCta]}
                    stlInp={[{
                        borderColor: ic.g_ccdWN,
                    }, pd.stlInpInp]}
                    
                    
                    state={pd.state}
                    b_edit={true}
                    phd={pd.phd}
                    onChg={(_sch)=>{                        
                        global.t?.setState({[pd.state]:_sch});
                        if (pd.o_onChg){
                            pd.o_onChg(_sch);
                        };
                    }}
                    onLay={pd.o_onLay}
                />
            </View>
        );
    }

static Tbl = (pd={
  state: null,
  n_cellH: 0,
  n_cellW: 0,
  lbl: '',
  n_lblW: 0,
  l_cmns: [],
  o_pfx: null,
  o_sfx: null,
}) => { // schedule
  if (pd.b_vsb == false) return null;

  let _n_cmn = ff.myCM_getLen(pd.l_cmns);

  let _ctgAls = cf.myRN_getFstAls(global.t?.state[pd.state]);
  return ([
    ce.c(View, {
      key: 'Sdl.Root',
      style: [{
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }, pd.stlCta],
    }, [
        (pd.d_tops) ?
          ce.c(View, { // top
            key: -1,
            style: {
              width: '100%',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }, 
          }, [
              ce.c(View, {
                key: -1,
                style: {
                  height: pd.n_cellH,
                  width: pd.n_lblW,
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                },
              }, [
              ]),
              ce.c(ce.BtnIconPfx, 
                {
                  key: -2,
                  b_row: true,
                  iconName: 'angle-left',
                  pfx: ' ',
                  o_onPrs: pd.o_pvs, // previous
                  ccd: ic.o_getCcd('d'),
                }
              ),
              ce.c(Text, 
                {
                  key: -3,
                  style: {
                    flex: 1,
                    fontSize: ic.gn_fontSizeLrg,
                    fontWeight: 'bold',
                    color: ic.g_fontCcdNrm,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    textAlign: 'center',
                    color: ic.g_fontCcdNrm,
                  },
                },
                pd.pfx,
              ),
              ce.c(ce.BtnIconPfx, 
                {
                  key: -4,
                  b_row: true,
                  iconName: 'angle-right',
                  pfx: ' ',
                  o_onPrs: pd.o_next,
                  ccd: ic.o_getCcd('d'),
                }
              ),
          ])
        : null,

        ce.c(View, { // hdr
          key: -2,
          style: {
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
            borderWidth: 0,
            borderBottomWidth: ic.gn_bdrWNrm,
            borderColor: ic.o_getCcd('d'),
          },
        }, [

          ce.c(View, {
            key: -1,
            style: {
              height: pd.n_cellH,
              width: pd.n_lblW,
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            },
          }, [
          ]),
          ce.c(View, {
            key: -2,
            style: {
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'center',
            },
          }, [

            ce.c(View, {
              key: -1,
              style: {
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
              },
            }, [
              pd.l_cmns.map( (_cmn, _cmnIdx) => {
                return (
                  ce.c(View, {
                    key: _cmn,
                    style: {
                      height: pd.n_cellH,
                      width: pd.n_cellW,
                      backgroundColor: (_cmnIdx % 2 == 1) ? ic.o_getCcd('h') : ic.o_getCcd('p'),
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      ...(pd.od_stlCells) ? pd.od_stlCells(_cmn, _cmnIdx) : null,
                    },
                  }, [
                    ce.c(Text, {
                      key: -1,
                    }, [
                      ( pd.o_pfx ) ? pd.o_pfx(_cmn) : _cmn
                    ])
                  ])
                );
              })
            ]),

            ( pd.o_sfx ) ?
              ce.c(View, {
                key: -2,
                style: {
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                },
              }, [
                pd.l_cmns.map( (_cmn, _cmnIdx) => {
                  return (
                    ce.c(View, {
                      key: _cmn,
                      style: {
                        height: pd.n_cellH,
                        width: pd.n_cellW,
                        backgroundColor: (_cmnIdx % 2 == 1) ? ic.o_getCcd('h') : ic.o_getCcd('p'),
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        ...(pd.od_stlCells) ? pd.od_stlCells(_cmn, _cmnIdx) : null,
                      },
                    }, [
                      ce.c(Text, {
                        key: -1,
                      }, [
                        pd.o_sfx(_cmn)
                      ])
                    ])
                  );
                })
              ])
            : null,

          ])

        ]),

          ce.c(View, { // bdy
            key: -3,
            style: {
              width: '100%',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            },
          }, [
            global.t?.state[pd.state]?.[_ctgAls].map( (_d_ctgs, _ctgIdx) => {
              let _tgtAls = cf.myRN_getFstAls(_d_ctgs.dld_cldDatsss);
              return [
                ce.c(View, {
                  key: `${_ctgIdx}`,
                  style: {
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                  },
                }, [
                  (pd.b_ctg != false) ?
                    ce.c(View, {
                      key: -1,
                      style: {
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                      },
                    }, [
                      ce.c(View, {
                        key: -1,
                        style: {
                          height: pd.n_cellH,
                          width: pd.n_lblW,
                          backgroundColor: ic.o_getCcd('p'),
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'flex-start',
                          paddingLeft: ic.gn_mgnNrm,
                          ...(pd.od_stlLbls) ? pd.od_stlLbls() : null,
                         },
                      }, [
                        ce.c(Text, {
                          key: -1,
                        }, [
                          _d_ctgs.d_tbls?.pfx
                        ]),
/*
                        ce.c(Text, {
                          key: -2,
                        }, [
//                          _d_ctgs.d_tbls?.sfx
                          'テスト'
                        ])
*/
                      ]),
                      pd.l_cmns.map( (_cmn, _cmnIdx) => {
                        return (
                          (pd.o_onPrs) ?
                            ce.c(ce.Tch, {
                              key: _cmn,
                              o_onPrs: () => pd.o_onPrs(_cmn, _d_ctgs),
                            }, [
                              ce.c(View, {
                                key: _cmn,
                                style: {
                                  height: pd.n_cellH,
                                  width: pd.n_cellW,
                                  backgroundColor: ic.o_getCcd('p'),
                                  flexDirection: 'column',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  ...(pd.od_stlCells) ? pd.od_stlCells(_cmn) : null,
                                },
                              }, [
                                ce.c(Text, {
                                  key: -1,
                                }, [
                                  (_d_ctgs.d_tbls?.d_is) ? _d_ctgs.d_tbls?.d_is[_cmn] : ''
                                ])
                              ])
                            ])
                          :
                            ce.c(View, {
                              key: _cmn,
                              style: {
                                height: pd.n_cellH,
                                width: pd.n_cellW,
                                backgroundColor: ic.o_getCcd('p'),
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                ...(pd.od_stlCells) ? pd.od_stlCells(_cmn) : null,
                              },
                            }, [
                              ce.c(Text, {
                                key: -1,
                              }, [
                                (_d_ctgs.d_tbls?.d_is) ? _d_ctgs.d_tbls?.d_is[_cmn] : ''
                              ])
                            ])
                        );
                      })
                    ])
                  : null,
                  _d_ctgs.dld_cldDatsss[_tgtAls].map( (_d_tgts, _tgtIdx) => {
                    if (pd.b_tgt == false) {
                      return null;
                    }
                    else {
                      return [
                        ce.c(View, {
                          key: `${_tgtIdx}`,
                          style: {
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                          },
                        }, [
                          ce.c(View, {
                            key: -1,
                            style: {
                              height: pd.n_cellH,
                              width: pd.n_lblW,
                              backgroundColor: ic.o_getCcd('h'),
                              flexDirection: 'column',
                              justifyContent: 'center',
                              alignItems: 'center',
                              ...(pd.od_stlLbls) ? pd.od_stlLbls() : null,
                            },
                          }, [
                            ce.c(Text, {
                              key: -1,
                            }, [
                              _d_tgts.d_tbls?.pfx
                            ]),
                          ]),
                          pd.l_cmns.map( (_cmn, _cmnIdx) => {
                            return (
                              (pd.o_onPrs) ?
                                ce.c(ce.Tch, {
                                  key: _cmn,
                                  o_onPrs: pd.o_onPrs(_cmn, _d_tgts, _d_ctgs),
                                }, [
                                  ce.c(View, {
                                    key: _cmn,
                                    style: {
                                      height: pd.n_cellH,
                                      width: pd.n_cellW,
                                      backgroundColor: (_cmnIdx % 2 == 1) ? ic.o_getCcd('h') : ic.o_getCcd('p'),
                                      flexDirection: 'column',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      ...(pd.od_stlCells) ? pd.od_stlCells(_cmn) : null,
                                    },
                                  }, [
                                    ce.c(Text, {
                                      key: -1,
                                    }, [
                                      (_d_tgts.d_tbls?.d_is) ? _d_tgts.d_tbls?.d_is[_cmn] : ''
                                    ])
                                  ])
                                ])
                              :
                                ce.c(View, {
                                  key: _cmn,
                                  style: {
                                    height: pd.n_cellH,
                                    width: pd.n_cellW,
                                    backgroundColor: (_cmnIdx % 2 == 1) ? ic.o_getCcd('h') : ic.o_getCcd('p'),
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    ...(pd.od_stlCells) ? pd.od_stlCells(_cmn) : null,
                                  },
                                }, [
                                  ce.c(Text, {
                                    key: -1,
                                  }, [
                                    (_d_tgts.d_tbls?.d_is) ? _d_tgts.d_tbls?.d_is[_cmn] : ''
                                  ])
                                ])
                            );
                          })
                        ])
                      ];
                    }
                  })
                ]),
              ];
            })
          ])
    ])
  ]);
};


static Tbl2 = (pd={
  state: null,
  n_cellH: 0,
  n_cellW: 0,
  lbl: '',
  n_lblW: 0,
  l_cmns: [],
  o_pfx: null,
  o_sfx: null,
}) => { // schedule
  if (pd.b_vsb == false) return null;

//  let _n_cmn = ff.myCM_getLen(pd.l_cmns);
  let _ctgAls = cf.myRN_getFstAls(global.t?.state[pd.state]);

  let _ll_cmnss = [];
  if (pd.n_cmn > 0) {
    let _l_cmns = [];
    pd.l_cmns.map( (_cmn, _idx) => {
      if (_idx > 0 && _idx % pd.n_cmn == 0) {
        _ll_cmnss.push(_l_cmns);
        _l_cmns = [];
      }
      _l_cmns.push(_cmn);
    });
    if (ff.f(_l_cmns)) {
      _ll_cmnss.push(_l_cmns);
    }
  }
  else {
    _ll_cmnss = [pd.l_cmns];
  }

  return ([
    ce.c(View, {
      key: 'Sdl.Root',
      style: {
        width: pd.n_w ?? ic.gn_bdyW,
        marginTop: pd.n_mgnTop,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        ...pd.stlCta, // 廃止予定
        ...pd.d_stlCtas,
      },
    }, [
        (pd.d_tops) ? // 年月
          ce.c(View, { // top
            key: -1,
            style: {
              width: '100%',
              flexDirection: 'row',
              justifyContent: 'center', // 20211213
              alignItems: 'center',
            }, 
          }, [
              ce.c(View, {
                key: -1,
                style: {
                  height: ic.s(2),
                  width: ic.gn_minBdyW,
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                },
              }, [
                (pd.d_tops.o_pvs) ?
                  ce.c(ce.BtnIconPfx, 
                    {
                      key: -2,
                      b_row: true,
                      iconName: 'angle-left',
                      pfx: ' ',
                      o_onPrs: pd.d_tops.o_pvs, // previous
                      ccd: ic.o_getCcd('d'),
                    }
                  )
                : null,
                ce.c(Text, 
                  {
                    key: -3,
                    style: {
                      flex: 1,
                      fontSize: ic.gn_fontSizeLrg,
                      fontWeight: 'bold',
                      color: ic.g_fontCcdNrm,
                      marginLeft: 'auto',
                      marginRight: 'auto',
                      textAlign: 'center',
                      color: ic.g_fontCcdNrm,
                      ...pd.d_tops?.d_stls,
                    },
                  },
                  pd.d_tops.pfx,
                ),
                (pd.d_tops.o_next) ?
                  ce.c(ce.BtnIconPfx, 
                    {
                      key: -4,
                      b_row: true,
                      iconName: 'angle-right',
                      pfx: ' ',
                      o_onPrs: pd.d_tops.o_next,
                      ccd: ic.o_getCcd('d'),
                    }
                  )
                : null,
              ])
          ])
        : null,

        ce.c(DataTable, {
          key: -2,
        }, [
          (pd.b_hdr != false && pd.o_hat) ?
            ce.c(DataTable.Row, { // hdr
              key: -1.1,
              style: {
                minHeight: ic.s(2),
                borderBottomWidth: 0,
                ...(pd.od_stlHdrRows) ? pd.od_stlHdrRows() : null,
              }
            }, 
              ff.c(
                [
                  ce.c(View, {
                    key: -1,
                    style: {
                      ... (pd.od_stlLbls) ? pd.od_stlLbls() : null,
                    },
                  }, [
                  ]),
                ],
                pd.l_cmns.map( (_cmn, _cmnIdx) => {
                  return (
                    ce.c(View, {
                      key: _cmn,
                      style: {
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        ... (pd.od_stlCells) ? pd.od_stlCells(_cmn, _cmnIdx) : null,
                      },
                    }, [
                      ce.c(Text, {
                        key: -2,
                        style: {
                          color: ic.g_fontCcdNrm,
                          fontSize: ic.s(1),
                        },
                      }, 
                        ( pd.o_hat ) ? pd.o_hat(_cmn, _cmnIdx) : _cmn
                      ),
                    ])
                  );
                })
              )
            )
          : null,
          (pd.b_hdr != false) ?
            ce.c(DataTable.Row, { // hdr
              key: -1.2,
              style: {
                minHeight: ic.s(2),
                borderBottomWidth: (pd.o_sfx) ? 0 : ic.b(1.5),
                ...(pd.od_stlHdrRows) ? pd.od_stlHdrRows() : null,
              }
            }, 
              ff.c(
                [
                  ce.c(View, { // ヘッダーラベル pfx
                    key: -1,
                    style: {
                      ... (pd.od_stlLbls) ? pd.od_stlLbls() : null,
                    },
                  }, [
                  ]),
                ],
                pd.l_cmns.map( (_cmn, _cmnIdx) => {
                  return (
                    ce.c(View, {
                      key: _cmn,
                      style: {
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        ... (pd.od_stlCells) ? pd.od_stlCells(_cmn, _cmnIdx) : null,
                      },
                    }, [
                      ce.c(Text, { // ヘッダーデータ pfx
                        key: -2,
                        style: {                          
                          width: '100%',
                          textAlign: 'center', // 20220216
                          color: ic.g_fontCcdNrm,
                          fontSize: ic.s(1),
                          ... (pd.od_stlCellPfxs) ? pd.od_stlCellPfxs(_cmn, _cmnIdx) : null,
                        },
                      }, 
                        ( pd.o_pfx ) ? pd.o_pfx(_cmn, _cmnIdx) : _cmn
                      ),
                    ])
                  );
                })
              )
            )
          : null,
          (pd.b_hdr != false && pd.o_sfx) ?
            ce.c(DataTable.Row, { // hdr
              key: -1.3,
              style: {
                minHeight: ic.s(2),
                borderBottomWidth: ic.b(1.5),
                ...(pd.od_stlHdrRows) ? pd.od_stlHdrRows() : null,
              }
            }, 
              ff.c(
                [
                  ce.c(View, { // ヘッダーラベル sfx
                    key: -1,
                    style: {
                      ... (pd.od_stlLbls) ? pd.od_stlLbls() : null,
                    },
                  }, [
                  ]),
                ],
                pd.l_cmns.map( (_cmn, _cmnIdx) => {
                  return (
                    ce.c(DataTable.Cell, {
                      key: _cmn,
                      style: {
                        width: ic.s(2),
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        ... (pd.od_stlCells) ? pd.od_stlCells(_cmn, _cmnIdx) : null,
                      },
                    }, [
                      ce.c(Text, { // ヘッダーデータ sfx
                        key: -2,
                        style: {
/*
                          color: ic.g_fontCcdNrm,
                          fontSize: ic.s(1),
                          ... (pd.od_stlCellPfxs) ? pd.od_stlCellPfxs(_cmn, _cmnIdx) : null,
*/
                          width: '100%',
                          textAlign: 'center', // 20220216
                          color: ic.g_fontCcdNrm,
                          fontSize: ic.s(1),
                          ... (pd.od_stlCellPfxs) ? pd.od_stlCellPfxs(_cmn, _cmnIdx) : null,
                        },
                      }, 
                        ( pd.o_sfx ) ? pd.o_sfx(_cmn, _cmnIdx) : _cmn
                      ),
                    ])
                  );
                })
              )
            )
          : null,
          global.t?.state[pd.state]?.[_ctgAls].map( (_d_ctgs, _ctgIdx) => { // bdy
            let _tgtAls = cf.myRN_getFstAls(_d_ctgs.dld_cldDatsss);
            return [
              (pd.n_hdrRpt > 0 && _ctgIdx > 0 && _ctgIdx % pd.n_hdrRpt == 0) ?
              [
                ce.c(DataTable.Row, {
                  key: -1,
                  style: {
                    minHeight: ic.s(2),
                    borderWidth: 0,
                    borderTopWidth: ic.b(0.45),
                    borderColor: ic.g_ccdHP,
//                    ...(pd.od_stlHdrRows) ? pd.od_stlHdrRows() : null,
//                    backgroundColor: 'red',
                  }
                }, 
                  ff.c(
                    [
                      ce.c(View, { // ヘッダーラベル pfx
                        key: -1,
                        style: {
                          ... (pd.od_stlLbls) ? pd.od_stlLbls() : null,
                        },
                      }, [
                      ]),
                    ],
                    pd.l_cmns.map( (_cmn, _cmnIdx) => {
                      return (
                        ce.c(DataTable.Cell, {
                          key: _cmn,
                          style: {
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: ic.gn_fontSizeNrm,
                            ... (pd.od_stlCells) ? pd.od_stlCells(_cmn, _cmnIdx) : null,
                          },
                        }, [
                          ce.c(Text, {
                            key: -1,
                            style: {
/*
                              color: ic.g_fontCcdNrm,
                              fontSize: ic.s(1),
*/
                              width: '100%',
                              textAlign: 'center', // 20220216
                              color: ic.g_fontCcdNrm,
                              fontSize: ic.s(1),
                              ... (pd.od_stlCellPfxs) ? pd.od_stlCellPfxs(_cmn, _cmnIdx) : null,
                            },
                          }, [
                            ( pd.o_pfx ) ? pd.o_pfx(_cmn) : _cmn
                          ]),
                        ])
                      );
                    })
                  )
                ),
                ce.c(DataTable.Row, {
                  key: -1,
                  style: {
                    minHeight: ic.s(2),
                    borderWidth: 0,
                    borderBottomWidth: ic.b(0.95),
                    borderColor: ic.g_ccdHP,
//                    ...(pd.od_stlHdrRows) ? pd.od_stlHdrRows() : null,
                  }
                }, 
                  ff.c(
                    [
                      ce.c(View, { // ヘッダーラベル sfx
                        key: -1,
                        style: {
                          ... (pd.od_stlLbls) ? pd.od_stlLbls() : null,
                        },
                      }, [
                      ]),
                    ],
                    pd.l_cmns.map( (_cmn, _cmnIdx) => {
                      return (
                        ce.c(DataTable.Cell, {
                          key: _cmn,
                          style: {
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: ic.gn_fontSizeNrm,
                            ... (pd.od_stlCells) ? pd.od_stlCells(_cmn, _cmnIdx) : null,
                          },
                        }, [
                          ce.c(Text, {
                            key: -1,
                            style: {
/*
                              color: ic.g_fontCcdNrm,
                              fontSize: ic.s(1),
*/
                              width: '100%',
                              textAlign: 'center', // 20220216
                              color: ic.g_fontCcdNrm,
                              fontSize: ic.s(1),
                              ... (pd.od_stlCellPfxs) ? pd.od_stlCellPfxs(_cmn, _cmnIdx) : null,
                            },
                          }, [
//                            ( pd.o_pfx ) ? pd.o_pfx(_cmn) : _cmn
                            ( pd.o_sfx ) ? pd.o_sfx(_cmn, _cmnIdx) : _cmn
                          ]),
                        ])
                      );
                    })
                  )
                )
              ]
              : null,
              (pd.b_ctg) ?
                _ll_cmnss.map( (_l_cmns, _idx) => {
                  return (
                    ce.c(DataTable.Row, { // category
                      key: `${_idx}.${_ctgIdx}`,
                      style: {
                        borderBottomWidth: (_idx == (ff.myCM_getLen(_ll_cmnss) - 1)) ? 1 : 0,
                        ...(pd.od_stlCtgRows) ? pd.od_stlCtgRows() : null,
                      },
                    }, [
                      ce.c(View, { // label
                        key: -1,
                        style: {
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'flex-start',
                          ... (pd.od_stlLbls) ? pd.od_stlLbls() : null,
                        },
                      }, [
                        (_idx == 0) ?
                          ce.c(View, {
                            key: -1,
                          }, [
                            ce.c(Text, { // ボディラベル ctg
                              key: -1,
                              style: {
                                fontSizen: ic.s(1),
                                ... (pd.od_stlLblPfxs) ? pd.od_stlLblPfxs() : null,
                              },
                              numberOfLines: 1,
                            }, [
                              _d_ctgs.d_tbls?.pfx
                            ]),
                            ce.c(Text, {
                              key: -2,
                              style: {
                                fontSizen: ic.s(1),
                                ... (pd.od_stlLblPfxs) ? pd.od_stlLblPfxs() : null,
                              },
                            }, [
                              _d_ctgs.d_tbls?.sfx
                            ])
                          ])
                        : null,
                      ]),
                      _l_cmns.map( (_cmn, _cmnIdx) => { // cell
                        return (
                          ce.c(TouchableOpacity, {
                            key: _cmn,
                            style: {
                              flexDirection: 'column',
                              justifyContent: 'center',
                              alignItems: 'center',
                              padding: ic.s(0.5),
                              ... (pd.od_stlCells) ? pd.od_stlCells(_cmn, _cmnIdx) : null,
                            },
                            onPress:
                              (pd.o_onCtgCellPrs) ? 
                                () => {
                                  pd.o_onCtgCellPrs(_d_ctgs.d_tbls?.d_is[_cmn]);
                                }
                              : null,
                          }, [
                            ce.c(View, {
                              key: -1,
                              style: {
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                              },
                            }, [
                              ce.c(Text, {
                                key: -1,
                                style: {
                                  color: (pd.o_onCtgCellPrs) ? ic.o_getCcd('t') : ic.g_fontCcdNrm,
                                  textDecorationLine: (pd.o_onCtgCellPrs) ? 'underline' : null,
                                  fontWeight: (pd.o_onCtgCellPrs) ? 'bold' : null,
                                  fontSize: ic.s(1),
                                  ... (pd.od_stlCellPfxs) ? pd.od_stlCellPfxs(_cmn) : null,
                                },
                                numberOfLines: pd.numberOfLines ? pd.numberOfLines : 1,
                                ellipsizeMode: 'tail',
                              }, 
                                (ff.f(_d_ctgs.d_tbls?.d_is[_cmn])) ? _d_ctgs.d_tbls?.d_is[_cmn].pfx : ''
                              ),
                              ce.c(Text, {
                                key: -2,
                                style: {
                                  color: ic.g_fontCcdSml,
                                  fontSize: ic.s(0.8),
                                  ... (pd.od_stlCellSfxs) ? pd.od_stlCellSfxs(_cmn) : null,
                                },
                                numberOfLines: 1,
                                ellipsizeMode: 'tail',
                              }, 
                                (ff.f(_d_ctgs.d_tbls?.d_is[_cmn])) ? _d_ctgs.d_tbls?.d_is[_cmn].sfx : ''
                              ),
                            ])
                          ])
                        );
                      })
                    ])
                  )
                })
              : null,
              (pd.b_tgt) ?
                _d_ctgs.dld_cldDatsss[_tgtAls].map( (_d_tgts, _tgtIdx) => { // detail
                  return [
                    ce.c(DataTable.Row, {
                      key: _tgtIdx,
                      style: {
                        ...(pd.od_stlDtlRows) ? pd.od_stlDtlRows() : null,
                      },
                      onPress: null,
                    }, [
                      ce.c(View, {
                        key: -1,
                        style: {
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          ... (pd.od_stlLbls) ? pd.od_stlLbls() : null,
                        },
                        onPress: null,
                      }, [
                        ce.c(View, {
                          key: -1,
                        }, [
                          ce.c(Text, { // ボディラベル dtl
                            key: -1,
                            style: {
                              fontSizen: ic.s(1),
                              ... (pd.od_stlLblPfxs) ? pd.od_stlLblPfxs() : null,
                            },
                            numberOfLines: 1,
                          }, [
                            _d_tgts.d_tbls?.pfx
                          ]),
                        ]),
                      ]),
                      pd.l_cmns.map( (_cmn, _cmnIdx) => {
//ff.l('ce 6679: {}, {}, {}, {}'.f(_d_tgts.d_tbls?.pfx, _cmn, (_d_tgts.d_tbls?.d_is[_cmn]?.cld) ? true : false, _d_tgts.d_tbls?.d_is[_cmn]?.pfx));
                        return (
                          ce.c(View, {
                            key: _cmn,
                            style: {
                              flexDirection: 'column',
                              justifyContent: 'center',
                              alignItems: 'center',
                              ... (pd.od_stlCells) ? pd.od_stlCells(_cmn, _cmnIdx) : null,
                            },
                          }, [
                            ce.c(View, {
                              key: -1,
                              style: {
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
//                                backgroundColor: 'red', // ボディ ★★★
                              },
                            }, [
/*
                              ce.c(Text, { // ボディデータ dtl
                                key: -1,
                                style: {
                                  color: ic.g_fontCcdNrm,
                                  fontSize: ic.s(1),
                                  ... (pd.od_stlDataPfxs) ? pd.od_stlDataPfxs() : null,
                                },
                                numberOfLines: 1,
                                ellipsizeMode: 'tail',
                              }, 
                                (ff.f(_d_tgts.d_tbls?.d_is[_cmn])) ? _d_tgts.d_tbls?.d_is[_cmn].pfx : ''
                              ),
*/
                              (_d_tgts.d_tbls?.d_is[_cmn]?.cld) ?
                                _d_tgts.d_tbls?.d_is[_cmn].cld
                              : ce.c(Text, { // ボディデータ dtl
                                key: -1,
                                style: {
                                  color: ic.g_fontCcdNrm,
                                  fontSize: ic.s(1),
                                  ... (pd.od_stlDataPfxs) ? pd.od_stlDataPfxs() : null,
                                },
                                numberOfLines: 1,
                                ellipsizeMode: 'tail',
                              }, 
                                (ff.f(_d_tgts.d_tbls?.d_is[_cmn])) ? _d_tgts.d_tbls?.d_is[_cmn].pfx : ''
                              ),
                              ce.c(Text, {
                                key: -2,
                                style: {
                                  color: ic.g_fontCcdSml,
                                  fontSize: ic.s(0.8),
                                },
                                numberOfLines: 1,
                                ellipsizeMode: 'tail',
                              }, 
                                (ff.f(_d_tgts.d_tbls?.d_is[_cmn])) ? _d_tgts.d_tbls?.d_is[_cmn].sfx : ''
                              ),
                            ])
                          ])
                        )
                      })
                    ])
                  ];
                })
              : null,
            ];
          })
        ]),
    ])
  ]);
};

static Spr (pd) { // separator
  return (
    ce.c(View, {
      key: 'Spr',
      style: {
        height: pd.n_h ?? 0,
        width: pd.n_w ?? (global.t?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2 - ic.gn_scbW),
        maxWidth: global.t?.state.sgcd_dmns.n_bdyW,
//        maxWidth: ic.gn_minBdyW * 2,
        borderWidth: 0,
        borderBottomWidth: ic.gn_bdrWNrw,
        borderColor: ic.g_ccdWN,
        borderBottomColor: (pd.b_rvs) ? ic.g_ccdWN : ic.g_ccdHP,
        marginTop: pd.n_mgnTop ?? ic.gn_mgnLrg,
        marginBottom: pd.n_mgnBtm ?? ic.gn_mgnLrg,
        marginLeft: pd.n_mgnLeft ?? 'auto',
        marginRight: pd.n_mgnRht ?? 'auto',
        ...pd.stlCta, // 廃止予定
        ...pd.d_stlCtas,
      }
    })
  );
}

    static Sti (pd) { // step indicator
        return (
            <View
                style={[{
                    width: global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                    flex: 1,
                    flexDirection: 'column',
                    justifyContent: 'center', 
                    alignItems: 'stretch',
                    margin: ic.gn_mgnNrm * 2,
                }]}
            >
                <StepIndicator
                    customStyles = {{
                        stepIndicatorSize: ic.gn_fontSizeSml * 2,
                        currentStepIndicatorSize:ic.gn_fontSizeSml * 2.6,
                        separatorStrokeWidth: 2,
                        currentStepStrokeWidth: 3,
                        stepStrokeCurrentColor: ic.g_ccdON,
                        stepStrokeWidth: 3,
                        stepStrokeFinishedColor: ic.g_ccdON,
                        stepStrokeUnFinishedColor: ic.g_ccdHN,
                        separatorFinishedColor: ic.g_ccdON,
                        separatorUnFinishedColor: ic.g_ccdHN,
                        stepIndicatorFinishedColor: ic.g_ccdON,
                        stepIndicatorUnFinishedColor: ic.g_ccdWN,
                        stepIndicatorCurrentColor: ic.g_ccdWN,
                        stepIndicatorLabelFontSize: ic.gn_fontSizeSml,
                        currentStepIndicatorLabelFontSize: ic.gn_fontSizeSml,
                        stepIndicatorLabelCurrentColor: ic.g_ccdON,
                        stepIndicatorLabelFinishedColor: ic.g_ccdWN,
                        stepIndicatorLabelUnFinishedColor: ic.g_ccdHN,
                        labelColor: ic.g_ccdHN,
                        labelSize: ic.gn_fontSizeSml,
                        currentStepLabelColor: ic.g_ccdON
                    }}
                    labels={pd.l_pfx}
                    stepCount={pd.l_pfx.length}
                    currentPosition={pd.n_step}
                />
            </View>
        );
    }

    static Tck(pd){
        //
        const [_s_val, _setVal] = useState(0);
        //
        useEffect(() => {
            let _n_cnt = 0;
            let _id = setInterval(() => {
                _n_cnt += 1;
                if (_n_cnt >= pd.n_cnt) {
                    _setVal(pd.n_val);
                    clearInterval(_id);
                }
                else {
                    _setVal(bf.myCM_get_rnd(999));
                };
            }, 250);
        }, [pd.n_val]);
        //
        return (
            <>
                {(pd.b_vsb) ?
                    <View
                        style={[{
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }, pd.stlCta]}
                    >
                        <Ticker
                            textStyle={[{
                                fontSize: ic.gn_fontSizeNrm,
                                fontWeight: 'bold',
                                color: ic.g_ccdWN,
                            }, pd.stlPfx]}
                            duration={250}
                        >
                            {'{}'.f(bf.myCM_pdd(_s_val, 3))}
                        </Ticker>
                    </View>
                : null }
            </>
        );
    }


static Pnl = (pd) => {

  let _b_vsb = pd.b_vsb ?? true;

  if (!_b_vsb) return null;

  let _minH = ic.gn_fontSizeNrm * 5  + ic.gn_mgnNrm * 10 + ic.gn_bdrWNrm * 2;

/*
        <View
          key={-1}
          style={{
            minHeight: ic.s(2.6),
            width: '100%',
            flexDirection: 'row',
            justifyContent: (ic.g_dvcMode == 's') ? 'space-between' : 'flex-start',
            alignItems: (ic.g_dvcMode == 's') ? 'center' : 'center',
            flexWrap: 'wrap',
            backgroundColor: ic.o_getCcd('n'),
            paddingTop: ic.gn_mgnNrm / 2,
            paddingBottom: ic.gn_mgnNrm / 2,
          }}
        >
          {(pd.d_hdrs?.d_lefts) ?
            ce.c(View, {
              key: -1,
              style: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
              },
            }, pd.d_hdrs?.d_lefts?.l_clds)
          :null}
          {(pd.d_hdrs?.d_ctrs) ?
            <View
              key={-2}
              style={{
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                flexWrap: 'wrap',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              { pd.d_hdrs?.d_ctrs?.l_clds }
            </View>
          :null}
          {(pd.d_hdrs?.d_rhts) ?
            <View
              key={-3}
              style={{
                position: 'absolute',
                right: ic.gn_mgnNrm,
                zIndex: ic.gn_zIdxBdy + 1,
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              { pd.d_hdrs?.d_rhts?.l_clds }
            </View>
          :null}
        </View>

 */
//ff.l('6657: {}'.f(pd.d_btms?.d_btns?.name))

  const [_so_scrView, _setScrView] = useState(null);

  return (
    ce.c(View, {
      key: -1,
      style: {
        height: ic.gn_h - ic.gn_hdrH, // 20211202
        width: '100%', // 縦方向の flex
        flexDirection: 'column',
        justifyContent: 'space-between', // 20211202
        alignItems: 'flex-start',
        ...pd.stlCta, // 廃止予定
        ...pd.d_stlCtas,
      },
    }, [
      (pd.d_hdrs?.b_vsb != false && pd.mode == 'list') ?
        ce.c(View, {
          key: -1,
          style: {
            minHeight: ic.s(2.6),
            width: '100%',
            flexDirection: 'row',
            justifyContent: (ic.g_dvcMode == 's') ? 'space-between' : 'flex-start',
            alignItems: (ic.g_dvcMode == 's') ? 'center' : 'center',
            flexWrap: 'wrap',
            backgroundColor: ic.o_getCcd('n'),
            paddingTop: ic.gn_mgnNrm / 2,
            paddingBottom: ic.gn_mgnNrm / 2,
          },
        }, [
/*
            ce.c(View, {
              key: -1,
              style: {
                width: 0,
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                marginLeft: ic.s(1),
              },
            }, pd.d_hdrs?.d_lefts?.l_clds),
*/
            ce.c(View, {
              key: -1,
              style: {
                position: 'absolute',
                zIndex: ic.gn_zIdxBdy + 1,
                left: 0,
//                width: ic.s(25),
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                marginLeft: ic.s(1),
//                backgroundColor: 'red',
              },
            }, pd.d_hdrs?.d_lefts?.l_clds),
            ce.c(View, {
              key: -2,
              style: {
                width: ic.gn_bdyW,
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                flexWrap: 'wrap',
                marginLeft: 'auto',
                marginRight: 'auto',
              },
            }, pd.d_hdrs?.d_ctrs?.l_clds),
/*
            ce.c(View, {
              key: -3,
              style: {
                width: 0,
                flexDirection: 'row',
                justifyContent: 'flex-end',
                alignItems: 'center',
                marginRight: ic.s(1),
              },
            }, pd.d_hdrs?.d_rhts?.l_clds)
*/
            ce.c(View, {
              key: -3,
              style: {
                position: 'absolute',
                zIndex: ic.gn_zIdxBdy + 1,
                right: 0,
//                width: ic.s(25),
                flexDirection: 'row',
                justifyContent: 'flex-end',
                alignItems: 'center',
                marginRight: ic.s(1),
//                backgroundColor: 'red',
              },
            }, pd.d_hdrs?.d_rhts?.l_clds)
        ])
      :null,
      (pd.d_hdrs?.b_vsb != false && pd.mode == 'dtl') ?
        <View
          key={-1}
          style={{
//            minHeight: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 4 + ic.gn_bdrWNrw * 1.5 * 2,
            minHeight: ic.s(2.6),
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            backgroundColor: ic.o_getCcd('n'),
            paddingTop: ic.gn_mgnNrm / 2,
            paddingBottom: ic.gn_mgnNrm / 2,
          }}
        >
            {(pd.d_hdrs?.d_lefts) ?
              <View
                key={-1}
                style={{
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  marginLeft: ic.gn_mgnNrm,
                  marginRight: 'auto',
                }}
              >
                { pd.d_hdrs?.d_lefts?.l_clds }
              </View>
            :null}
            {(pd.d_hdrs?.d_ctrs) ?
              <View
                key={-2}
                style={{
                  width: '100%',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                { pd.d_hdrs?.d_ctrs?.l_clds }
              </View>
            :null}
            {(pd.d_hdrs?.d_rhts) ?
              <View
                key={-3}
                style={{
                  marginLeft: 'auto',
                  marginRight: ic.gn_mgnNrm,
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                { pd.d_hdrs?.d_rhts?.l_clds }
              </View>
            :null}
            {(pd.d_hdrs?.d_htys && pd.d_hdrs?.d_htys.b_vsb != false) ? // history
              ce.c(View, {
                key: -4,
                style: {
                  marginLeft: 'auto',
                  marginRight: ic.gn_mgnNrm,
                }
              }, [
                ce.c(ce.Pck, {
                  key: -1,
                  pfx: '履歴',
                  state: 'sgc_hty_key',
                  b_vsb: bf.i(global.t?.state.sgc_pageMode, ['show', 'hty']) ? true : false,
                  b_edit: true,
                  b_row: true,
                  b_rvs: true,
                  n_col: 13,
                  ld_iss: pd.d_hdrs?.d_htys.ld_iss,
                  o_onChg: _d_is => {
                    if (_d_is) { // 履歴
                      cf.s();
                      cf.myRN_savePageStgs({
                        sgc_pageMode: 'hty',
                      })
                      .then(() => {
                        pd.d_hdrs?.d_htys.op_loadDtl({
                          elm: pd.d_hdrs?.d_htys.elm,
                          key: global.t?.state.sgc_hty_key,
                        })
                        .then(() => {
                          cf.h();
                        });
                      });
                    }
                    else { // 通常
                      cf.s();
                      cf.myRN_savePageStgs({
                        sgc_pageMode: 'show',
                      })
                      .then(() => {
                        pd.d_hdrs?.d_htys.op_loadDtl({
                          elm: pd.d_hdrs?.d_htys.elm,
                          fst: global.t?.state.sgc_pageFst,
                        })
                        .then(() => {
                          cf.h();
                        })
                      });
                    };
                  },
                })
              ])
            : null}
        </View>
      :null,
      (pd.d_tops) ?
        ce.c(View, {
          key: -2,
          style: {
            width: '100%',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            alignItems: 'center',
          },
        }, pd.d_tops?.l_clds )
      : null,
      (pd.d_bdys) ?
        ce.c(ScrollView, { // 20211202
          key: -3,
          style: {
            flex: 1,
            width: '100%', // 高さ方向のみ flex
          },
          ref: _o => {
            _setScrView(_o);
          },
          onScroll: async (_e)=>{
            if (( _e.nativeEvent.contentSize.height - _e.nativeEvent.contentOffset.y ) <= _e.nativeEvent.layoutMeasurement.height * 2.5 ){
              if (pd.d_srls?.state) {
                cf.s();
                cf.myRN_setStt({
                  [pd.d_srls?.state]: _next => {
                    let _als = cf.myRN_getFstAls(_next);
                    let _n_cnt = 0;
                    _next[_als].map( _d_dats => {
                      if ( _n_cnt <= 50 && _d_dats.b_show != true) {
                        _d_dats.b_show = true;
                        _n_cnt += 1;
                      }
                    });
                  },
                })
                .then(() => {
                  cf.h();
                });
              }
            };
          },
          scrollEventThrottle: 0,
        }, [
          (pd.d_bdys.d_msgBfrs) ?
            ce.c(ce.Msg, {
              key: -1,
              pfx: pd.d_bdys.d_msgBfrs.pfx,
              stlCta: {
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: ic.gn_bdyW - ic.m(2, true), // 20211202
                maxWidth: ic.gn_minBdyW * 2, // 20211202
                marginTop: pd.d_bdys.d_msgBfrs.n_mgnTop ?? ic.s(0.5),
                marginBottom: pd.d_bdys.d_msgBfrs.n_mgnBtm ?? ic.s(1.5), // 20211202
                ...pd.d_bdys.d_msgBfrs.d_stlCtas,
              },
              stlPfx: {
                textAlign: 'left',
                ...pd.d_bdys.d_msgBfrs.stlPfx, // 廃止予定
                ...pd.d_bdys.d_msgBfrs.d_stlPfxs,
              },
            })
          : null,
          ce.c(ce.Box, {
            key: -2,
            d_stlCtas: {
              height: '100%',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'center', // 左寄せとする場合 flex-start で上書き
              marginLeft: 'auto',
              marginRight: 'auto',
              ...pd.d_bdys?.d_stlCtas,
            },
          }, pd.d_bdys?.l_clds),
          (pd.d_bdys.d_msgAtrs) ?
            ce.c(ce.Msg, {
              key: -3,
              pfx: pd.d_bdys.d_msgAtrs.pfx,
              stlCta: {
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: ic.gn_bdyW - ic.m(2, true),
                marginTop: ic.s(0.5),
                marginBottom: ic.s(1),
              },
              stlPfx: {
                textAlign: 'left',
                ...pd.d_bdys.d_msgAtrs.stlPfx,
              },
            })
          : null,
        ])
      : null,
      (pd.d_btms) ?
        ce.c(View, {
          key: -4,
          style: [
            {
              width: '100%',
              flexDirection: 'column',
              justifyContent: 'center', // 20211202
              alignItems: 'center',
              backgroundColor: 'transparent',
            },
            pd.d_btms.d_stlCtas, // 20211202
            pd.d_btms.d_ctrStls, // 20211202
          ],
        }, [
          (pd.d_btms.d_msgBfrs?.pfx) ?
            ce.c(ce.Msg, {
              key: -1,
              pfx: pd.d_btms.d_msgBfrs.pfx,
              stlCta: {
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: ic.gn_bdyW - ic.m(2, true),
                marginTop: ic.s(0.5), // 20211202
                marginBottom: ic.s(0.5), // 20211202
              },
              stlPfx: {
                textAlign: 'left',
                ...pd.d_btms.d_msgBfrs.stlPfx,
              },
            })
          : null,
          (pd.d_btms.l_clds) ?
            pd.d_btms?.l_clds
          : (global.t?.state.sgc_pnlMode == 'list') ?
              ce.c(ce.Box, {
                key: -2,
                stlCta: {
                  minHeight: (ic.g_dvcMode == 's') ? ic.s(2) : ic.s(2 * 2), // 20211202
                  width: ic.gn_minBdyW,
                  flexDirection: 'row',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                  marginTop: ic.s(0.5), // 20211202
                  marginBottom: ic.s(0.5), // 20211202
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }
              }, [
                ce.c(ce.Btn, {
                  key: -1,
                  pfx: pd.d_btms?.d_news?.pfx ?? '新規',
                  b_rvs: pd.d_btms?.d_news?.b_rvs ?? false,
                  stlBtn: {
                    width: ic.s(8),
                    ...pd.d_btms?.d_news?.d_stlBtns,
                  },
                  o_onPrs: () => {
                    cf.myRN_chgPageMode({
                      ...pd.d_btms.d_news,
                      mode: 'sttNew',
                      b_clr: true, // 現行要素の初期化に必要
                    })
                  },
                }),
              ])
          : (global.t?.state.sgc_pnlMode == 'dtl') ?
            ce.c(ce.Box, {
              key: -3,
              stlCta: {
                minHeight: (ic.g_dvcMode == 's') ? ic.s(2) : ic.s(2 * 2), // 20211202
                flexDirection: 'row',
                justifyContent: 'space-around',
                alignItems: 'center',
                width: ic.gn_bdyW, // 20211220
                maxWidth: ic.gn_minBdyW * 2, // 20211220
                marginTop: ic.s(0.5), // 20211202
                marginBottom: ic.s(0.5), // 20211202
                marginLeft: 'auto',
                marginRight: 'auto',
                backgroundColor: 'rgba(255,255,255,0.2)',
              }
            }, [
              global.t?.state.sgc_pageMode == 'new' ?
                ce.c(ce.Btn, {
                  key: -1,
                  pfx: '登録を止める',
                  b_vsb: global.t?.state.sgc_pageMode == 'new' ? true : false,
                  stlBtn: {
                    width: ic.s(8),
                    backgroundColor: ic.g_ccdHN,
                    borderColor: ic.g_ccdHN,
                  },
                  o_onPrs: () => {
                    cf.myRN_chgPageMode({
                      mode: 'cclNew',
                    });
                  },
                })
              : null,
              global.t?.state.sgc_pageMode == 'new' ?
                ce.c(ce.Btn, {
                  key: -2,
//                  pfx: `${pd.d_btms.d_btns?.name ?? 'この情報'}を登録`,
                  pfx: `${pd.d_btms.d_btns?.name ?? 'この内容'}を登録`,
                  b_vsb: global.t?.state.sgc_pageMode == 'new' ? true : false,
                  stlBtn: {
                    width: pd.d_btms.n_btnW ?? ic.s(8),
                    ...pd.d_btms.d_btns?.d_stlBtns,
                  },
                  o_onPrs: () => {
                    if (global.t?.$opb_chk) {
                      global.t?.$opb_chk()
                      .then( _b_res => {
                        if (_b_res) {
                          cf.myRN_chgPageMode({
                            mode: 'endNew',
                          });
                        };
                      })
                    }
                    else {
                      cf.myRN_chgPageMode({
                        mode: 'endNew',
                      });
                    }
                  },
                })
              : null,
              (global.t?.state.sgc_pageMode == 'show' && pd.d_btms.b_rtn != false) ?
                ce.c(ce.Btn, {
                  key: -3,
                  pfx: '前の画面に戻る',
                  b_vsb: (global.t?.state.sgc_pageMode == 'show' && pd.d_btms.b_rtn != false) ? true : false,
                  stlBtn: {
                    width: ic.s(8),
                    backgroundColor: ic.g_ccdHN,
                    borderColor: ic.g_ccdHN,
                  },
                  o_onPrs: () => {
                    cf.myRN_chgPnlMode({
                      mode: 'list',
                    });
                  },
                })
              : null,
              global.t?.state.sgc_pageMode == 'show' ?
                ce.c(ce.Btn, {
                  key: -4,
//                  pfx: `${pd.d_btms.d_btns?.name ?? pd.d_btms.name ?? 'この情報'}を変更`,
                  pfx: `${pd.d_btms.d_btns?.name ?? pd.d_btms.name ?? 'この情報'}の変更画面へ`,
                  b_vsb: global.t?.state.sgc_pageMode == 'show' ? true : false,
                  stlBtn: {
                    width: pd.d_btms.n_btnW ?? ic.s(12),
                    ...pd.d_btms.d_btns?.d_stlBtns,
                  },
                  o_onPrs: () => {
                    cf.myRN_chgPageMode({
                      mode: 'sttEdit',
                    });
                  },
                })
              : null,
              (global.t?.state.sgc_pageMode == 'show' && pd.d_btms.b_dlt == true) ?
                ce.c(ce.Btn, {
                  key: -5,
                  pfx: `${pd.d_btms.d_btns?.name ?? pd.d_btms.name ?? 'この情報'}を削除`,
                  b_vsb: global.t?.state.sgc_pageMode == 'show' ? true : false,
                  stlBtn: {
                    width: pd.d_btms.n_btnW ?? ic.s(8),
                    backgroundColor: ic.g_ccdHN,
                    borderColor: ic.g_ccdHN,
                    ...pd.d_btms.d_btns?.d_stlBtns,
                  },
                  o_onPrs: () => {
                    cf.myRN_chgPageMode({
                      mode: 'dlt',
                    });
                  },
                })
              : null,
              global.t?.state.sgc_pageMode == 'edit' ?
                ce.c(ce.Btn, {
                  key: -6,
                  pfx: '変更を止める',
                  b_vsb: global.t?.state.sgc_pageMode == 'edit' ? true : false,
                  stlBtn: {
                    width: ic.s(8),
                    backgroundColor: ic.g_ccdHN,
                    borderColor: ic.g_ccdHN,
                  },
                  o_onPrs: () => {
                    cf.myRN_chgPageMode({
                      mode: 'cclEdit',
                    });
                  },
                })
              : null,
              global.t?.state.sgc_pageMode == 'edit' ?
                ce.c(ce.Btn, {
                  key: -7,
//                  pfx: `${pd.d_btms.d_btns?.name ?? pd.d_btms.name ?? 'この情報'}を登録`,
                  pfx: `${pd.d_btms.d_btns?.name ?? pd.d_btms.name ?? 'この情報'}を変更`,
                  b_vsb: global.t?.state.sgc_pageMode == 'edit' ? true : false,
                  stlBtn: {
                    width: pd.d_btms.n_btnW ?? ic.s(8),
                    ...pd.d_btms.d_btns?.d_stlBtns,
                  },
                  o_onPrs: () => {
                    if (global.t?.$opb_chk) {
                      global.t?.$opb_chk()
                      .then( _b_res => {
                        if (_b_res) {
                          cf.myRN_chgPageMode({
                            mode: 'endEdit',
                          });
                        };
                      })
                    }
                    else {
                      cf.myRN_chgPageMode({
                        mode: 'endEdit',
                      });
                    }
                  },
                })
              : null,
            ])
          : null,
          (pd.d_btms?.d_msgAtrs?.pfx) ? // 20211202
            ce.c(ce.Msg, {
              key: -4,
              pfx: pd.d_btms.d_msgAtrs.pfx,
              stlCta: {
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: ic.gn_bdyW - ic.m(2, true),
                marginTop: ic.s(1),
                marginBottom: ic.s(1),
              },
              stlPfx: {
                textAlign: 'left',
                ...pd.d_btms.d_msgAtrs.stlPfx,
              },
            })
          : null,
        ])
      : null,
    ])
  );
};

  static Top (pd) {
    return (
      <View
        style={{
          position: 'absolute',
          zIndex: ic.gn_zIdxBdy,
          top: ic.gn_hdrH,
          left: (global.t?.state.sgcd_dmns.n_w - ((pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW)) / 2,
          height: (pd.n_h) ? pd.n_h : 0,
          width: (pd.n_pntW) ? pd.n_pntW : global.t?.state.sgcd_dmns.n_bdyW,
          justifyContent: 'center',
        }}
      >                
      </View>
    );
  };

    static Tree(pd){
        //
        let _r1 = [];
        let _r2 = [];
        //
        let _ld_iss = global.t?.state[pd.state];
        //
        let _topH = ic.gn_fontSizeNrm + ic.gn_mgnLrg * 2;
        //
        let _w = (global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 27;
        let _h = (global.t?.state.sgcd_dmns.n_bdyH - _topH - ic.gn_mgnNrm * 2) / 3 - ic.gn_bdrWNrw * 2;
        //
        function _fnc01(pn_x, pn_y, pn_w, pn_h, p_pfx, p_key) {
            return (
                <View
                    style={{
                        height: pn_w,
                        width: pn_h,
                        transform: [{ rotate: '90deg'}],
                        position: 'absolute',
                        zIndex: 10,
                        top: pn_y - pn_w/2,
                        left: pn_x - pn_h/2,
                        backgroundColor: (p_key != 0) ? ic.g_ccdWN : '#eeeeee',
                        borderColor: (p_key != 0) ? ic.g_ccdHN : ic.g_ccdWN,                        
                        borderWidth: ic.gn_bdrWNrw,
                        borderRadius: ic.gn_bdrRdsNrm,
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <TouchableOpacity
                        onPress={()=>{
                            if (pd.o_onPrs && p_key != 0) {
                                pd.o_onPrs(p_key);
                            };
                        }}
                    >
                        <Text
                            style={{
                                lineHeight: pn_w, 
                                height: pn_w,
                                width: pn_h,
                                color: ic.g_fontCcdNrm,
                                fontSize: (ic.gn_fontSizeNrm > pn_w * 0.8) ? pn_w * 0.8 : ic.gn_fontSizeNrm,
                                marginStart: 0, 
                                marginEnd: 0, 
                                marginTop: 0, 
                                marginBottom: 0, 
                                paddingStart: ic.gn_mgnNrm, 
                                paddingEnd: 0, 
                                paddingTop: 0, 
                                paddingBottom: 0, 
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            {p_pfx}
                        </Text>
                    </TouchableOpacity>
                </View>
            );
        };
        //
        // １階層目
        let _cnt1 = 0;
        bf.myCM_for_each(_ld_iss, (_d_items1)=>{
            if (_d_items1.pntKey == '') {
                _cnt1 += 1;
                let _x = (global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 2 / 1 + (global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 1 * (_cnt1 -1) - _w / 2 + ic.gn_mgnNrm;
                let _y = ic.gn_hdrH + _h * (1 - 1) + ic.gn_mgnNrm + _topH;
                _r1.push(
                    <>
                        <ce.Row
                            stlCta={{
                                width: global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            { (pd.b_leftPrs) ?
                                <ce.Btn
                                    
                                    stlCta={{
                                        width: ic.gn_btnWSml,
                                    }}
                                    stlBtn={{
                                        width: ic.gn_btnWSml,
                                    }}
                                    pfx='＜'
                                   o_onPrs={pd.o_onLeftPrs}
                                />
                            :
                                <View
                                    style={{
                                        width: ic.gn_btnWSml,
                                    }}
                                >
                                </View>
                            }
                            <View
                                style={{
                                    height: _topH,
                                    width: global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2 - ic.gn_btnWSml * 2,
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <Text
                                >
                                    {_d_items1.pfx}
                                </Text>
                            </View>
                            { (pd.b_RhtPrs) ?
                            <ce.Btn
                                
                                stlCta={{
                                    width: ic.gn_btnWSml,
                                }}
                                stlBtn={{
                                    width: ic.gn_btnWSml,
                                }}
                                pfx='＞'
                                o_onPrs={pd.o_onRhtPrs}
                            />
                            :
                                <View
                                    style={{
                                        width: ic.gn_btnWSml,
                                    }}
                                >
                                </View>
                            }
                        </ce.Row>
                    </>
                );
                //
                // ダミー
                //
                // ２階層目
                for (let _cnt2 of [1,2,3]) {
                    let _x = (global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 2 / 3 + (global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 3 * (_cnt2 -1) - _w / 2 + ic.gn_mgnNrm ;
                    let _y = ic.gn_hdrH + _topH + _h * (2 - 2) + ic.gn_mgnNrm;
                    _r2.push(_fnc01(_x, _y, _w, _h, '', 0));
                    //
                    // ３階層目
                    for (let _cnt3 of [1,2,3]) {
                        let _x = (global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 2 / 9 + (global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 9 * (_cnt3  + (_cnt2 - 1) * 3 - 1) - _w / 2 + ic.gn_mgnNrm ;
                        let _y = ic.gn_hdrH + _h * (3 - 2) + ic.gn_mgnNrm + _topH;
                        _r2.push(_fnc01(_x, _y, _w, _h, '', 0));
                        //
                        // ４階層目
                        for (let _cnt4 of [1,2,3]) {
                            let _x = (global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 2 / 27 + (global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 27 * (_cnt4 + (_cnt3 - 1) * 3  + (_cnt2 - 1) * 9 - 1) - _w / 2 + ic.gn_mgnNrm ;
                            let _y = ic.gn_hdrH + _h * (4 - 2) + ic.gn_mgnNrm + _topH;
                            _r2.push(_fnc01(_x, _y, _w, _h, '', 0));
                        };
                    };
                };
                //
                // 実データ
                //
                // ２階層目
                let _cnt2 = 0;
                bf.myCM_for_each(_ld_iss, (_d_items2)=>{
                    if (_d_items2.pntKey == _d_items1.key) {
                        _cnt2 += 1;
                        let _x = (global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 2 / 3 + (global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 3 * (_cnt2 -1) - _w / 2 + ic.gn_mgnNrm ;
                        let _y = ic.gn_hdrH + _topH + _h * (2 - 2) + ic.gn_mgnNrm;
                        _r2.push(_fnc01(_x, _y, _w, _h, _d_items2.pfx, _d_items2.key));
                        //
                        // ３階層目
                        let _cnt3 = 0;
                        bf.myCM_for_each(_ld_iss, async (_d_items3)=>{
                            if (_d_items3.pntKey == _d_items2.key) {
                                _cnt3 += 1;
                                let _x = (global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 2 / 9 + (global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 9 * (_cnt3  + (_cnt2 - 1) * 3 - 1) - _w / 2 + ic.gn_mgnNrm ;
                                let _y = ic.gn_hdrH + _h * (3 - 2) + ic.gn_mgnNrm + _topH;
                                _r2.push(_fnc01(_x, _y, _w, _h, _d_items3.pfx, _d_items3.key));
                                //
                                // ４階層目
                                let _cnt4 = 0;
                                await bf.myCM_for_each(_ld_iss, (_d_items4)=>{
                                    if (_d_items4.pntKey == _d_items3.key) {
                                        _cnt4 += 1;
                                        let _x = (global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 2 / 27 + (global.t?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 27 * (_cnt4 + (_cnt3 - 1) * 3  + (_cnt2 - 1) * 9 - 1) - _w / 2 + ic.gn_mgnNrm ;
                                        let _y = ic.gn_hdrH + _h * (4 - 2) + ic.gn_mgnNrm + _topH;
                                        _r2.push(_fnc01(_x, _y, _w, _h, _d_items4.pfx, _d_items4.key));
                                    };
                                });
                            };
                        });
                    };
                });
            };
        });
        //
        return (
            <>
                <View>
                    {_r1}
                </View>
                <View
                    style={{
                    }}
                >
                    {_r2}
                </View>
            </>
        );
    }

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
